import downloadCenterBetaOne from '../../assets/images/download-center-beta-one.png';
import downloadCenterBetaTwo from '../../assets/images/download-center-beta-two.png';
import userActivityLogOne from '../../assets/images/user-activity-log-one.png';
import tenantMgmtOne from '@/assets/images/tenantMgmtOne.png';
import tenantMgmtTwo from '@/assets/images/tenantMgmtTwo.png';
import tenantMgmtThree from '@/assets/images/tenantMgmtThree.png';
import tenantMgmtFour from '@/assets/images/tenantMgmtFour.png';
import tenantMgmtFive from '@/assets/images/tenantMgmtFive.png';
import tenantMgmtSix from '@/assets/images/tenantMgmtSix.png';
import tenantMgmtSeven from '@/assets/images/tenantMgmtSeven.png';
import usageReportOne from '@/assets/images/usageReportOne.png';
import tenantMgmtMasterMsspOne from '@/assets/images/tenantMgmtMasterMsspOne.png';
import tenantMgmtMasterMsspTwo from '@/assets/images/tenantMgmtMasterMsspTwo.png';
import tenantMgmtMasterMsspThree from '@/assets/images/tenantMgmtMasterMsspThree.png';
import tenantMgmtMasterMsspFour from '@/assets/images/tenantMgmtMasterMsspFour.png';
import tenantMgmtMasterMsspFive from '@/assets/images/tenantMgmtMasterMsspFive.png';
import tenantMgmtMasterMsspSix from '@/assets/images/tenantMgmtMasterMsspSix.png';
import tenantMgmtMasterMsspSeven from '@/assets/images/tenantMgmtMasterMsspSeven.png';
import tenantMgmtMasterMsspEight from '@/assets/images/tenantMgmtMasterMsspEight.png';
import tenantMgmtMasterMsspNine from '@/assets/images/tenantMgmtMasterMsspNine.png';
import renewalManagerOne from '@/assets/images/renewalManagerOne.png';
import renewalManagerTwo from '@/assets/images/renewalManagerTwo.png';
import renewalManagerThree from '@/assets/images/renewalManagerThree.png';
import renewalManagerFour from '@/assets/images/renewalManagerFour.png';
import renewalManagerFive from '@/assets/images/renewalManagerFive.png';
import renewalManagerSix from '@/assets/images/renewalManagerSix.png';
import renewalManagerSeven from '@/assets/images/renewalManagerSeven.png';
import notificationCenterOne from '@/assets/images/notificationCenterOne.png';
import notificationCenterTwo from '@/assets/images/notificationCenterTwo.png';
import notificationCenterThree from '@/assets/images/notificationCenterThree.png';
import downloadSignatureOne from '@/assets/images/downloadSignatureOne.png';
import downloadSignatureTwo from '@/assets/images/downloadSignatureTwo.png';
import downloadSignatureThree from '@/assets/images/downloadSignatureThree.png';
import nfrServicesOne from '@/assets/images/nfrServicesOne.png';
import nfrServicesTwo from '@/assets/images/nfrServicesTwo.png';
import psaOne from '@/assets/images/psaOne.png';
import psaTwo from '@/assets/images/psaTwo.png';
import psaThree from '@/assets/images/psaThree.png';
import accessMgmtOne from '@/assets/images/accessMgmtOne.png';
import accessMgmtTwo from '@/assets/images/accessMgmtTwo.png';
import accessMgmtThree from '@/assets/images/accessMgmtThree.png';
import accessMgmtFour from '@/assets/images/accessMgmtFour.png';
import externalIDPOne from '@/assets/images/externalIDPOne.png';
import externalIDPTwo from '@/assets/images/externalIDPTwo.png';
import externalIDPThree from '@/assets/images/externalIDPThree.png';

export const dashboardCardview = `
<div>
  <h2>My Workspace</h2>
  <p>
    <strong>My Workspace</strong>&nbsp;is the homepage of MySonicWall Workspace. In My Workspace, you can: create tenants,
    view tenants as a list or as cards, view starred tenants, register products, manage user groups, verify licensing status of the products,
    access support cases, view available downloads, and so on.
  </p>
  <p>
  If you are a partner who provides services to other end customers,
   the term tenant refers to a product group that you have set up for that customer.
    If you are an end customer who has procured your services directly,
   the term tenant refers to any product group within your company that you might have set up for customization.
  </p>
  <p>Each tenant is represented as a card. A tenant card displays the following information:</p>
  <ul>
    <li>Tenant&rsquo;s name</li>
    <li>Number of products of each product type associated with the tenant, for example: three firewalls, two access points, and so on</li>
    <li>License status of the products associated with the tenant</li>
    <li>Software or firmware downloads available for the products registered to your account</li>
    <li>Options to customize the tenant card, such as: rename, delete, or add to the Starred Tenants list</li>
  </ul>
  <p>
    Click
    <strong>View details</strong> in the tenant card to see all the products associated
     with the tenant and details such as product name, product type, and serial number.
  </p>
  <p>You can perform the following tasks:</p>
  <ul>
    <li>
     <p> <strong>Adding a tenant to the Starred Tenants list</strong></p>
     <p>Adding a tenant to the Starred Tenants list helps you to address the tenants at ease when required.
     To add a tenant to the Starred Tenants list, enable the
     <span style="background-color: black; display: inline-block;padding: 2px" >
    <img src='https://www.mysonicwall.com/images/icon_unstarred-customer.svg' width='13px' height: '13px'/>
    </span> icon that is next to the tenant&rsquo;s name.</p>
    <p>
     To see the list of starred tenants, click
     <strong>Starred Tenants</strong>.
    </p>
  </li>
  <li>
     <p> <strong>Removing a tenant from the Starred Tenants list</strong></p>
    <p>To remove a tenant from the Starred Tenants list, disable the
   <span style="background-color: black; display: inline-block;padding: 2px">
  <img src='https://www.mysonicwall.com/images/icon_starred-customer.svg' width='13px' height: '13px'/>
  </span> icon that is next to the tenant&rsquo;s name.</p>
  </li>
  <li>
  <p><strong>Searching a tenant:</strong></p>
   <p>You can search for a tenant by its
  name in <strong>Search Tenants</strong> box, and then select the tenant from the suggestions.   </p>
  </li>
    <li>
     <p> <strong>Renaming a tenant</strong></p>
    <p>
    To rename a tenant, click
    <strong>settings</strong> <img src='https://www.mysonicwall.com/images/more-options.png' width='10px'/>
    icon at the upper-right corner in the tenant card, click <strong>Rename</strong>, rename the tenant, and then click checkmark next to it.
    </p>
  </li>
    <li>
    <p>  <strong>Deleting a tenant</strong></p>
  <p>
    To delete a tenant, click
    <strong>settings</strong> <img src='https://www.mysonicwall.com/images/more-options.png' width='10px' />
    icon at the upper-right corner in the tenant card, click <strong>Delete</strong>, and then click Yes to confirm deletion.
  </p>
  <p>You cannot delete the default tenant.</p>
  </li>
    <li>
   <p> <strong>Creating a tenant</strong></p>
  <p>
    To create a tenant, click
    <strong>Create Tenant</strong> at the upper-right corner of the page and do the workflow actions.
  </p>
  <p>
    You can also search for tenants using the
    <strong>Search Tenants</strong> box.
  </p>
  </li>
    <li>
     <p> <strong>Viewing tenants as a list or as cards</strong></p>
  <p>
    To toggle between the views of listing the tenants as a list or as cards, click
    <strong>View all as list/ View all as card</strong>.
  </p>
  </li>
    <li>
    <p>  <strong>Registering a product</strong></p>
  <p>
    To register a product, click
    <strong>Register products</strong> window and do the workflow actions.
  </p>
  </li>
    <li>
     <p> <strong>Managing user groups</strong></p>
  <p>
    To manage user groups, click
    <strong>Manage</strong> in the
    <strong>User Management</strong> window to begin.
  </p>
  </li>
    <li>
     <p> <strong>Managing products</strong></p>
  <p>
    The
    <strong>Tenant products</strong> window displays the number of products and the number of tenants in your MySonicWall Workspace account.
     To manage products, click
    <strong>Manage</strong> in the
    <strong>Tenant Products</strong> window.
  </p>
  </li>
    <li>
      <p><strong>Viewing license status</strong></p>
  <p>
    The
    <strong>Licensing Status</strong> window displays the number of expired licenses and number of licenses that expires soon.
     To know the licensing status of the registered products, click
    <strong>View all</strong> in the
    <strong>Licensing status</strong>window.
  </p>
  </li>
    <li>
      <p><strong>Toggling between the Classic mode and the Contemporary Mode</strong></p>
  <p>
    The default view is in the Contemporary mode. Click
    <strong>Classic mode</strong> or
    <strong>Contemporary Mode</strong> at the upper-right corner of the page to toggle between the classic and the contemporary modes.&nbsp;
  </p>
  </li>
  </ul>
</div>`;

export const dashboardListview = `
<div>
  <h2>My Workspace</h2>
  <p>All the tenants of your MySonicWall Workspace account are displayed as a list.</p>
  <p>
  If you are a partner who provides services to other end customers,
   the term tenant refers to a product group that you have set up for that customer.
    If you are an end customer who has procured your services directly,
   the term tenant refers to any product group within your company that you might have set up for customization.
  </p>
  <p>A row in the table corresponding to a tenant displays the following information about the tenant:</p>
  <ul>
    <li>Tenant&rsquo;s name</li>
    <li>Number of products of each product type associated with the Tenant, for example: three firewalls, two access points, and so on</li>
    <li>License status of the products associated with the tenant</li>
    <li>Software or firmware downloads available for the products registered to your account</li>
    <li>Options to customize the tenant card, such as: rename, delete, or add to the Starred Tenants list</li>
  </ul>
  <p>
    Click
    <strong>View details</strong> in the
    <strong>Action</strong> column to see all the products associated with a tenant and details like product name, product type, and serial number.
  </p>
  <p>You can perform the following tasks:</p>
  <ul>
    <li>
    <p>  <strong>Adding a tenant to the Starred Tenants list</strong></p>
  <p>Adding a tenant to the Starred Tenants list helps you to address the tenants at ease when required.
  To add a tenant to the Starred Tenants list, enable the
   <span style="background-color: black; display: inline-block;padding: 2px" >
  <img src='https://www.mysonicwall.com/images/icon_unstarred-customer.svg' width='13px' height: '13px'/>
  </span> icon that is next to the tenant&rsquo;s name.</p>
  <p>
     To see the list of starred tenants, click
    <strong>Starred Tenants</strong>.
  </p>
  </li>
    <li>
      <p><strong>Removing a tenant from the Starred Tenants list</strong></p>
  <p>To remove a tenant from the starred tenants list, disable the
  <span style="background-color: black; display: inline-block;padding: 2px">
  <img src='https://www.mysonicwall.com/images/icon_starred-customer.svg' width='13px' height: '13px'/>
  </span> icon that is next to the tenant&rsquo;s name.</p>
  </li>
  <li>
     <p><strong>Searching a tenant:</strong></p>
     <p>You can search for a tenant by its name in Search Tenants box,
     and then select the tenant from the suggestions.</p>
  </li>
    <li>
      <p><strong>Renaming a tenant</strong></p>
  <p>
    To rename a tenant, hover over the tenant&rsquo;s name and click
    <strong>edit</strong> icon next to the tenant name, update the name, and then click the checkmark.
  </p>
  </li>
    <li>
    <p>    <strong>Deleting a tenant</strong></p>
  <p>
    To delete a tenant, hover over
    <strong>View details</strong> in the Action column and click
    <strong>delete</strong> icon.
  </p>
  <p>You cannot delete the default tenant. The default tanant is represented by <span style="background-color: black; display: inline-block;padding: 2px">
  <img src='https://www.mysonicwall.com/images/icon_default-customer.svg' width='13px' height: '13px'/>
  </span> icon, displayed next to it.</p>
  </li>
    <li>
      <p><strong>Creating a tenant</strong></p>
  <p>
    To create a tenant, click
    <strong>Create Tenant</strong> at the upper-right corner of the page and do the workflow actions.
  </p>
  </li>
    <li>
    <p>  <strong>Viewing tenants as a list or as cards</strong></p>
  <p>
    To toggle between the views of listing the tenants as a list or as cards, click
    <strong>View all as list/ View all as card</strong>.
  </p>
  </li>
    <li>
  <p>    <strong>Registering a product</strong></p>
  <p>
    To register a product, click
    <strong>Register products</strong> window and do the workflow actions.
  </p>
  </li>
    <li>
    <p>  <strong>Managing user groups</strong></p>
  <p>
    To manage user groups, click
    <strong>Manage</strong> in the
    <strong>User Management</strong> window to begin.
  </p>
  </li>
    <li>
      <p><strong>Managing products</strong></p>
  <p>
    The
    <strong>Tenant products</strong> window displays the number of products and the number of tenants in your MySonicWall Workspace account.
    To manage products, click
    <strong>Manage</strong> in the
    <strong>Tenant Products</strong> window.
  </p>
  </li>
    <li>
      <p><strong>Viewing license status</strong></p>
  <p>
    The
    <strong>Licensing Status</strong> window displays the number of expired licenses and the number of licenses that expires soon.
    To know the licensing status of the registered products, click
    <strong>View all</strong> in the
    <strong>Licensing status</strong> window.
  </p>
  </li>
    <li>
      <p><strong>Toggling between the Classic mode and the Contemporary Mode</strong></p>
  <p>
    The default view is in the Contemporary mode. Click
    <strong>Classic mode</strong> or
    <strong>Contemporary Mode</strong> at the upper-right corner of the page to toggle between the classic and the contemporary modes.
  </p>
  </li>
  </ul>
</div>
`;

export const productsList = `
<div>
  <h1>Tenant Products</h1>
  <p>
    The
    <strong>Tenant Products</strong> page lists all the products that are registered in your MySonicWall Workspace account along
      with details of each product, for example: serial number of the product, tenant to which the product is registered, date of registration,
      and so on.
  </p>
  <p>You can customize columns to choose the data that you want to see on the page. On this page,
    you can perform many tasks, for example: transferring a product to another tenant, deleting a product, registering a product, and so on.</p>
  <p>You can perform the following tasks:</p>
  <ul>
    <li>
     <p> <strong>Customizing columns</strong></p>
  <p>
    To customize columns, click
    <strong>Customize Columns</strong>, and select or clear the options to include or hide the data of the selected columns.
  </p>
  </li>
  <li>
  <p> <strong>Searching a product</strong></p>
  <p>You can search for a product by its friendly name or serial number in the search box at the upper-left corner on the page.</p>
  </li>
    <li>
     <p> <strong>Downloading product details</strong></p>
  <p>
    To download details of all the registered products as a CSV file, click
    <strong>Download CSV</strong>.
  </p>
  </li>
    <li>
      <p><strong>Uploading a CSV file</strong></p>
    <p>
     You can upload a CSV file to update the product details (for example, friendly names) of many products at once.</p>
     <p>
         To upload an updated CSV file:
     </p>
     <ol>
           <li>Click <strong>  Download  CSV </strong> to download the CSV file. </li>
           <li>Update the CSV file with required changes.</li>
           <li>Click  <strong>Upload CSV </strong> and upload the CSV file to update the product details.  </li>
     </ol>
  </li>
    <li>
     <p> <strong>Registering products</strong></p>
  <p>
    To register products, click
    <strong>Register products</strong> tab at the upper-right corner of the page and do the workflow actions.
  </p>
  </li>
    <li>
      <strong>Sort products</strong>
  <p>You can sort products by:</p>
  <ul>
    <li>
      <strong>Tenant</strong>&mdash;To list the products that are registered to a tenant, select a tenant from
      <strong>All</strong>
      <strong>tenants</strong>
      drop-down box in the upper-left corner of the page; you can also search for the tenant and then select the appropriate tenant.
    </li>
    <li>
     <p><strong> Product type </strong>—To list the products of a specific product type,
     click <span class="sw-font-icon icon-filter" style="font-size:16px;" > </span>and select the appropriate product type</p>
    </li>
    <li>
      <strong>Registered date</strong>&mdash;
      To list the products that are registered on a specified day or within a specified period,
      select the appropriate option from the drop-down box available in the slider. You can also adjust slider position to specify the period of registration.
    </li>
  </ul>
  </li>
  </ul>
  <p>You can perform the following tasks on a listed product:</p>
  <ul>
    <li>
      <p><strong>Selecting a product</strong>: Click the box next to a product to select the product.</p>
    </li>
    <li>
      <p><strong>Activating service</strong>: To activate a service for a product, click
      <strong>Activate service</strong> <img src='https://www.mysonicwall.com/images/key.png' width='20px' height='20px' />
      icon at the end of the row, enter the
      <strong>Activation key</strong> of the service you want to activate, and click
      <strong>Activate</strong>.</p>
      <ul>
    <li>
      <p>You can see the list of services that are active and nearing expiry under
      <strong>Active Services</strong>. To activate a service listed here, click
       <img src='https://www.mysonicwall.com/images/key.png' width='20px' height='20px' />
      <strong>Activate</strong> for the service, enter the activation key, and then click
      <strong>Confirm</strong>.</p>
    </li>
    <li>
      <p>To activate a service that is already expired, click
      <strong>Inactive Services</strong>. From the list of inactive services, click
       <img src='https://www.mysonicwall.com/images/key.png' width='20px' height='20px' />
      <strong>Activate</strong> next to the service that you want to activate, enter the activation key, and then click
      <strong>Confirm</strong>.</p>
    </li>
    </ul>
    </li>
    <li>
      <p><strong>Viewing product details</strong>: To view the details of a product, such as: serial number and date of registration,
      click the serial number of the product. To view the active or inactive services associated with your product, click
      <strong>Active Services</strong> or
      <strong>Inactive Services</strong>.</p>
    </li>
    <li>
      <p><strong>Renaming a product</strong>: To rename a product, hover over its name, click
      <strong>edit</strong> icon, rename, and then click checkmark.</p>
    </li>
    <li>
    <p><strong>Performing Cloud Backups for Firewalls (Gen 6 and later)</strong></p>
    <p>You should create a backup of your current running configuration to easily recover the
     firewall setup whenever there is a problem.</p>
    <p>Firewall cloud backups are sent securely over HTTPS to SonicWall servers
     that are managed by SonicWall. The settings file is not only transmitted
     securely but is encrypted individually while stored.</p>
    <p>To perform cloud backups manually:</p>
    <ol>
    <li>Click <img src='https://www.mysonicwall.com/images/more-options.png' width='10px'/> icon.</li>
    <li>Click <strong>Cloud backups</strong>.</li>
    <li>Click <strong>Add Preference File</strong>.</li>
    <li>To choose the file to export from within your firewall, click <strong>Choose File</strong> and select the appropriate file.</li>
    <li>Add <strong>Description</strong>.</li>
    <li>Click <strong>Submit</strong>.</li>
    </ol>
    </li>
  </ul>
  <p>You can perform the following tasks on one or more selected products:</p>
  <ul>
    <li>
      <p><strong>Update zero touch</strong>: To perform zero-touch update, click
      <strong>Update zero touch</strong>, confirm the serial number, and then click
      <strong>Update</strong>.</p>
    </li>
    <li>
      <p><strong>Deleting products</strong>: To delete the products, click
      <strong>Delete Products</strong>.</p>
    </li>
    <li>
      <p><strong>Transferring products</strong></p>
      <ul>
        <li>
          <p>To transfer products to another tenant, click
          <strong>Transfer Products</strong> and select the appropriate tenant from the list, and then click
          <strong>Transfer</strong>.</p>
        </li>
        <li>
          <p>To transfer products to another user, click
          <strong>Transfer Products</strong> &gt;
          <strong>User account</strong>. In the
          <strong>Email</strong> box enter the email address of the user to which you want to transfer the product, and then click
          <strong>Transfer</strong>.</p>
        </li>
      </ul>
    </li>
    <li>
      <p><strong>Downloading product details</strong>: To download the selected products&rsquo; details as a CSV file, click
      <strong>Download CSV</strong>.</p>
    </li>
  </ul>
</div>`;

export const registerProduct1 = `<div>
<h2>Register Products</h2>
<h2>Choosing a Tenant</h2>
<p>It is recommended to first select a tenant to which you want to register a product, and then proceed further to register the product.
 If you don't select a tenant, your product will be registered to the default tenant.</p>
<ul>
  <li>
    To select a tenant, click the required tenant that is listed below
    <strong>Search Tenants</strong> You can also search for a tenant by its name and then select the tenant.
  </li>
  <li>
    You can create a tenant from this page and then choose the newly created tenant to register your product. To create a tenant, click
    <strong>+ Create new tenant </strong>and do the workflow actions, and then select the newly created tenant to register your product.
  </li>
  <li>
    To skip selecting a tenant, click
    <strong>Proceed to product registration </strong>at the bottom of the page.
  </li>
</ul>`;

export const registerProduct98 = `
<h2>Register Products</h2>
<p><img src='../../../images/register_default_image.PNG' width='280px' height='100px' /></p>
<p>To begin registration, enter a serial number or activation key or assign key for a hardware or software or cloud product.</p>
<p>
Enter
<strong>Authentication code</strong> if prompted.
</p>
<p>
<strong>Note:</strong> If you try registering a product that&rsquo;s already registered to another user, a dialog box prompts that
 the product is already registered. If you still want to register the product, accept the terms and conditions and click
<strong>Transfer</strong> to transfer the product to your user account.
</p>
<p>
If you wish to register many products at once, click <strong>+ Register another serial number</strong>, otherwise click
<strong>Choose management options</strong> to continue with the product registration.
</p>
<p>
Note: <strong>You cannot perform registration of two or more CASB/HES products at once.</strong>
</p>
`;

export const registerUTMStep1 = `
<h2>Registering UTMs (TZ,NSA,NSv,Supermassives)</h2>
<p><img src='../../../images/firewall.PNG' style='height:100px;padding-left:20px;'/></p>
<ul>
<li>
    Enter <strong>Friendly name.</strong>
   <p>
   The product type is displayed next to the
   <strong>Friendly name</strong> box.
  </p>
 </li>
 <!-- <li>
      Click <strong>Choose management options</strong>.
</li> -->
</ul>
`;

export const registerUTMStep2 = `
<h2>Registering UTMs (TZ,NSA,NSv,Supermassives)</h2>
<p>Select a platform for zero-touch management:</p>
<p>The status of management options depends on your infrastructure, for example: if you have cloud-based management services enabled,
<strong>Cloud</strong> option is activated; if on-premise GMS is not configured,<strong> On-Prem</strong> option is deactivated.</p>
<ul>
   <li><strong>Cloud</strong><br>
   Manage your devices using cloud-based firewall management. To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
   </li>
   <li><strong>On-Prem</strong><br>
   Manage your devices using On-Prem GMS. To manage the firewall, select any one of the GMS servers
    from the <strong>GMS Server Public IP/FQDN</strong> dropdown.
   To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
    Enter the FQDN/IP in <strong>ZeroTouch Agent Public IP/FQDN</strong> that must be used to access the zero-touch agent from the firewall.
   </li>
   <li><strong>On-Box</strong><br>
   Manage your device using On-box Manager</li>
</ul>
  <!-- <p>Click<strong> Done</strong>.</p>
  <p>A confirmation message is displayed if the product registration is successful.</p>
 <p>The newly registered product is listed on the
  <strong>Tenant Products</strong> page.
  </p> -->
`;

export const registerSATA1 = `
<h2>Registering Storage Modules and SATA modules</h2>
<ul>
<li>
  Enter
  <strong>Friendly name.</strong>
 <p>
  The product type is displayed next to the
  <strong>Friendly name</strong> box.
 </p>
</li>
<li>
<p>
  Select
  <strong>Storage Module</strong> in the drop-down box.</p>
<p>
</li>
</ul>
<p>
Select the serial number of the appropriate storage module and click
<strong> Done</strong>.</p>
`;

export const registerSATA2 = `
<h2>Registering Storage Modules and SATA modules</h2>
<p>Verify the storage module is linked with your product and click
  <strong> Done</strong>; you have options to relink your product to another storage module or delete the storage module that
   is linked with your product and click
  <strong> Done</strong>.</p>
  <!-- <p>A confirmation message is displayed if the product registration is successful.</p>
<p>The newly registered product is listed on the
  <strong>Tenant Products</strong> page.</p> -->
`;

export const  registerHES1 = `
<h2>Registering HES Products</h2>
<p><img src='../../../images/hes_image.PNG' style='height:100px;padding-left: 20px;'/></p>
<ul><li>
<p>
Enter
<strong>Friendly name.</strong>
</p>
<p>
The product type is displayed next to the
 <strong>Friendly name</strong> box.
</p>
</li>
</ul>
`;

export const registerHES2 = `
<h2>Registering HES Products</h2>
<p>Configure the following options:</p>
<ul>
   <li>
     <p><strong>Select your Data Center Location&mdash;North America or Europe.</strong></p>
     <p>
      <strong>Note:</strong>You cannot change this option once it has been specified.
     </p>
   </li>
   <li>
  <p><strong>Domain Name</strong>&mdash;The primary domain name that is associated with your SonicWall Hosted Email
   Security solution, for example: SonicWall.com </p>
   </li>
   <li>
    <p> <strong>Confirm Domain Name</strong>&mdash;Confirm the domain name that you entered in the <strong>Domain Name box</strong>.</p>
   </li>
   <li>
   <p> <strong>Inbound Mail Server Host / IP Address</strong>&mdash;
      The IP address of the mail server hosting your user mailbox(es) for inbound messages.</p> </li>
<li>
 <p> <strong>Apply ISP Filter</strong></p>
</li>
<li>
 <p> <strong>Outbound Source IP Address</strong>&mdash;The outbound IP address of your Hosted Email Security solution.</p>
 <p>For example, if you registered the domain name soniclab.us.snwlhosted.com, then the Outbound Mail Server Host is soniclab.outbound.snwlhosted.com.</p>
</li>
<li>
  <p>  <strong>Email Address / Login</strong>&mdash;The email address or login name associated with your Hosted Email Security account.</p>
</li>
<li>
  <p> <strong>Password</strong>&mdash;The password associated with your Hosted Email Security account.</p>
</li>
<li>
 <p> <strong>Confirm Password</strong>&mdash;The password you entered in the previous field.</p>
</li>
</ul>
</li>`;

export const registerHES3 = `
<!-- <h2>Registering HES Products</h2>
<li>
  Click <strong>Done</strong>.
</li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>The newly registered product is listed on the
<strong>Tenant Products</strong> page.
</p> -->`;

export const registerSonicwave1 = `
<h2>Registering Sonicwave products</h2>
<p><img src='../../../images/wifi.PNG' style='height:100px;padding-left: 20px;'/></p>
<ul>
<li>
  <p> Enter <strong>Friendly name.</strong></p>
 <p> The product type is displayed next to the <strong>Friendly name</strong> box.</p>
</li>
<!-- <li>
<p> Click
  <strong>Choose management options</strong>.</p>
 </li> -->
 </ul> `;

export const registerSonicwave2 = `
<h2>Registering Sonicwave products</h2>
<ul>
<li>Select the management platform for the access point:
<p>The status of management options depends on your infrastructure, for example: if you have cloud-based management services enabled,
<strong>Cloud</strong> option is activated; if on-premise GMS is not configured,<strong> On-Prem</strong> option is deactivated.</p>
<ul>
   <li><strong>Cloud</strong><br>
   Manage your devices using cloud-based firewall management. To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
   </li>
   <li><strong>On-Prem</strong><br>
   Manage your devices using On-Prem GMS. To manage the firewall, select any one of the GMS servers
    from the <strong>GMS Server Public IP/FQDN</strong> dropdown.
   To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
    Enter the FQDN/IP in <strong>ZeroTouch Agent Public IP/FQDN</strong> that must be used to access the zero-touch agent from the firewall.
   </li>
   <li><strong>On-Box</strong><br>
   Manage your device using On-box Manager</li>
</ul>
</li>
<li>
  Select the country of operation from
  <strong>Select country</strong> drop-down menu.
</li>
</ul>
</li>`;

export const registerSoho1 = `
<h2>SOHO product registration</h2>
<ul>
  <li>
    Enter
    <strong>Friendly name.</strong>
   <p>
    The product type is displayed next to the
    <strong>Friendly name</strong> box.
   </p>
  </li>
  <li>
    Click
    <strong>Done</strong>.
  </li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
  The newly registered product is listed on the
  <strong>Tenant Products</strong> page.
</p>
`;

export const registerWaf1 = `
<h2>WAF product registration</h2>
<ul>
<li>
  Enter
  <strong>Friendly name.</strong>
 <p>
  The product type is displayed next to the
  <strong>Friendly name</strong> box.
 </p>
</li>
<li>
  Click
  <strong>Done</strong>.
</li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
The newly registered product is listed on the
<strong>Tenant Products</strong> page.
</p>`;

export const registerVpn1 = `
<h2>SSL VPN products</h2>
<ul>
  <li>
    Enter
    <strong>Friendly name.</strong>
   <p>
    The product type is displayed next to the
    <strong>Friendly name</strong> box.
   </p>
  </li>
  <li>
    Click
    <strong>Done</strong>.
  </li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
  The newly registered product is listed on the
  <strong>Tenant Products</strong> page.
</p>`;

export const registerGms1 = `

<h2>GMS Products</h2>
<ul>
<li>
  Enter
  <strong>Friendly name.</strong>
 <p>
  The product type is displayed next to the
  <strong>Friendly name</strong> box.
 </p>
</li>
<li>
  Click
  <strong>Done</strong>.
</li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
The newly registered product is listed on the
<strong>Tenant Products</strong> page.
</p>`;

export const registerCas2 = `
<h2>Registering CAS</h2>
Configure the following options:
<ul>
  <li>
     <strong>Domain Name</strong>&mdash;Enter a domain name that is associated with your CAS solution. Example: SonicWall.com
  </li>
 <li>
   <strong>Confirm Domain Name</strong>&mdash; Confirm the domain name that you entered In the <strong>Domain Name</strong>
 </li>
  <li>
 <strong>Select your Data Center Location</strong>&mdash;  <strong>North America or Europe.</strong>
    <p>
     <strong>Note:</strong>You cannot change this option once it has been specified.
 </p>
 </li>
 <li>
    <strong>CAS App</strong>&mdash;Select the appropriate <strong>CAS App</strong> from the drop-down box.
  </li>
</ul>
</li>
</ul>
<!--
<li>
 Click
 <strong>Done</strong>.
</li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
The newly registered product is listed on the
<strong>Tenant Products</strong> page.
</p> -->`;

export const registerCas1 = `
<h2>Registering CAS</h2>
<p><img src='../../../images/cas_image.PNG' style='height:100px;padding-left: 20px;'/></p>
<p>
<strong>Note:</strong>If you try registering a product that&rsquo;s already registered to another user, a dialog box prompts that
  the product is already registered. If you still want to register the product, accept the terms and conditions and click
 <strong>Transfer</strong> to transfer the product to your account.
</p>
<ul><li>
   <p>
   Enter
   <strong>Friendly name.</strong>
  </p>
  <p>
The product type is displayed next to the
 <strong>Friendly name</strong> box.
</p></li>
  </ul>`;

export const registerSonicwallUpgrade1 = `
<h2>SonicWall Upgrade</h2>
<ul>
<li>
  Enter <strong>Friendly name.</strong>
<p>
The product type is displayed next to the
<strong>Friendly name</strong> box.
</p>
</li>
<li>
  Select
  <strong>SonicWall Replacement</strong>in the drop-down box.
 <p>A list of available devices that can be replaced are displayed.</p>
</li>
<li>Select the trade-in unit to be replaced with the product you are registering.</li>
<li>
  Select
  <strong>Register and transfer</strong> in the drop-down box.
</li>
<li>
  Click
  <strong>Done</strong>.
 <p>
You can either delete or relink another trade-in unit. To delete, click
<strong>delete</strong> icon next to the unit serial number; to replace with another unit click edit icon, choose another unit, and click
<strong>Done</strong>.
  </p>
</li>
<!-- <li>
  Click
  <strong>Choose management options</strong>.
</li> -->
</ul>
`;

export const registerSonicwallUpgrade2 = `
<h2>SonicWall Upgrade</h2>
<li>Choose the management platform for zero-touch management:
<p>The status of management options depends on your infrastructure, for example: if you have cloud-based management services enabled,
<strong>Cloud</strong> option is activated; if on-premise GMS is not configured,<strong> On-Prem</strong> option is deactivated.</p>
<ul>
   <li><strong>Cloud</strong><br>
   Manage your devices using cloud-based firewall management. To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
   </li>
   <li><strong>On-Prem</strong><br>
   Manage your devices using On-Prem GMS. To manage the firewall, select any one of the GMS servers
    from the <strong>GMS Server Public IP/FQDN</strong> dropdown.
   To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
    Enter the FQDN/IP in <strong>ZeroTouch Agent Public IP/FQDN</strong> that must be used to access the zero-touch agent from the firewall.
   </li>
   <li><strong>On-Box</strong><br>
   Manage your device using On-box Manager</li>
</ul>
</li>
</ul>
<!--
<li>
  Click
  <strong>Done</strong>.
</li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
The newly registered product is listed on the
<strong>Tenant Products</strong> page.
</p> -->`;

export const registerCompitativeUpgrade1 = `
<h2>Competitive Upgrade</h2>
<ul>
<li>
  Enter
  <strong>Friendly name.</strong>
<p>
The product type is displayed next to the
<strong>Friendly name</strong> box.
</p>
</li>
<li>
  Select
  <strong>Competitive Replacement</strong>in the drop-down box.
</li>
<li>Specify manufacturer, model name or number.</li>
<li>Enter the serial number of the product </li>
<li>
<p>
  Click
  <strong>Done</strong>.
  </p>
 <p>
You can either delete or relink another unit. To delete, click
<strong>delete</strong> icon next to the unit serial number or to replace with another unit click
<strong>edit</strong> icon, choose another unit, and click
<strong>Done</strong>.
 </p>
</li>
<!-- <li>
  Click
  <strong>Choose management options</strong>.
</li> -->`;

export const registerCompitativeUpgrade2 = `
<h2>Competitive Upgrade</h2>
<li>Choose the management platform for zero-touch management:
<p>The status of management options depends on your infrastructure, for example: if you have cloud-based management services enabled,
<strong>Cloud</strong> option is activated; if on-premise GMS is not configured,<strong> On-Prem</strong> option is deactivated.</p>
<ul>
   <li><strong>Cloud</strong><br>
   Manage your devices using cloud-based firewall management. To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
   </li>
   <li><strong>On-Prem</strong><br>
   Manage your devices using On-Prem GMS. To manage the firewall, select any one of the GMS servers
    from the <strong>GMS Server Public IP/FQDN</strong> dropdown.
   To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
    Enter the FQDN/IP in <strong>ZeroTouch Agent Public IP/FQDN</strong> that must be used to access the zero-touch agent from the firewall.
   </li>
   <li><strong>On-Box</strong><br>
   Manage your device using On-box Manager</li>
</ul>
   </li>
   </ul>
   <!--
<li>
  Click <strong>Done</strong>.
</li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
The newly registered product is listed on the
<strong>Tenant Products</strong> page.
</p> -->`;

export const registerHighAvaliability1 = `<h2>Configuring High Availability Association</h2>
<p>You can configure High Availability association only on products of the same product type.
 For example: A NSa appliance can be associated with another NSa appliance.</p>
<p>To associate a high-availability secondary appliance to an appliance:</p>
<ul>
  <li>Click the serial number of the product to which you want to configure HA association.</li>
  <li>
    In the
    <strong>product details</strong>window, click
    <strong>HA Secondary</strong>to associate HA secondary appliance to the product.
  </li>
  <li>
    In the
    <strong>HA secondary</strong> window, select the appropriate serial number of the secondary appliance that you want to pair with your product.
  </li>
  <li>
    Click
    <strong>Associate</strong>.
  </li>
</ul>
<p>You will receive a confirmation message if the association is successful.</p>
<p>
  In the
  <strong>product details</strong> tab of the product that you performed HA association, you will see an increment in
  <strong>HA Secondary</strong> under
  <strong>Associated Products</strong>.
</p>
</div>`;

export const registerProduct2 = `<h2>Register Products</h2>
<h2>Registering UTMs (TZ,NSA,NSv,Supermassives)</h2>
<p>To begin registration, enter a serial number or activation key or assign key for a hardware or software or cloud product.</p>
<p>
  Enter
  <strong>Authentication code</strong>.
</p>
<p>
  <strong>Note:</strong> If you try registering a product that&rsquo;s already registered to another user, a dialog box prompts that
   the product is already registered. If you still want to register the product, accept the terms and conditions and click
  <strong>Transfer</strong> to transfer the product to your user account.
</p>
<ul>
  <li>
    Enter
    <strong>Friendly name.</strong>
   <p>
    The product type is displayed next to the
     <strong>Friendly name</strong> box.
   </p>
  </li>
  <li>
    Click <strong>Choose management options</strong>.
   <p>Select a platform for zero-touch management:</p>
   <p>The status of management options depends on your infrastructure, for example: if you have cloud-based management services enabled,
   <strong>Cloud</strong> option is activated; if on-premise GMS is not configured,<strong> On-Prem</strong> option is deactivated.</p>
   <ul>
      <li><strong>Cloud</strong><br>
      Manage your devices using cloud-based firewall management. To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
      </li>
      <li><strong>On-Prem</strong><br>
      Manage your devices using On-Prem GMS. To manage the firewall, select any one of the GMS servers
       from the <strong>GMS Server Public IP/FQDN</strong> dropdown.
      To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
       Enter the FQDN/IP in <strong>ZeroTouch Agent Public IP/FQDN</strong> that must be used to access the zero-touch agent from the firewall.
      </li>
      <li><strong>On-Box</strong><br>
      Manage your device using On-box Manager</li>
   </ul>
  </li>
  <li>
  <p>Click<strong>Done</strong>.</p>
  </li>
  </ul>
  <p>A confirmation message is displayed if the product registration is successful.</p>
  <p>The newly registered product is listed on the
  <strong>Tenant Products</strong> page.
  </p>

<h2>Registering Storage Modules and SATA modules</h2>
<p>To begin registration, enter a serial number or activation key or assign key for a hardware or software or cloud product.</p>
<p>
  Enter
  <strong>Authentication code</strong>.
</p>
<p>
  <strong>Note:</strong>If you try registering a product that&rsquo;s already registered to another user, a dialog box prompts that the product
   is already registered. If you still want to register the product, accept the terms and conditions and click
  <strong>Transfer</strong> to transfer the product to your account.
</p>
<ul>
  <li>
    Enter
    <strong>Friendly name.</strong>
   <p>
    The product type is displayed next to the
    <strong>Friendly name</strong> box.
   </p>
  </li>
  <li>
  <p>
    Select
    <strong>Storage Module</strong> in the drop-down box.</p>
  <p>
  Select the serial number of the appropriate storage module and click
  <strong>Done</strong>.</p>
<p>Verify the storage module is linked with your product and click
  <strong>Done</strong>; you have options to relink your product to another storage module or delete the storage module that
   is linked with your product and click
  <strong>Done</strong>.</p>
  </li>
  </ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>The newly registered product is listed on the
  <strong>Tenant Products</strong> page.</p>

<h2>Registering HES Products</h2>
<p>To begin registration, enter a Serial number or activation key or assign key for a hardware or software or cloud product.</p>
<ul>
  <li>
  <p>
    Enter
    <strong>Friendly name.</strong>
  </p>
  <p>
  The product type is displayed next to the
  <strong>Friendly name</strong> box.
  </p>
  </li>
  <li><p>Configure the following options:</p>
  <ul>
     <li>
       <p><strong>Select your Data Center Location&mdash;North America or Europe.</strong></p>
       <p>
        <strong>Note:</strong>You cannot change this option once it has been specified.
       </p>
     </li>
     <li>
    <p><strong>Domain Name</strong>&mdash;The primary domain name that is associated with your SonicWall Hosted Email
     Security solution, for example: SonicWall.com </p>
     </li>
     <li>
      <p> <strong>Confirm Domain Name</strong>&mdash;Confirm the domain name that you entered in the <strong>Domain Name box</strong>.</p>
     </li>
     <li>
     <p> <strong>Inbound Mail Server Host / IP Address</strong>&mdash;
        The IP address of the mail server hosting your user mailbox(es) for inbound messages.</p> </li>
  <li>
   <p> <strong>Apply ISP Filter</strong></p>
  </li>
  <li>
   <p> <strong>Outbound Source IP Address</strong>&mdash;The outbound IP address of your Hosted Email Security solution.</p>
   <p>For example, if you registered the domain name soniclab.us.snwlhosted.com, then the Outbound Mail Server Host is soniclab.outbound.snwlhosted.com.</p>
  </li>
  <li>
    <p>  <strong>Email Address / Login</strong>&mdash;The email address or login name associated with your Hosted Email Security account.</p>
  </li>
  <li>
    <p> <strong>Password</strong>&mdash;The password associated with your Hosted Email Security account.</p>
  </li>
  <li>
   <p> <strong>Confirm Password</strong>&mdash;The password you entered in the previous field.</p>
  </li>
</ul>
</li>
<li>
    Click <strong>Done</strong>.
</li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>The newly registered product is listed on the
  <strong>Tenant Products</strong> page.
</p>

<h2>Registering Sonicwave products</h2>
<p>To begin registration, enter a serial number or activation key or assign key for a hardware or software or cloud product.</p>
<p>Enter <strong>Authentication code</strong>. </p>
<p><strong>Note:</strong>If you try registering a product that&rsquo;s already registered to another user, a dialog box prompts that
   the product is already registered. If you still want to register the product, accept the terms and conditions and click
  <strong>Transfer</strong> to transfer the product to your account.
</p>
<ul>
  <li>
    <p> Enter <strong>Friendly name.</strong></p>
   <p> The product type is displayed next to the <strong>Friendly name</strong> box.</p>
  </li>
  <li>
  <p>  Click
    <strong>Choose management options</strong>.</p>
  <ul>
  <li>Select the management platform for the access point:
<p>The status of management options depends on your infrastructure, for example: if you have cloud-based management services enabled,
<strong>Cloud</strong> option is activated; if on-premise GMS is not configured,<strong> On-Prem</strong> option is deactivated.</p>
<ul>
   <li><strong>Cloud</strong><br>
   Manage your devices using cloud-based firewall management. To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
   </li>
   <li><strong>On-Prem</strong><br>
   Manage your devices using On-Prem GMS. To manage the firewall, select any one of the GMS servers
    from the <strong>GMS Server Public IP/FQDN</strong> dropdown.
   To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
    Enter the FQDN/IP in <strong>ZeroTouch Agent Public IP/FQDN</strong> that must be used to access the zero-touch agent from the firewall.
   </li>
   <li><strong>On-Box</strong><br>
   Manage your device using On-box Manager</li>
</ul>
  </li>
  <li>
    Select the country of operation from
    <strong>Select country</strong> drop-down menu.
  </li>
  </ul>
  </li>
  <li>
    Click
    <strong>Done</strong>.
  </li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
  The newly registered product is listed on
  <strong>Tenant Products</strong> page.
</p>

<h2>SOHO product registration</h2>
<p>To begin registration, enter a serial number or activation key or assign key for a hardware or software or cloud product.</p>
<p>
  Enter
  <strong>Authentication code</strong>.
</p>
<p>
  <strong>Note:</strong>If you try registering a product that&rsquo;s already registered to another user, a dialog box prompts that
   the product is already registered. If you still want to register the product, accept the terms and conditions and click
  <strong>Transfer</strong> to transfer the product to your account.
</p>

<ul>
  <li>
    Enter
    <strong>Friendly name.</strong>
   <p>
    The product type is displayed next to the
    <strong>Friendly name</strong> box.
   </p>
  </li>
  <li>
    Click
    <strong>Done</strong>.
  </li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
  The newly registered product is listed on the
  <strong>Tenant Products</strong> page.
</p>


<h2>WAF product registration</h2>
<p>To begin registration, enter a serial number or activation key or assign key for a hardware or software or cloud product.</p>
<p>
  Enter
  <strong>Authentication code</strong>.
</p>
<p>
  <strong>Note:</strong>If you try registering a product that&rsquo;s already registered to another user, a dialog box prompts that
   the product is already registered. If you still want to register the product, accept the terms and conditions and click
  <strong>Transfer</strong> to transfer the product to your account.
</p>
<ul>
  <li>
    Enter
    <strong>Friendly name.</strong>
   <p>
  The product type is displayed next to the
  <strong>Friendly name</strong> box.
  </p>
  </li>
  <li>
    Click
    <strong>Done</strong>.
  </li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
  The newly registered product is listed on the
  <strong>Tenant Products</strong> page.
</p>

<h2>SSL VPN products</h2>
<p>To begin registration, enter a serial number or activation key or assign key for a hardware or software or cloud product.</p>
<p>
  Enter
  <strong>Authentication code</strong>.
</p>
<p>
  <strong>Note:</strong>If you try registering a product that&rsquo;s already registered to another user, a dialog box prompts that
   the product is already registered. If you still want to register the product, accept the terms and conditions and click
  <strong>Transfer</strong> to transfer the product to your account.
</p>
<ul>
  <li>
    Enter
    <strong>Friendly name.</strong>
   <p>
    The product type is displayed next to the
    <strong>Friendly name</strong> box.
   </p>
   </li>
   <li>
    Click
    <strong>Done</strong>.
  </li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
  The newly registered product is listed on the
  <strong>Tenant Products</strong> page.
</p>


<h2>GMS Products</h2>
<p>To begin registration, enter a serial number or activation key or assign key for a hardware or software or cloud product.</p>
<p>
  Enter
  <strong>Authentication code</strong>.
</p>
<p>
  <strong>Note:</strong>If you try registering a product that&rsquo;s already registered to another user, a dialog box prompts that
   the product is already registered. If you still want to register the product, accept the terms and conditions and click
  <strong>Transfer</strong> to transfer the product to your account.
</p>
<ul>
  <li>
    Enter
    <strong>Friendly name.</strong>
<p>
  The product type is displayed next to the
  <strong>Friendly name</strong> box.
</p>
</li>
  <li>
    Click
    <strong>Done</strong>.
  </li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
  The newly registered product is listed on the
  <strong>Tenant Products</strong> page.
</p>


<h2>Registering CAS</h2>
<p>To begin registration, enter a serial number or activation key or assign key for a hardware or software or cloud product.</p>
<p>
 <strong>Note:</strong>If you try registering a product that&rsquo;s already registered to another user, a dialog box prompts that
   the product is already registered. If you still want to register the product, accept the terms and conditions and click
  <strong>Transfer</strong> to transfer the product to your account.
</p>
<ul>
  <li>
    Enter
    <strong>Friendly name.</strong>
   <p>
    The product type is displayed next to the
    <strong>Friendly name</strong> box.
   </p>
  </li>
  <li>Configure the following options:
   <ul>
     <li>
        <strong>Domain Name</strong>&mdash;Enter a domain name that is associated with your CAS solution. Example: SonicWall.com
     </li>
    <li>
      <strong>Confirm Domain Name</strong>&mdash; Confirm the domain name that you entered In the <strong>Domain Name</strong>
    </li>
     <li>
    <strong>Select your Data Center Location</strong>&mdash;  <strong>North America or Europe.</strong>
       <p>
        <strong>Note:</strong>You cannot change this option once it has been specified.
    </p>
    </li>
    <li>
       <strong>CAS App</strong>&mdash;Select the appropriate <strong>CAS App</strong> from the drop-down box.
     </li>
   </ul>
</li>
<li>
    Click
    <strong>Done</strong>.
</li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
  The newly registered product is listed on the
  <strong>Tenant Products</strong> page.
</p>
<p>&nbsp;</p>

<h2>SonicWall Upgrade</h2>
<p>To begin registration, enter a serial number or activation key or assign key for a hardware or software or cloud product.</p>
<p>
  Enter
  <strong>Authentication code</strong>.
</p>
<p>
  <strong>Note:</strong>If you try registering a product that&rsquo;s already registered to another user, a dialog box prompts that
   the product is already registered. If you still want to register the product, accept the terms and conditions and click
  <strong>Transfer</strong> to transfer the product to your account.
</p>
<ul>
  <li>
    Enter <strong>Friendly name.</strong>
  <p>
  The product type is displayed next to the
  <strong>Friendly name</strong> box.
  </p>
  </li>
  <li>
    Select
    <strong>SonicWall Replacement</strong>in the drop-down box.
   <p>A list of available devices that can be replaced are displayed.</p>
  </li>
  <li>Select the trade-in unit to be replaced with the product you are registering.</li>
  <li>
    Select
    <strong>Register and transfer</strong> in the drop-down box.
  </li>
  <li>
    Click
    <strong>Done</strong>.
   <p>
  You can either delete or relink another trade-in unit. To delete, click
  <strong>delete</strong> icon next to the unit serial number; to replace with another unit click edit icon, choose another unit, and click
  <strong>Done</strong>.
    </p>
  </li>
  <li>
    Click
    <strong>Choose management options</strong>.
  </li>
  <li>Choose the management platform for zero-touch management:
  <p>The status of management options depends on your infrastructure, for example: if you have cloud-based management services enabled,
<strong>Cloud</strong> option is activated; if on-premise GMS is not configured,<strong> On-Prem</strong> option is deactivated.</p>
<ul>
   <li><strong>Cloud</strong><br>
   Manage your devices using cloud-based firewall management. To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
   </li>
   <li><strong>On-Prem</strong><br>
   Manage your devices using On-Prem GMS. To manage the firewall, select any one of the GMS servers
    from the <strong>GMS Server Public IP/FQDN</strong> dropdown.
   To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
    Enter the FQDN/IP in <strong>ZeroTouch Agent Public IP/FQDN</strong> that must be used to access the zero-touch agent from the firewall.
   </li>
   <li><strong>On-Box</strong><br>
   Manage your device using On-box Manager</li>
</ul>
</li>
  <li>
    Click
    <strong>Done</strong>.
  </li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
  The newly registered product is listed on the
  <strong>Tenant Products</strong> page.
</p>

<h2>Competitive Upgrade</h2>
<p>To begin registration, enter a serial number or activation key or assign key for a hardware or software or cloud product.</p>
<p>
  Enter
  <strong>Authentication code</strong>.
</p>
<p>
  <strong>Note:</strong>If you try registering a product that&rsquo;s already registered to another user, a dialog box prompts
   that the product is already registered. If you still want to register the product, accept the terms and conditions and click
  <strong>Transfer</strong> to transfer the product to your account.
</p>
<ul>
  <li>
    Enter
    <strong>Friendly name.</strong>
<p>
  The product type is displayed next to the
  <strong>Friendly name</strong> box.
</p>
</li>
  <li>
    Select
    <strong>Competitive Replacement</strong>in the drop-down box.
  </li>
  <li>Specify manufacturer, model name or number.</li>
  <li>Enter the serial number of the product </li>
  <li>
  <p>
    Click
    <strong>Done</strong>.
    </p>
   <p>
  You can either delete or relink another unit. To delete, click
  <strong>delete</strong> icon next to the unit serial number or to replace with another unit click
  <strong>edit</strong> icon, choose another unit, and click
  <strong>Done</strong>.
   </p>
 </li>
  <li>
    Click
    <strong>Choose management options</strong>.
  </li>
  <li>Choose the management platform for zero-touch management:
  <p>The status of management options depends on your infrastructure, for example: if you have cloud-based management services enabled,
<strong>Cloud</strong> option is activated; if on-premise GMS is not configured,<strong> On-Prem</strong> option is deactivated.</p>
<ul>
   <li><strong>Cloud</strong><br>
   Manage your devices using cloud-based firewall management. To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
   </li>
   <li><strong>On-Prem</strong><br>
   Manage your devices using On-Prem GMS. To manage the firewall, select any one of the GMS servers
    from the <strong>GMS Server Public IP/FQDN</strong> dropdown.
   To enable zero-touch feature, select <strong>Enable Zero Touch</strong> option.
    Enter the FQDN/IP in <strong>ZeroTouch Agent Public IP/FQDN</strong> that must be used to access the zero-touch agent from the firewall.
   </li>
   <li><strong>On-Box</strong><br>
   Manage your device using On-box Manager</li>
</ul>
     </li>
  <li>
    Click <strong>Done</strong>.
  </li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
 The newly registered product is listed on the
  <strong>Tenant Products</strong> page.
</p>

<h2>Configuring High Availability Association</h2>
<p>You can configure High Availability association only on products of the same product type.
 For example: A NSa appliance can be associated with another NSa appliance.</p>
<p>To associate a high-availability secondary appliance to an appliance:</p>
<ul>
  <li>Click the serial number of the product to which you want to configure HA association.</li>
  <li>
    In the
    <strong>product details</strong>window, click
    <strong>HA Secondary</strong>to associate HA secondary appliance to the product.
  </li>
  <li>
    In the
    <strong>HA secondary</strong> window, select the appropriate serial number of the secondary appliance that you want to pair with your product.
  </li>
  <li>
    Click
    <strong>Associate</strong>.
  </li>
</ul>
<p>You will receive a confirmation message if the association is successful.</p>
<p>
  In the
  <strong>product details</strong> tab of the product that you performed HA association, you will see an increment in
  <strong>HA Secondary</strong> under
  <strong>Associated Products</strong>.
</p>
</div>`;

export const createCustomer = `
<div>
<h2>Create Tenant</h2>
<p>You can create tenants, assign and manage user groups associated with the tenants.</p>
<p>
  To  create a Tenant, enter the tenant name in the
  <strong>New Tenants</strong> box and click the checkmark next to it.
</p>
</div>
`;

export const userGroupsHelp = `<div>
<h1>User groups</h1>
<p>The page lists the available user groups in your MySonicWall Workspace account. &nbsp;</p>
<p>You can perform the following tasks:</p>
<ul>
<li><strong>Creating a new user group</strong>: Click <strong>+ New user group</strong> at the lower-left corner on the <strong>User groups</strong>
 window to begin.</li>
<li><strong>Assigning tenants to the user groups</strong>: Click <strong>Assign tenants </strong>to begin.</li>
<li><strong>Managing a user group</strong>: Click the user group to begin.</li>
</ul>
<h2>Assigning tenants</h2>
<p>To assign tenants to multiple user groups at once:</p>
<ul>
<li>Click <strong>Assign Tenants </strong> on the<strong> User groups </strong> page<strong>.</strong></li>
<li>Select the user groups and select the tenants to assign the tenants to the selected user groups.</li>
<li>Click <strong>Assign</strong>.</li>
</ul>
</div>`;

export const customerUserGroupsHelp =  `<div>
<h1>User groups</h1>
<p>
  The default user group is automatically assigned to the tenant.
  </p>
  <p>
  To assign other user groups, select the user groups from the
  <strong>Available groups</strong> list. Ensure to have at least one user group assigned to the tenant that is being created.
</p>
<p>
  To manage a user group, users, and user-permissions, click the user group in the
  <strong>Selected groups</strong> list.
</p>
</div>`;

export const customerUserGroupsHelp2 = `<div>
 <h1>User groups</h1>
 <p>The userGroup assigned to the tenant are listed under <strong>Selected Groups</strong>.</p>
 <p> To assign the other User Groups to the
tenant,select the groups listed in <strong> Available Groups </strong> list.
 </p>
</div>`;

export const userGroupsUsersTab =  `<div>
<h2>Managing User Groups</h2>
  <p>You can add users or remove users from a user group. You can rename, delete, or make any group as the default user group.</p>
  <ul>
    <li>To add or remove users:
      <ul>
       <li>
         To add users, click
         <strong>+ User</strong>, select users that are available (users that are part of all the user groups are listed);
         you can also search for a user by the name, select, and then click
        <strong>Add</strong>.
       </li>
        <li>
         You can also invite users to join the group. Click
         <strong>+ Invite user</strong>, enter the following details of the user to invite: email address, first name, last name, select the appropriate
         <strong>Contact Type</strong> from the drop-down box, and then click
         <strong>Invite</strong>.
          <p>
         The invited user is listed in
         <strong>Available users</strong> list. Select the user and click
         <strong>Add</strong>. The user is added to the group and status is shown as invited.
         </p>
         </li>
         <li>
         To remove users associated with the group, click
         <strong>Remove</strong>.
         </li>
        </ul>
        </li>
    <li>
      To make the user group as default, click
      <strong>Make Default.</strong>
    </li>
    <li>
      To rename the user group, click
      <strong>edit</strong> icon, rename, and then click the checkmark next to it.
    </li>
    <li>
      To remove the user group assigned to the tenant, click
      <strong>delete</strong>
    </li>
  </ul>
</div>`;

export const userGroupsCustomerTab = `<div>
<h2> Tenants  </h2>
<p> All the tenants assigned to the user group are displayed here.
Every user group should have at least one tenant assigned to it. The default tenant is assigned to the newly created user group.
You can assign tenants to the user group or remove the tenants assigned to the user group.</p>
<h2>Assign Tenants</h2>
<p>When you assign a tenant to the user group, the users of the user group will have access to the products registered to the tenant.</p>
<ul>
  <li>
    To assign tenants to the user group, click
    <strong>+ Tenants</strong> and select other tenants listed, and then click
  </li>
  <li>
    To unassign a tenant, click
    <strong>Remove</strong> next to the tenant&rsquo;s name.
  </li>
</ul>
<p>To assign tenants to multiple user groups at once:</p>
<ul>
  <li>
    Click
    <strong>Assign Tenants</strong>on the
    <strong>User groups</strong>page
    <strong>.</strong>
  </li>
  <li>Select the user groups and select the tenants to assign the tenants to the selected user groups.</li>
  <li> Click
  <strong>Assign</strong>.</li>
</ul>
</div>`;

export const userGroupsPermissionTab = `
<div>
<h2>Manage permissions</h2>
<h3>CSC Management</h3>
<p>
  Select the appropriate role to assign user-permissions to manage products through CSC.
   The available roles and corresponding permissions differ among the available product types.
    For roles and permissions for each product type that can be managed through CSC, see the CSC documentation available at the Technical Documentation portal:
  <a
    href="https://www.sonicwall.com/support/technical-documentation/"
  target="_blank">https://www.sonicwall.com/support/technical-documentation/</a>.
</p>
<h3>Product Management</h3>
<p>To assign user-permissions to manage products in MySonicWall Workspace,<br>select the appropriate role:</p>
<ul>
  <li>
    <strong>Admin</strong>
    <p>This role provides access to everything that you can do with the products listed in MySonicWall Workspace:</p>
    <ul>
       <li>View products, search products, filter products, export product details.</li>
       <li>Register product, licensing; modify, delete, or transfer product</li>
       <li>Register trial versions of the products</li>
       <li>View support cases, download upgrade for the registered products</li>
    </ul>
  </li><li><strong>Operator</strong><p>This role provides access only to: view product details, Register Product,Licensing, Rename Product,
  Update Zero Touch, search products, filter products, export product details; view support cases</p></li>
  <li>
    <strong>Read only</strong>
    <p>This role provides access only to: view product details, search products, filter products, export product details; view support cases.</p>
  </li>
  <li>
    <strong>Support</strong>
    <p>This role provides access only to: view product details, search products, filter products, export product details;
    download upgrade for the registered products; view support cases.</p>
  </li>
</ul>
<h3>Tenant Management</h3>
<p>To assign user-permissions to manage tenants in MySonicWall Workspace, select appropriate roles:</p>
<ul>
  <li>
    <strong>Admin</strong>
    <p>The role provides access to everything that you can do with the tenants, including create, rename, and delete.</p>
  </li>
  <li>
    <strong>Read only</strong>
    <p>This role provides access only to view the information and activity; can't make any changes (create tenant, rename tenant, delete tenant).</p>
  </li>
  <li>
    <strong>Operator</strong>
    <p>This role allows permissions needed to manage devices in MSW, including creating, editing, and deploying configuration updates.
     Assigned users have read/write access to assets and reports. They cannot modify user permissions, or delete tenants.</p>
  </li>
  <li>
    <strong>No Access</strong>
    <p>This role is the lowest permission tier, granting no rights to view or interact with any tenant or product.</p>
  </li>
</ul>
</div>`;

export const createUserGroup = `<div>
   <h2>Creating User Group</h2>
   <p>Enter the user group name in the box available in the User groups window,
   and click the checkmark next to it.
   The newly added user group is listed in the User groups list.</p>
   </div>`;

export const bulkRegistration = `
   <h2>Bulk Registration Using CSV File</h2>
   <p>To register many products at once using a CSV file: download the CSV template,
    update the file with appropriate details of the products you want to register,
    and then upload the updated CSV file.</p>
    <p><strong>Note:</strong> You cannot perform competitive upgrade
    through bulk registration using a CSV file.</p>
    <p> <strong>Note:</strong> You can perform granular configuration
    for some products being registered only after you complete the product registration.
    For example: When registering a firewall, you can only specify the GMS serial number for zero-touch management,
    and further configuration can be performed from the <strong>Product Details</strong> window after the product is registered;
    when registering HES products, domain configuration can be performed only after the product is registered.</p>
<p>To perform bulk registration, do the following:</p>
<ol>
<li>Download the CSV template: Click <strong>Download CSV template</strong> at the lower-left corner of the page.</li>
<li>Enter the product details of each product that you want to register in a row.
You may need to leave some cells blank in a row for few parameters depending on the product you are registering.
 Refer the below table for descriptions of the column headers in the CSV template and which fields need to be filled for
 the products that you are registering:</li>
</ol>

<table border="1">
<tbody>
<tr style="height: 35px;">
<td style="height: 35px;" width="151">
<p><strong>Term</strong></p>
</td>
<td style="height: 35px;" width="239">
<p><strong>Description</strong></p>
</td>
<td style="height: 35px;" width="186">
<p><strong>Products </strong></p>
</td>
</tr>
<tr style="height: 85px;">
<td style="height: 85px;" width="151">
<p><strong>Serial number</strong></p>
</td>
<td style="height: 85px;" width="239">
<p>Serial number of the product you are registering.</p>
<p><strong>Note</strong>: You can enter the activation key in this cell for CAS, HES, and Analytics.</p>
</td>
<td style="height: 85px;" width="186">
<p>All</p>
<p>&nbsp;</p>
</td>
</tr>
<tr style="height: 61px;">
<td style="height: 61px;" width="151">
<p><strong>Authorization Code</strong></p>
</td>
<td style="height: 61px;" width="239">
<p>Authorization code of the product you are registering.</p>
</td>
<td style="height: 61px;" width="186">
<p>All except CAS, On-prem Analytics, and NSv using AWS token</p>
</td>
</tr>
<tr style="height: 48px;">
<td style="height: 48px;" width="151">
<p><strong>Friendly Name</strong></p>
</td>
<td style="height: 48px;" width="239">
<p>Friendly name of the product you are registering.</p>
</td>
<td style="height: 48px;" width="186">
<p>All (optional)</p>
</td>
</tr>
<tr style="height: 174px;">
<td style="height: 174px;" width="151">
<p><strong>HA Primary Serial Number</strong></p>
</td>
<td style="height: 174px;" width="239">
<p>Serial number of the registered product for which you want to configure High-Availability association with the product being registered.</p>
<p>You can configure High Availability association only for products of the same product type.
For example: An NSa appliance can be associated with another NSa appliance.</p>
<p>&nbsp;</p>
</td>
<td style="height: 174px;" width="186">
<p>All (If you are performing HA association with the product you are registering) &nbsp;&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr style="height: 61px;">
<td style="height: 61px;" width="151">
<p><strong>Trade-in Serial Number</strong></p>
<p>&nbsp;</p>
</td>
<td style="height: 61px;" width="239">
<p>Serial number of the Sonicwall product that you want to replace with the product that you are registering.</p>
</td>
<td style="height: 61px;" width="186">
<p>All (If you are performing Secure upgrade)</p>
</td>
</tr>
<tr style="height: 87px;">
<td style="height: 87px;" width="151">
<p><strong>ZTSupport</strong></p>
</td>
<td style="height: 87px;" width="239">
<p>Specifies whether to configure zero-touch support for the product you are registering.
Enter <strong>0 </strong>if you don&rsquo;t want to configure zero-touch support; enter <strong>1</strong> otherwise.</p>
</td>
<td style="height: 87px;" width="186">
<p>UTMs</p>
</td>
</tr>
<tr style="height: 59px;">
<td style="height: 59px;" width="151">
<p><strong>Data Center</strong></p>
<p>&nbsp;</p>
</td>
<td style="height: 59px;" width="239">
<p>The data center location to which you want to register your product.</p>
</td>
<td style="height: 59px;" width="186">
<p>CAS, On-prem Analytics, and firewalls</p>
</td>
</tr>
<tr style="height: 98px;">
<td style="height: 98px;" width="151">
<p><strong>GMS Serial Number</strong></p>
<p>&nbsp;</p>
</td>
<td style="height: 98px;" width="239">
<p>The serial number of the GMS system that manages the product you are registering.</p>
<p>Note: Make sure that the GMS is already registered to the tenant to which the product is being registered.</p>
</td>
<td style="height: 98px;" width="186">
<p>UTMs</p>
</td>
</tr>
<tr style="height: 61px;">
<td style="height: 61px;" width="151">
<p><strong>Storage or SATA Parent</strong></p>
</td>
<td style="height: 61px;" width="239">
<p>Enter the serial number of the storage module to associate with the product you are registering.</p>
</td>
<td style="height: 61px;" width="186">
<p>Storage</p>
</td>
</tr>
<tr style="height: 61px;">
<td style="height: 61px;" width="151">
<p><strong>CAS App</strong></p>
</td>
<td style="height: 61px;" width="239">
<p>Enter the appropriate cloud application to be secured using the cloud application security product that you are registering.</p>
</td>
<td style="height: 61px;" width="186">
<p>CAS</p>
</td>
</tr>
<tr style="height: 61px;">
<td style="height: 61px;" width="151">
<p><strong>CAS Sub-Domain</strong></p>
</td>
<td style="height: 61px;" width="239">
<p>This subdomain name will be used to create your tenant in the SonicWall Cloud App Security (SaaS Security) service.</p>
</td>
<td style="height: 61px;" width="186">
<p>CAS</p>
</td>
</tr>
<tr style="height: 74px;">
<td style="height: 74px;" width="151">
<p><strong>AWS Token</strong></p>
</td>
<td style="height: 74px;" width="239">
<p>AWS token for registering NSv products. You can specify either the AWS token or the serial number to register NSv products.</p>
</td>
<td style="height: 74px;" width="186">
<p>NSv</p>
</td>
</tr>
<tr style="height: 48px;">
<td style="height: 48px;" width="151">
<p><strong>Country</strong></p>
</td>
<td style="height: 48px;" width="239">
<p>The country of operation for SonicWave products.</p>
</td>
<td style="height: 48px;" width="186">
<p>SonicWave</p>
</td>
</tr>
</tbody>
</table>
<p>-Click <strong>Upload CSV for bulk registration</strong>, select the updated CSV file, and click <strong>UPLOAD</strong>. </p>
</p>
   `;

export const genericRegisterHelp = `
<p>
If you wish to register many products at once, click <strong>+ Register another serial number</strong>, otherwise click
<strong>Choose management options</strong> to continue with the product registration.
</p>
<p>
Note: <strong>You cannot perform registration of two or more CASB/HES products at once.</strong>
</p>
`;

export const genericRegisterHelp3 =
`<li>
Click <strong>Done</strong>.
</li>
</ul>
<p>A confirmation message is displayed if the product registration is successful.</p>
<p>
The newly registered product is listed on the
<strong>Tenant Products</strong> page.
</p>`;

export const downloadCenterHelp =
`<div>
  <h1> Download Center By Version </h1>
  <p> <strong> The Download Center By Version </strong> is a common repository to: </p>
  <ul>
    <li> View or download the set-up files for the eligible products registered with SonicWall. You can download
    the eligible software on regular basis or on an as needed basis. </li>
    <li> View the set-up files for all other products that SonicWall has released. </li>
    <li> View or download the Release notes for all the products that SonicWall has released. </li>
  </ul>
  <p> <strong> Default page: </strong> </p>
  <p> The <strong> Download Center By Version </strong> page displays a blank <strong> Download Center (Beta) </strong> screen with
  <strong> Product name </strong> box. </p>

  <h1> Eligibility Criteria </h1>
  <p> Eligibility criteria to download the software for a product is that user should have registered at least one product
  with SonicWall and have active support. </p>
  <p> <strong> Example: </strong> </p>
  <p> If the product is registered in the year 2015 and the support is expired in the year 2020, you are allowed to
  download the software versions released from year 2015 to 2020 only. You can view all other releases of the
  product till date, but the download is allowed till the active support date only </p>

  <h1> Filter Options for the Download Center </h1>

    <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
      <tbody>
        <tr>
          <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
          <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
        </tr>

        <tr>
          <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
           <span class="sw-icon__inner sw-font-icon icon-filter" style="font-size:2rem"></span>
          </td>
          <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Quick Filter </strong> icon to list the set-up files and release notes based on the <strong> LANGUAGE, RELEASE TYPE </strong>
          and <strong> RELEASE DATE </strong> filters. You can apply these filter groups individually or in combination to find the specific details.
          </td>
          </tr>

          <tr>
          <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
            <span class="sw-icon__inner sw-font-icon icon-search" style="font-size:2rem"></span>
            </td>
            <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
            Use the <strong> Search </strong> icon to search for any specific product
            </td>
            </tr>

            <tr>
          <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
            <span class="sw-icon__inner sw-font-icon icon-informational" style="font-size:2rem"></span>
            </td>
            <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
            Use <strong> Information </strong> icon to know more information on the column data
            </td>
            </tr>

          <tr>
            <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
              <span class="sw-icon__inner sw-font-icon icon-view" style="font-size:2rem"></span>
              </td>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
              Use the <strong> View </strong> icon to view the Release notes in the browser.
              </td>
              </tr>

          <tr>
            <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
              <span class="sw-icon__inner sw-font-icon icon-download" style="font-size:2rem"></span>
            </td>
          <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
           Use the <strong> Download </strong> icon to download the set-up files or Release notes
          </td>
        </tr>

        <tr>
          <td style="text-align:right;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
            <div style="display:flex;align-items:center">
              <span class="sw-icon__inner sw-font-icon icon-arrow-up" style="font-size:2rem;transform: rotateZ(90deg);"></span>
              <span class="sw-icon__inner sw-font-icon icon-arrow-up" style="font-size:2rem;transform: rotate(180deg);"></span>
            </div>
          </td>
          <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
           Use the <strong> Arrow </strong> icon to show or hide the details
          </td>
        </tr>

        <tr>
          <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
           <span class="sw-icon__inner sw-font-icon icon-blocked" style="font-size:2rem;"></span>
          </td>
          <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
           Download is restricted
          </td>
        </tr>

      </tbody>
    </table>

  <h1> Downloading Set-up Files for Eligible Active Products </h1>
  <ul>
    <ol>
      <li> Click <strong> Product name </strong> box and then perform one of the following ways: </li>
        <ul>
          <li> Enter name of the product in <strong> Search for product </strong> box </li>
          <li> Enable the <strong> Show my products </strong> option to list the active products and then select the required
          product from the <strong> MY PRODUCTS </strong> list. </li>
            <p> <strong> NOTE: </strong> </p>
              <ul>
                <li> You can identify the active products with <strong> <em> Downloads Available </em> </strong> text below the product name </li>
                <li>  When the product is selected, the <strong> Quick Filter </strong> and <strong> Search </strong> icons are enabled at top left
                corner of the table. </li>
              </ul>
        </ul>
      <div> <img src="${downloadCenterBetaOne}" style="width:100%" /> </div>
      <li> Click the Quick Filter icon. </li>
      <li> Select the required filters for <strong> LANGUAGE, RELEASE TYPE and RELEASE DATE </strong> and then click <strong> Apply, </strong>
      which displays the selected active filters on top of the table. </li>
      <li> Click <strong> Close </strong> (x) to remove the filter. </li>
      <li> Click the <strong> Search </strong> icon and then type a search string if you are looking for any specif product release. </li>
      <li> Enable the <strong> Show latest available downloads </strong> option on top of the table to list the latest available
      software to download. </li>
      <li> Click the major release number and then navigate to the required software release, which displays a table
      with <strong> NAME </strong> of the product, <strong> RELEASE DATE, LANGUAGE </strong> of the files, <strong> TYPE </strong> of release and <strong> FILES. </strong> </li>
      <div> <img src="${downloadCenterBetaTwo}" style="width:100%" /> </div>
      <li> Point to the <strong> Information </strong> icon in the <strong> NAME </strong> column to view statistics of the particular release set-up files. </li>
      <li> Click <strong> Close </strong> (x) to close the statistics information. </li>
      <li> Click the <strong> Information </strong> icon next to the <strong> TYPE </strong> heading to know the different types of releases and their
      definitions. </li>
      <li> Click the <strong> Download </strong> icon to download the required set-up files or release notes from the <strong> Files </strong> column. If
      the download is restricted for any of the set-up files, check the <span style="color:#FF791A"> Eligibility Criteria. </span> </li>
      <li> Click the <strong> View </strong> icon to view the Release notes in the browser. </li>
      <li>  Click the <strong> Arrow </strong> icon of the release in the table to show or hide the details </li>
    </ol>
  </ul>

  <h1> Viewing Set-up Files for Non-registered Products </h1>
  <p> In addition to the registered active products, the <strong> Download Center By Version </strong> displays set-up files for all nonregistered products (other products) that SonicWall has released till date. For non-registered products (other
    products), you can only view the set-up files of the software, but the download is restricted. </p>
</div>`;

export const activityLogHelp = `<div><span style="font-size: 14pt;font-weight:700">User Activity Log</span></div>
<div>&nbsp;</div>
<div>The <strong>User Activity Log</strong> page summarizes the activity log details in a tabular form for all
 types of activities performed by the user on all Tenants, Users, Products, and Services registered and shared with
 your MySonicWall account.</div>
<div>From the <strong>UserActivityLog</strong> page, you can filter the activities with all possible combinations for
last 30 days or any custom duration, not exceeding 30 days.</div>
<div>You can also customize and sort the filtered activity log details to identify the specific results.</div>
<div><strong>Default page:</strong></div>
<ul style="list-style-type: square;">
<li>The <strong>User Activity Log</strong> page summarizes the activity log details in a tabular form for last 30 days
for all<br />types of activities performed on users registered and shared with your MySonicWall account. The User<br />
Activity Log table includes <strong>ACTIVITY TIME</strong>, <strong>ACTIVITY USER NAME</strong>, <strong>EMAIL ADDRESS</strong>,
 <strong>ACTIVITY</strong>,<br /><strong>ACTIVITY DETAILS</strong>, <strong>TENANT, SERIAL NUMBER</strong>, and
  <strong>SOURCE</strong>.</li>
<li><strong>IP ADDRESS</strong> and <strong>USER ORGANIZATION</strong> are not included in the User Activity Log table. To include<br />
them in the table, click Settings icon on top of the table, and then check the boxes for the <strong>IP ADDRESS</strong>
<br />and <strong>USER ORGANIZATION. </strong>You can reset the table details to default, filter and customize the table
details with the help of the icons, buttons and drop-downs available on top of the table.</li>
</ul>
<p><span style="font-size: 14pt;"><strong>Filter Options for the User Activity Log</strong></span></p>
<table style="border-collapse: collapse; width: 100%; height: 360px;" border="1">
<tbody>
<tr style="height: 18px;">
<td style="width: 49.8792%; height: 18px;"><strong>Icon/Term&nbsp;</strong></td>
<td style="width: 50.1208%; height: 18px;"><strong>Description</strong></td>
</tr>
<tr style="height: 72px;">
<td style="width: 49.8792%; height: 72px;">
  <span class="sw-icon__inner sw-font-icon icon-filter" style="font-size:2rem"></span>
</td>
<td style="width: 50.1208%; height: 72px;">Use the Quick Filter icon to list activities of the
 <strong>TENANTS</strong>, <strong>USERS</strong>, <strong>SERIAL NUMBERS</strong>,
 <strong>SOURCES</strong>, <strong>IP ADDRESS</strong>.
 You can apply these filter groups individually or in combination to find the specific activity log details</td>
</tr>
<tr style="height: 54px;">
<td style="width: 49.8792%; height: 54px;">
 <span class="sw-icon__inner sw-font-icon icon-options" style="font-size:2rem"></span>
</td>
<td style="width: 50.1208%; height: 54px;">Use the Settings icon to include or exclude the <strong>IP</strong>
<strong>ADDRESS </strong>and/or <strong>USER ORGANIZATION</strong> details in the activity log details</td>
</tr>
<tr style="height: 54px;">
<td style="width: 49.8792%; height: 54px;">
 <span class="sw-icon__inner sw-font-icon icon-refresh" style="font-size:2rem"></span>
</td>
<td style="width: 50.1208%; height: 54px;">Use the Refresh icon to reset the filters to default for <strong>
Activity Type</strong>, <strong>Activity</strong>, Duration (<strong>Last 30days</strong> or
  <strong>Custom: Max 30days</strong>), Settings options</td>
</tr>
<tr style="height: 36px;">
<td style="width: 49.8792%; height: 36px;">Last 30 days</td>
<td style="width: 50.1208%; height: 36px;">Click the <strong>Last 30 days</strong>
 so the table shows the last 30 days of data</td>
</tr>
<tr style="height: 36px;">
<td style="width: 49.8792%; height: 36px;">Custom: Max 30days</td>
<td style="width: 50.1208%; height: 36px;">Click the <strong>Custom: Max 30days</strong>
and select any custom duration, not exceeding 30 days.</td>
</tr>
<tr style="height: 36px;">
<td style="width: 49.8792%; height: 36px;">Activity Type</td>
<td style="width: 50.1208%; height: 36px;">Select a specific filter from the <strong>Activity Type
</strong> drop-down list.</td>
</tr>
<tr style="height: 54px;">
<td style="width: 49.8792%; height: 54px;">Activity</td>
<td style="width: 50.1208%; height: 54px;">Select the relevant filter from the <strong>Activity</strong>
 drop-down list for the selected <strong>Activity Type </strong>for which you want to list
  the activity log details</td>
</tr>
</tbody>
</table>
<h2><strong>Quick Filter</strong></h2>
<p>Use the <strong>Quick Filter</strong> option if you are looking for activities of any one
 of the groups or combination of the groups listed below.</p>
<p><strong>Filter Groups</strong></p>
<table style="border-collapse: collapse; width: 100%; height: 108px;" border="1">
<tbody>
<tr style="height: 18px;">
<td style="width: 50%; height: 18px;"><strong>Group Name</strong></td>
<td style="width: 50%; height: 18px;"><strong>Description</strong></td>
</tr>
<tr style="height: 18px;">
<td style="width: 50%; height: 18px;"><strong>TENANTS</strong></td>
<td style="width: 50%; height: 18px;">The <strong>TENANTS</strong> group displays the complete
 list of registered and shared tenants under your MySonicWall account. Search or select the
  required Tenant group from the list to get activities of the users belong to the Tenant.</td>
</tr>
<tr style="height: 18px;">
<td style="width: 50%; height: 18px;"><strong>USERS</strong></td>
<td style="width: 50%; height: 18px;">The <strong>USERS</strong> group displays the complete
 list of registered and shared users under your MySonicWall account. Search or select the specific
  user or users for the selected <strong>TENANTS</strong> group from the list to get the activity
   log details. Check the boxes of the users to be included</td>
</tr>
<tr style="height: 18px;">
<td style="width: 50%; height: 18px;"><strong>SERIAL NUMBERS</strong></td>
<td style="width: 50%; height: 18px;">The <strong>SERIAL NUMBERS</strong> group displays
 the complete list of serial numbers of the appliances assigned to the registered and shared
  users under your MySonicWall<br />account. Search or select the specific serial number from
   the list for which you want to list the activity log details.</td>
</tr>
<tr style="height: 18px;">
<td style="width: 50%; height: 18px;"><strong>SOURCES</strong></td>
<td style="width: 50%; height: 18px;">The <strong>SOURCES</strong> group displays the
 complete list of sources of the appliances assigned to the users. Search or select the
  required source or sources from the list to get activity log details. Check the boxes of the
   sources to be included.</td>
</tr>
<tr style="height: 18px;">
<td style="width: 50%; height: 18px;"><strong>IP ADDRESS</strong></td>
<td style="width: 50%; height: 18px;">
<p>The <strong>IP ADDRESS</strong> group displays the complete list of IP Addresses of the
 appliances assigned to the users. Search or select the specific IP address of the appliance
  assigned from the list for which you want to get activity log.</p>
</td>
</tr>
</tbody>
</table>
<p><strong><em>To filter data by Quick Filter:</em></strong></p>
<ul>
<li>
<div>Click the <strong>Quick Filter</strong> icon available at top left corner of the table.</div>
&nbsp;<strong>NOTE</strong>: By default, the <strong>IP ADDRESS</strong> is not included as
filter group. To include the<strong> IP ADDRESS</strong> as filter&nbsp; &nbsp; &nbsp;group, click
 <strong>Settings</strong> icon on top of the table and then check the box for the <strong>IP ADDRESS</strong>.</li>
 <div> <img src="${userActivityLogOne}" style="width:100%" /> </div>
<li>Reduce the number of activity log records being displayed in one of the following ways
<ul>
<li>Select any one of the filter options. &nbsp;</li>
<li>Type a search string in one of the fields provided.</li>
</ul>
</li>
<li>Set the required duration from top of the table. By default, <strong>Last 30 days
</strong> option is selected. You can set<br />the custom duration for any period (not exceeding 30 days)
 by selecting the <strong>Custom: Max 30days</strong> option.</li>
<li>Click <strong>Apply</strong> to get the activity details.</li>
<li>Click <strong>Clear</strong> to clear the filter selection.</li>
</ul>
<p style="padding-left: 40px;"><strong>NOTE:</strong></p>
<ul>
<li style="list-style-type: none;">
<ul>
<li>To show or hide the filter groups at any point, click the <strong>Quick Filter</strong>
 icon available at top-left corner of the table.</li>
<li>If none of the filter group is selected from the <strong>Quick Filter</strong>,
 then the activity table displays the details for all filter groups.</li>
</ul>
</li>
</ul>
<h2><strong>Filtering by Activity Type or Activity</strong></h2>
<p>Filtering by the<strong> Activity Type</strong> or <strong>Activity</strong>
 helps you to find the specific type of activity performed on the Tenants, Users, and Usergroups
  registered in your MySonicWall account.</p>
<p><strong>Examples</strong>:</p>
<ul>
<li>&nbsp;If you want list the software downloaded in last 30 days, select the <strong>Download Center
</strong> as Activity Type,<br /><strong>Download Software</strong> as Activity, the <strong>Last 30 days
</strong> option for duration and then click <strong>Filter</strong>. The table<br />displays the list of software
 downloads in last 30 days. Here in this example, only one option is available<br />for Activity, so even if you
  leave the Activity as <strong>All</strong>, the activity table list the same results.</li>
<li>Consider another example where you have more options for Activity. To list the products registered in last
 10 days, select the <strong>Product</strong> as Activity Type, <strong>Register Product</strong> as Activity,
  set custom duration range, not exceeding 30 days) and then click <strong>Filter</strong>. The activity table
   displays the list of the products registered for the selected range.</li>
</ul>
<p><strong><em>To filter data by Activity Type or Activity:</em></strong></p>
<ul>
<li>Set the required Quick Filters per Quick Filter. If you are looking for activity details for
 all filter groups <strong>TENANTS</strong>, <strong>USERS</strong>, <strong>SERIAL NUMBERS</strong>,
  <strong>SOURCES</strong> and<strong> IP ADDRESS</strong>, leave all the filter groups unselected or click
   <strong>Clear</strong>.</li>
<li>Select the required <strong>Activity Type</strong> and <strong>Activity</strong> from the respective drop-down
 lists.
<p>NOTE: Refer to the below table for Activity Type and its associated Activities</p>
<p>&nbsp;</p>
<table style="border-collapse: collapse; width: 100.772%; height: 1255px;" border="1">
<tbody>
<tr>
<td style="width: 50%;"><strong>Activity Type</strong></td>
<td style="width: 50%;"><strong>Activity</strong></td>
</tr>
<tr>
<td style="width: 50%;">Tenant</td>
<td style="width: 50%;">
<table style="border-collapse: collapse; width: 100%; height: 180px;" border="1">
<tbody>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Add Product to Tenant</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Add Usergroup to Tenant</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Delete Tenant</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Provision Tenant</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Remove Product from Tenant</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Remove Usergroup from Tenant</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Rename Tenant</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Set Default Tenant</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update Tenant Address</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update Tenant Star</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td style="width: 50%;">User Activity</td>
<td style="width: 50%;">
<table style="border-collapse: collapse; width: 100%; height: 90px;" border="1">
<tbody>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Account LockedOut</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Login</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Logout</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Unusual Login</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">User Signup</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td style="width: 50%;">Usergroup</td>
<td style="width: 50%;">
<table style="border-collapse: collapse; width: 100%; height: 180px;" border="1">
<tbody>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Add Tenant to Usergroup</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Add User to Usergroup</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Delete Usergroup</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Invite User</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Provision Usergroup</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Remove Tenant from Usergroup</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Remove User from Usergroup</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Rename Usergroup</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Set Default Usergroup</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update Usergroup Permission</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td style="width: 50%;">User Profile</td>
<td style="width: 50%;">
<table style="border-collapse: collapse; width: 100%; height: 183px;" border="1">
<tbody>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Change Password</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Delete Contact</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Edit Address</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Reset Password</td>
</tr>
<tr style="height: 21px;">
<td style="width: 100%; height: 21px;">Update Alerts</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update Email Address</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update Preferences</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update Profile</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update TFA Mode</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update TimeZone</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td style="width: 50%;">Download Center</td>
<td style="width: 50%;">Download Software</td>
</tr>
<tr>
<td style="width: 50%;">Product</td>
<td style="width: 50%;">
<table style="border-collapse: collapse; width: 100.932%; height: 180px;" border="1">
<tbody>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Associate Product</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Claim Product</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">De-enroll in Master MSSP</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Delete Product</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Download Preference File</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Enroll in Master MSSP</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Manage GUID</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Register Product</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Register Trial Product</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Remove Association</td>
</tr>
</tbody>
</table>
<table style="border-collapse: collapse; width: 100%; height: 180px;" border="1">
<tbody>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Rename Product</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Request NFR</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Secure Upgrade From</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Secure Upgrade To</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Transfer Product</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update Firmware Version</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update Hosted Email Security Password</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update Managed by Option</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update Partner Info</td>
</tr>
<tr style="height: 18px;">
<td style="width: 100%; height: 18px;">Update Zero Touch</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td style="width: 50%;">Service</td>
<td style="width: 50%;">Activate Service</td>
</tr>
</tbody>
</table>
.</li>
<li>Select the duration as <strong>Last 30 days</strong> or set the custom duration range by
 selecting<strong> Custom (Max 30days) </strong>(range should not exceed 30 days).</li>
<li>Click the <strong>Settings</strong> icon on top of the table and then check the boxes of the
 <strong>IP Address</strong> and/or<strong> User</strong><br /><strong>Organization</strong> if
  you want to include them in the filter results.</li>
<li>Click <strong>Filter</strong> to list the results.</li>
<li>Click the <strong>Refresh</strong> icon to reset or clear the filter selection.</li>
</ul>
<h2><strong>Customizing the User Activity Log</strong></h2>
<p>You can customize the <strong>User Activity Log</strong> table to include or exclude the
 <strong>IP Address</strong> and/or <strong>User Organization</strong> details in the filter
  results. By default, the <strong>IP Address</strong> and<strong> User Organization</strong>
   are not included in the <strong>User Activity</strong> <strong>Log</strong> table. Click
    <strong>Setting</strong> icon and then check the boxes of the<strong> IP Address</strong>
     and/or <strong>User Organization</strong> to add them.</p>
<h2><strong>Sorting the User Activity Log</strong></h2>
<p>Click the table headings to sort the data in ascending or descending order.</p>`;

export const masterMsspUserGuide =
`<div>
  <h1> Overview </h1>
  <p> Welcome to the SonicWall MSSP Monthly User Guide. This guide is applicable for MySonicWall users who have Master MSSP permissions </p>
  <p> With help of this guide , you can perform the below listed operations: </p>
  <ul>
    <li> <a href="#provisioningMssp"> <span style="color:#FF791A"> Provisioning MSSP, Tenant, and Product </span> </a> </li>
    <li> <a href="#editingMssp"> <span style="color:#FF791A"> Editing MSSP, Tenant, or Product Details </span> </a> </li>
    <li> <a href="#deletingProduct"> <span style="color:#FF791A"> Deleting Product </span> </a> </li>
    <li> <a href="#generatingReport"> <span style="color:#FF791A"> Generating the Monthly Billing Report </span> </a> </li>
    <li> <a href="#exportingData"> <span style="color:#FF791A"> Exporting the Table Data </span> </a> </li>
  </ul>
  <h1> Products </h1>
  <p> Navigation: <strong> MSSP Monthly > Products </strong> </p>
  <p> The <strong> Products </strong> page gives you a quick overview of MSSPs, Tenants, and Products registered under Tenant. </p>
  <div> <img src="${tenantMgmtMasterMsspOne}" style="height:100%;width:100%" /> </div>
  <p> The <strong> Products </strong> page summarizes the list of Tenants, and Products added under each MSSP group in a tabular form. </p>
  <p> From the <strong> Products </strong> table, you can perform the below operations on the table data: </p>
  <ul>
    <li> Filter the table data with all possible combinations, and save the filter preferences for next time log in. </li>
    <li> Refresh, and sort the table data to identify the specific results. </li>
    <li> Customize columns to show, or hide the table data. </li>
    <li> Export the table data into CSV, or XLS format. </li>
  </ul>
  <p> From the <strong> Products </strong> page, you can perform the below operations: </p>
  <ul>
    <li> Provision a new MSSP, and invite a new MSSP. </li>
    <li> Provision Tenant, and Product. </li>
    <li> Edit details of the MSSP, and Tenant. </li>
    <li> Launch CSC Product Console </li>
    <li> Modify the allocation of licensed units, expiry date, and service type (if applicable) of the Product. </li>
    <li> Download the Product details of the Tenant into CSV, or XLS format. </li>
    <li> Transfer the Product to another Tenant. </li>
    <li> Delete the Product. </li>
    <li> Remove the Product from MSSP Monthly. </li>
  </ul>

  <p> <strong> Default page: </strong> </p>
  <p> The <strong> Products </strong> page summarizes the provisioned MSSPs, Tenants provisioned under each MSSP, and
      Products provisioned for each of the Tenant </p>
  <ul>
    <li> The <strong> Products </strong> table includes <strong> MSSP, TENANT, SERVICE, LICENSED UNITS, STATUS, </strong> and
    <strong> EXPIRY DATE. </strong> </li>
    <li> <strong> Usage, Serial Number, FRIENDLY NAME, FIRMWARE, PRODUCT, </strong> and <strong> START DATE </strong> are not shown in
    the default view. To show them in the table, click the <strong> Customize Columns </strong> icon, and check the boxes to
    view the required details. </li>
  </ul>
  <div> <img src="${tenantMgmtMasterMsspTwo}" style="height:100%;width:100%"/> </div>
  <p> You can filter, refresh, export, and customize the table data with the help of the options available on top of the
  table. </p>

  <p> <strong> Topics: </strong> </p>
  <ul>
    <li> <a href="#optionsForProducts"> <span style="color:#FF791A"> Options for Products </span> </a> </li>
    <li> <a href="#quickFilter"> <span style="color:#FF791A"> Quick Filter </span> </a> </li>
    <li> <a href="#customizingData"> <span style="color:#FF791A"> Customizing the Table Data </span> </a> </li>
    <li> <a href="#interpretingProducts"> <span style="color:#FF791A"> Interpreting the Products Table </span> </a> </li>
    <li> <a href="#provisioningMssp"> <span style="color:#FF791A"> Provisioning MSSP, Tenant, and Product </span> </a> </li>
    <li> <a href="#editingMssp"> <span style="color:#FF791A"> Editing MSSP, Tenant, or Product Details </span> </a> </li>
    <li> <a href="#deletingProduct"> <span style="color:#FF791A"> Deleting Product </span> </a> </li>
    <li> <a href="#sortingData"> <span style="color:#FF791A"> Sorting the Table Data </span> </a> </li>
    <li> <a href="#exportingData"> <span style="color:#FF791A"> Exporting the Table Data </span> </a> </li>
  </ul>

  <h1 id="optionsForProducts"> Options for Products </h1>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-filter" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Quick Filter </strong> icon to filter the table data for specific results per <a href="#quickFilter"> <span style="color:#FF791A"> Quick Filter </span> </a>
          groups, and save the filter preferences for next time log in. You can apply these filter groups either individually,
          or in combination to find the specific results.
        </td>
      </tr>

      <tr>
        <td style="text-align:right;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <div style="display:flex;align-items:center">
            <span class="sw-icon__inner sw-font-icon icon-arrow-up" style="font-size:2rem;transform: rotateZ(180deg);"></span>
          </div>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Drop-down </strong> icon to select a specific MSSP, and Tenant from the list.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-search" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Search </strong> icon to filter the table data with a specific string.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-refresh" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Refresh </strong> icon to get the most recent data in the table.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-export" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Export </strong> icon to export the table data into CSV, or XLS format.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-options" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Customize Columns </strong> icon to view additional fields available to
          show, or hide the details in the table data - <strong> Usage, Serial NUMBER, FRIENDLY
          NAME, FIRMWARE, PRODUCT, START DATE. </strong>
        </td>
      </tr>
    </tbody>
  </table>

  <h1 id="quickFilter"> Quick Filter </h1>
  <p> Use the <strong> Quick Filter </strong> option if you are looking for details of any single group, or combination of the groups listed below. </p>
  <div> <img src="${tenantMgmtMasterMsspThree}" style="height:100%;width:100%"/> </div>
  <p> <strong> Filter Groups </strong> </p>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Group Name </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          PRODUCTS
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> PRODUCTS </strong> group displays the list of products available under MSSP Monthly.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          SERVICES
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> SERVICES </strong> group displays the complete list of services available for the
          products listed under <strong> PRODUCTS </strong> group.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          LICENSED UNITS
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> LICENSED UNITS </strong> group allows to enter the minimum, and maximum
          number of licensed units.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          START DATE
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> START DATE </strong> group allows to select the start date of the service.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          EXPIRY DATE
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> EXPIRY DATE </strong> group allows to select the expiry date of the service.
        </td>
      </tr>
    </tbody>
  </table>

  <p> <strong style="font-style:italic"> To Filter Data by Quick Filter: </i> </strong> </p>
  <ol>
    <li> Click the <strong> Quick Filter </strong> icon available at top left corner of the table. </li>
    <li> Select the required filter options. </li>
    <li> Click <strong> Apply </strong> to set the filter preferences only for this time, otherwise, click <strong>  Save & Apply </strong>
    to set, and save the filter preferences for next time log in. </li>
    <span> <strong> NOTE: </strong> Saved filter preferences are applied until you choose to <strong> Clear </strong>, and <strong> Save & Apply. </strong> </span>
    <li> Click <strong> Clear </strong> to clear the filter selection. </li>
    <div style="margin-left:-15px"> <strong> NOTE: </strong> </div>
    <ul>
      <li> To show, or hide the filter groups at any point, click the <strong> Quick Filter </strong> icon available at top-left corner of
      the table. </li>
      <li> If none of the filter group is selected from the <strong> Quick Filter </strong>, the table displays the details for all filter groups. </li>
    </ul>
  </ol>

  <h1 id="customizingData"> Customizing the Table Data </h1>
  <p> You can customize the <strong> Products </strong> table to show, or hide the <strong> Usage, Serial Number, FRIENDLY NAME,
  FIRMWARE, PRODUCT </strong> , or <strong> START DATE </strong> details. By default, these details are not shown in the <strong> Products </strong>
  table. Click the <strong> Customize Columns </strong> icon, and check the boxes to view the required details. </p>
  <div> <img src="${tenantMgmtFour}" style="height:100%"/> </div>
  <p> <strong>  NOTE: </strong> Once you check the boxes, the selected details remains checked, and shows in the table data for
  next time log in until you change the preferences. </p>

  <h1 id="provisioningMssp"> Provisioning MSSP, Tenant, and Product </h1>
  <p> Navigation: <strong> MSSP Monthly > Products </strong> </p>
  <p> <strong> Topics: </strong> </p>
  <ul>
    <li> <a href="#provisioningMssp"> <span style="color:#FF791A"> Provisioning MSSP </span> </a> </li>
    <li> <a href="#provisioningTenant"> <span style="color:#FF791A"> Provisioning Tenant </span> </a> </li>
    <li> <a href="#provisioningProduct"> <span style="color:#FF791A"> Provisioning Product </span> </a> </li>
  </ul>

  <h1 id="provisioningMssp"> Provisioning MSSP </h1>
  <p> You can invite a new MSSP to your MySonicWall account, or you can add. </p>
  <p> <strong style="font-style:italic"> To add MSSP: </i> </strong> </p>
  <ol>
    <li> Click <strong> Provision > MSSP. </strong> </li>
    <li> Enter details of the new MSSP. </li>
    <li> Do one of the following: </li>
    <ul>
      <li> Click <strong> Save & Close </strong> to add the MSSP, and close the window  </li>
      <li> Click <strong> Next: Add Tenant </strong> to add the MSSP, and proceed with addition of a new Tenant under that MSSP. </li>
    </ul>
    <li> On successful saving, you get <strong> SUCCESS </strong> notification per below: </li>
    <ul>
      <li> If you add a new user who does not have a MySonicWall account. </li>
        <div> <img src="${tenantMgmtMasterMsspFour}" style="height:100%;width:100%"/> </div>
        <span> <strong> NOTE: </strong> Now the new MSSP is added to your <strong> All MSSP </strong> list, but you cannot add Tenant until
          the invited MSSP user completes the Sign Up. </span>
      <li> If you add an existing MySonicWall user. </li>
        <span> <strong> NOTE: </strong> Now the new MSSP is added to your <strong> All MSSP </strong> list, and you can add Tenant as needed. </span>
        <div> <img src="${tenantMgmtMasterMsspFive}" style="height:100%;width:100%"/> </div>
    </ul>
  </ol>

  <h1 id="provisioningTenant"> Provisioning Tenant </h1>
  <p> Before provisioning Tenant, make sure the MSSP is provisioned under which you want to provision the Tenant. If the MSSP is not provisioned,
    follow per <a href="#provisioningMssp"> <span style="color:#FF791A"> Provisioning MSSP. </span> </a> </p>
  <ol>
    <li> Click <strong> Provision > Tenant. </strong> </li>
    <li> Select the <strong> MSSP Name </strong> from the list. </li>
    <li> Enter details of the new Tenant. </li>
    <li> Do one of the following: </li>
    <ul>
      <li> Click <strong> Save & Close </strong>  to add the <strong> Tenant. </strong>  </li>
      <li> Click <strong> Next: Add Product </strong> to add the Tenant, and proceed with addition of <strong> Product. </strong>  </li>
    </ul>
    <span> You are prompted for <strong> Address Confirmation </strong> if you have not entered the standard address. </span>
    <li> Click <strong> Return to previous page to try again </strong> to edit the address, else click <strong> USE THIS ADDRESS </strong> to add
    Tenant. </li>
  </ol>

  <h1 id="provisioningProduct"> Provisioning Product </h1>
  <p> Currently SonicWall offers the below listed <strong> Products, </strong> and <strong> Services </strong> on <strong> MSSP Monthly </strong> program.
    You can provision any of the <strong> Products </strong>, and <strong> Services </strong>.</p>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;width:100%">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Product </th>
        <th style="text-align:center;border-top: 1px solid #ddd;border-collapse: collapse;" colspan="3"> Service </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Capture Client </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Premier </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Advanced </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Cloud App Security </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Basic </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Advanced </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Cloud Edge </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Secure Access </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Hosted Email Security </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Advanced </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> NSv Virtual Firewall 200 </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Basic </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Total Secure </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Total Secure Advanced </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> NSv Virtual Firewall 270 </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Essential </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Advanced </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> NSv Virtual Firewall 400 </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Basic </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Total Secure </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Total Secure Advanced </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> NSv Virtual Firewall 470 </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Essential </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Advanced </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> NSv Virtual Firewall 50 </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Basic </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Total Secure </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Total Secure Advanced </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Secure Mobile Access 1000v </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> CMS Pooled License </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>
    </tbody>
  </table>

  <p> <strong style="font-style:italic"> To add Product: </i> </strong> </p>
  <ol>
    <li> Click <strong> Provision > Product. </strong> </li>
    <li> Select the <strong> MSSP Name, and Tenant Name </strong> under which you want to add the Product. </li>
    <li> Select the required <strong> Product </strong> from the list. </li>
      <ol type="a">
        <li> For NSv Virtual Firewall 200/400, select the <strong> Platform </strong> from list. </li>
      </ol>
    <span> <strong> NOTE: </strong> The NSv Virtual Firewall 200/400 is available for <strong> VMWare, Azure, </strong>  and
      <strong> KVM </strong> platforms. </strong> </span>
    <li> Select the required <strong> Service </strong> from the list. </li>
      <ol type="a">
        <li> For the Basic Service of the Cloud App Security, select the <strong> Application </strong> from list. </li>
      </ol>
    <span> <strong> NOTE: </strong> Basic Service of Cloud App Security is available for <strong> Office 365, </strong>  and <strong> Google </strong>
      applications. </span>
    <li> Enter the Friendly Name of the Product. </li>
    <span> <strong> NOTE: </strong> For the <strong> Capture Client, </strong> the <strong> Friendly Name </strong> gets generated automatically with
      <strong> Product - Tenant Name </strong> combination. </span>
    <li> For <strong> Cloud App Security, </strong> and <strong> Cloud Edge, </strong> enter the Sub <strong> domain name. </strong> </li>
    <li> Enter the number of <strong> Licensed Units </strong> to be provisioned. </li>
      <ol type="a">
        <li> For the <strong> Capture Client, </strong> you can select <strong> Set upper limit </strong> to enter the maximum allowable units, or
          select strong> No upper limit </strong> to use as many units as needed for the deployment </li>
      </ol>
    <li> Select the <strong> Expiry </strong> date of the Product. </li>
    <li> For <strong> Capture Client, Cloud App Security, </strong> and <strong> Cloud Edge, </strong> select the applicable
      <strong> Data Center. </strong> </li>
    <li> Click <strong> Provision </strong> to add the Product, and close the window. </li>
    <li> Check <strong> STATUS </strong> of the added Product in the <strong> Products </strong> table. </li>
      <ul>
        <li> <strong> Active - </strong> The Product is successfully provisioned, and ready to use. </li>
        <li> <strong> Provisioning in progress </strong> - The Product provisioning is in progress. Wait until the status is
          changed to Active to use the Product. </li>
      </ul>
      <span> <strong> NOTE: </strong> You can find the <strong> CSC Console </strong> icon for the <strong> Active </strong> Products except for NSv Products. </span>
  </ol>

  <h1 id="interpretingProducts"> Interpreting the Products Table </h1>
  <p> From the <strong> Products </strong> table, you can perform the below list of operations. </p>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem;display:flex;justify-contents:start" width="150">
          <div>
            <span class="sw-icon__inner sw-font-icon icon-pencil" style="font-size:2rem"></span>
          </div>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Edit </strong> icon to edit MSSP, Tenant, and Product details.
          <ul>
            <li> To edit MSSP, or Tenant details, point to the required MSSP, or Tenant name in the table, and click <strong> Edit </strong> icon. </li>
            <li> To edit Product details, click <strong> Edit </strong> icon available at end of the Product row.
              You can edit the provisioned licensed units, expiry date, and service of the
            Product. </li>
          </ul>
        </td>
      </tr>

      <tr>
        <td style="text-align:right;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <div style="display:flex;align-items:center">
            <span class="sw-icon__inner sw-font-icon icon-monitoring" style="font-size:2rem"></span>
          </div>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> CSC Console </strong> icon to connect to respective product console.
        </td>
      </tr>

      <tr>
        <td style="text-align:right;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem;display:flex;justify-contents:start" width="150">
          <div>
            <span class="sw-icon__inner sw-font-icon icon-menu" style="font-size:2rem"></span>
          </div>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> More Actions </strong> icon to:
          <div style="display:flex;align-items:center;border-top:1px solid #ddd">
            <div> <span class="sw-icon__inner sw-font-icon icon-trash" style="font-size:2rem"></span> </div>
            <div> <ul> <li> <strong> Delete </strong> the Product. </li> </ul> </div>
          </div>
          <div style="display:flex;align-items:center;border-top:1px solid #ddd">
            <div> <span class="sw-icon__inner sw-font-icon icon-download" style="font-size:2rem"></span> </div>
            <div> <ul> <li> <strong> Download </strong> the Products details into CSV, or XLS format. </li> </ul> </div>
          </div>
          <div style="display:flex;align-items:center;border-top:1px solid #ddd">
            <div> <span class="sw-icon__inner sw-font-icon icon-topo-change" style="font-size:2rem"></span> </div>
            <div> <ul> <li> <strong> Transfer </strong> the Product to another Tenant.</li> </ul> </div>
          </div>
          <div style="display:flex;align-items:center;border-top:1px solid #ddd">
            <div> <span class="sw-icon__inner sw-font-icon icon-app-remove" style="font-size:2rem"></span> </div>
            <div> <ul> <li> <strong> Remove </strong> the Product from <strong> MSSP Monthly. </strong> </li> </ul> </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <h1 id="editingMssp"> Editing MSSP, Tenant, or Product Details </h1>
  <p> <strong> Topics: </strong> </p>
  <ul>
    <li> <a href="#editingMssp"> <span style="color:#FF791A"> Editing MSSP Details </span> </a> </li>
    <li> <a href="#editingTenant"> <span style="color:#FF791A"> Editing Tenant Details </span> </a> </li>
    <li> <a href="#editingProduct"> <span style="color:#FF791A"> Editing Product Details </span> </a> </li>
  </ul>

  <h1 id="editingMssp"> Editing MSSP Details </h1>
  <ol>
    <li> Point to the required <strong> MSSP </strong> name in the table, and click <strong> Edit </strong> icon. </li>
    <div> <img src="${tenantMgmtMasterMsspSix}" style="height:100%;width:100%"/> </div>
    <li> Make the necessary changes, and click <strong> Save </strong>. </li>
  </ol>

  <h1 id="editingTenant"> Editing Tenant Details </h1>
  <ol>
    <li> Point to the required <strong> Tenant </strong> name in the table, and click <strong> Edit </strong> icon. </li>
    <div> <img src="${tenantMgmtMasterMsspSeven}" style="height:100%;width:100%"/> </div>
    <li> Make the necessary changes, and click <strong> Save </strong>. </li>
  </ol>

  <h1 id="editingProduct"> Editing Product Details </h1>
  <ol>
    <li> Click <strong> Edit </strong> icon in the table for editing the <strong> Product </strong>. </li>
    <div> <img src="${tenantMgmtMasterMsspEight}" style="height:100%;width:100%"/> </div>
    <li> Update the provisioned <strong> Licensed Units, Expiry </strong> date, or <strong> Service </strong> of the Product as required. </li>
    <li> Click <strong> Save </strong>. </li>
  </ol>

  <h1 id="deletingProduct"> Deleting Product </h1>
  <ol>
    <li> Click <strong> More Actions </strong> icon in the table. </li>
    <li> Click <strong> Delete </strong> icon to delete the product. </li>
    <div> <img src="${tenantMgmtMasterMsspNine}" style="height:100%;width:100%"/> </div>
    <li> Select the reason for deleting the product, and click <strong> Delete </strong>. </li>
  </ol>

  <h1 id="sortingData"> Sorting the Table Data </h1>
  <p> Click the table headings to sort the data in ascending, or descending order. </p>

  <h1 id="exportingData"> Exporting the Table Data </h1>
  <p> You can export the filtered table data into CSV, or XLS format. </p>
  <p> To export the table data, click the <strong> Export </strong> icon, and select <strong> Export CSV </strong> or <strong> Export XLS </strong>. </p>
</div>`;

export const regularMsspUserGuide =
`<div>
  <h1> Overview </h1>
  <p> Welcome to the SonicWall MSSP Monthly User Guide. This guide is applicable for MySonicWall users who have MSSP permissions </p>
  <p> This guide helps you provision and manage Tenant, and Product. It also helps you generate the monthly billing reports by Tenant </p>
  <p> With help of this guide , you can perform the below listed operations: </p>
  <ul>
    <li> <a href="#provisioningTenantProduct"> <span style="color:#FF791A"> Provisioning Tenant, and Product </span> </a> </li>
    <li> <a href="#editingTenantProduct"> <span style="color:#FF791A"> Editing Tenant, or Product Details </span> </a> </li>
    <li> <a href="#deletingProduct"> <span style="color:#FF791A"> Deleting Product </span> </a> </li>
    <li> <a href="#generatingBillingReport"> <span style="color:#FF791A"> Generating the Monthly Billing Report </span> </a> </li>
    <li> <a href="#exportingData"> <span style="color:#FF791A"> Exporting the Table Data </span> </a> </li>
  </ul>

  <h1> Products </h1>
  <p> Navigation: <strong> MSSP Monthly > Products </strong> </p>
  <p> The <strong> Products </strong> page gives you a quick overview of Tenants, and Products registered under Tenant. </p>
  <div> <img src="${tenantMgmtOne}" style="height:100%;width:100%" /> </div>
  <p> The <strong> Products </strong> page summarizes the list of Products added under each Tenant group in a tabular form. </p>
  <p> From the <strong> Products </strong> table, you can perform the below operations on the table data: </p>
  <ul>
    <li> Filter the table data with all possible combinations, and save the filter preferences for next time log in. </li>
    <li> Refresh, and sort the table data to identify the specific results. </li>
    <li> Customize columns to show, or hide the table data. </li>
    <li> Export the table data into CSV, or XLS format. </li>
  </ul>
  <p> From the <strong> Products </strong> page, you can perform the below operations: </p>
  <ul>
    <li> Provision Tenant, and Product. </li>
    <li> Edit details of the Tenant. </li>
    <li> Launch CSC Product Console </li>
    <li> Modify the allocation of licensed units, expiry date, and service type (if applicable) of the Product. </li>
    <li> Download the Product details of the Tenant into CSV, or XLS format. </li>
    <li> Transfer the Product to another Tenant. </li>
    <li> Delete the Product. </li>
    <li> Remove the Product from MSSP Monthly. </li>
  </ul>

  <p> <strong> Default page: </strong> </p>
  <p> The <strong> Products </strong> page summarizes the list of Products added under each Tenant. </p>
  <ul>
  <li> The <strong> Products </strong> table includes <strong> TENANT, SERVICE, LICENSED UNITS, STATUS, </strong> and
  <strong> EXPIRY DATE. </strong> </li>
  <li> <strong> Usage, Serial NUMBER, FRIENDLY NAME, FIRMWARE, PRODUCT, </strong> and <strong> START DATE </strong> are not shown in
  the default view. To show them in the table, click the <strong> Customize Columns </strong> icon, and check the boxes to
  view the required details. </li>
  </ul>
  <div> <img src="${tenantMgmtTwo}" style="height:100%;width:100%"/> </div>
  <p> You can filter, refresh, export, and customize the table data with the help of the options available on top of the
  table. </p>

  <p> <strong> Topics: </strong> </p>
  <ul>
    <li> <a href="#optionsForProducts"> <span style="color:#FF791A"> Options for Products </span> </a> </li>
    <li> <a href="#quickFilter"> <span style="color:#FF791A"> Quick Filter </span> </a> </li>
    <li> <a href="#customizingData"> <span style="color:#FF791A"> Customizing the Table Data </span> </a> </li>
    <li> <a href="#interpretingProducts"> <span style="color:#FF791A"> Interpreting the Products Table </span> </a> </li>
    <li> <a href="#provisioningTenantProduct"> <span style="color:#FF791A"> Provisioning Tenant, and Product </span> </a> </li>
    <li> <a href="#editingTenantProduct"> <span style="color:#FF791A"> Editing Tenant, or Product Details </span> </a> </li>
    <li> <a href="#deletingProduct"> <span style="color:#FF791A"> Deleting Product </span> </a> </li>
    <li> <a href="#sortingData"> <span style="color:#FF791A"> Sorting the Table Data </span> </a> </li>
    <li> <a href="#exportingData"> <span style="color:#FF791A"> Exporting the Table Data </span> </a> </li>
  </ul>

  <h1 id="optionsForProducts"> Options for Products </h1>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-filter" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Quick Filter </strong> icon to filter the table data for specific results per <a href="#quickFilter"> <span style="color:#FF791A"> Quick Filter </span> </a>
          groups, and save the filter preferences for next time log in. You can apply these filter groups either individually,
          or in combination to find the specific results.
        </td>
      </tr>

      <tr>
        <td style="text-align:right;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <div style="display:flex;align-items:center">
            <span class="sw-icon__inner sw-font-icon icon-arrow-up" style="font-size:2rem;transform: rotateZ(180deg);"></span>
          </div>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Drop-down </strong> icon to select a specific Tenant from the list.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-search" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Search </strong> icon to filter the table data with a specific string.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-refresh" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Refresh </strong> icon to get the most recent data in the table.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-export" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Export </strong> icon to export the table data into CSV, or XLS format.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-options" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Customize Columns </strong> icon to view additional fields available to
          show, or hide the details in the table data - <strong> Usage, Serial NUMBER, FRIENDLY
          NAME, FIRMWARE, PRODUCT, START DATE. </strong>
        </td>
      </tr>
    </tbody>
  </table>

  <h1 id="quickFilter"> Quick Filter </h1>
  <p> Use the <strong> Quick Filter </strong> option if you are looking for details of any single group, or combination of the groups listed below. </p>
  <div> <img src="${tenantMgmtThree}" style="height:100%;width:100%"/> </div>
  <p> <strong> Filter Groups </strong> </p>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Group Name </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          PRODUCTS
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> PRODUCTS </strong> group displays the list of products available under MSSP Monthly.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          SERVICES
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> SERVICES </strong> group displays the complete list of services available for the
          products listed under <strong> PRODUCTS </strong> group.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          LICENSED UNITS
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> LICENSED UNITS </strong> group allows to enter the minimum, and maximum
          number of licensed units.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          START DATE
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> START DATE </strong> group allows to select the start date of the service.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          EXPIRY DATE
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> EXPIRY DATE </strong> group allows to select the expiry date of the service.
        </td>
      </tr>
    </tbody>
  </table>

  <p> <strong style="font-style:italic"> To Filter Data by Quick Filter: </i> </strong> </p>
  <ol>
    <li> Click the <strong> Quick Filter </strong> icon available at top left corner of the table. </li>
    <li> Select the required filter options. </li>
    <li> Click <strong> Apply </strong> to set the filter preferences only for this time, otherwise, click <strong>  Save & Apply </strong>
    to set, and save the filter preferences for next time log in. </li>
    <span> <strong> NOTE: </strong> Saved filter preferences are applied until you choose to <strong> Clear </strong>, and <strong> Save & Apply. </strong> </span>
    <li> Click <strong> Clear </strong> to clear the filter selection. </li>
    <div style="margin-left:-15px"> <strong> NOTE: </strong> </div>
    <ul>
      <li> To show, or hide the filter groups at any point, click the <strong> Quick Filter </strong> icon available at top-left corner of
      the table. </li>
      <li> If none of the filter group is selected from the <strong> Quick Filter </strong>, the table displays the details for all filter groups. </li>
    </ul>
  </ol>

  <h1 id="customizingData"> Customizing the Table Data </h1>
  <p> You can customize the <strong> Products </strong> table to show, or hide the <strong> Usage, Serial NUMBER, FRIENDLY NAME,
  FIRMWARE, PRODUCT </strong> , or <strong> START DATE </strong> details. By default, these details are not shown in the <strong> Products table. </strong> table.
  Click the <strong> Customize Columns </strong> icon, and check the boxes to view the required details. </p>
  <div> <img src="${tenantMgmtFour}" style="height:100%"/> </div>
  <p> <strong>  NOTE: </strong> Once you check the boxes, the selected details remains checked, and shows in the table data for
  next time log in until you change the preferences. </p>

  <h1 id="provisioningTenantProduct"> Provisioning Tenant, and Product </h1>
  <p> Navigation: <strong> MSSP Monthly > Products </strong> </p>
  <p> <strong> Topics: </strong> </p>
  <ul>
    <li> <a href="#provisioningTenant"> <span style="color:#FF791A"> Provisioning Tenant </span> </a> </li>
    <li> <a href="#provisioningProduct"> <span style="color:#FF791A"> Provisioning Product </span> </a> </li>
  </ul>

  <h1 id="provisioningTenant"> Provisioning Tenant </h1>
  <ol>
    <li> Click <strong> Provision > Tenant. </strong> </li>
    <li> Enter details of the new Tenant. </li>
    <li> Do one of the following: </li>
    <ul>
    <li> Click <strong> Save & Close </strong>  to add the <strong> Tenant. </strong>  </li>
    <li> Click <strong> Next: Add Product </strong>  to add the Tenant, and proceed with addition of <strong> Product. </strong>  </li>
    </ul>
    <span> You are prompted for <strong> Address Confirmation </strong> if you have not entered the standard address. </span>
    <li> Click <strong> Return to previous page to try again </strong> to edit the address, else click <strong> USE THIS ADDRESS </strong> to add
    Tenant. </li>
  </ol>

  <h1 id="provisioningProduct"> Provisioning Product </h1>
  <p> Currently SonicWall offers the below listed <strong> Products, </strong> and <strong> Services </strong> on <strong> MSSP Monthly </strong> program.
  You can provision any of the <strong> Products </strong>, and <strong> Services </strong>.</p>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;width:100%">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Product </th>
        <th style="text-align:center;border-top: 1px solid #ddd;border-collapse: collapse;" colspan="3"> Service </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Capture Client </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Premier </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Advanced </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Cloud App Security </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Basic </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Advanced </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Cloud Edge </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Secure Access </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Hosted Email Security </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Advanced </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> NSv Virtual Firewall 200 </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Basic </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Total Secure </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Total Secure Advanced </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> NSv Virtual Firewall 270 </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Essential </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Advanced </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> NSv Virtual Firewall 400 </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Basic </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Total Secure </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Total Secure Advanced </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> NSv Virtual Firewall 470 </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Essential </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Advanced </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> NSv Virtual Firewall 50 </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Basic </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Total Secure </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Total Secure Advanced </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> Secure Mobile Access 1000v </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> CMS Pooled License </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> </td>
      </tr>
    </tbody>
  </table>

  <p> <strong style="font-style:italic"> To add Product: </i> </strong> </p>
  <ol>
    <li> Click <strong> Provision > Product. </strong> </li>
    <li> Select the <strong> Tenant Name </strong> under which you want to add the Product. </li>
    <li> Select the required <strong> Product </strong> from the list. </li>
      <ol type="a">
        <li> For NSv Virtual Firewall 200/400, select the <strong> Platform </strong> from list. </li>
      </ol>
    <span> <strong> NOTE: </strong> The NSv Virtual Firewall 200/400 is available for <strong> VMWare, Azure, </strong>  and
      <strong> KVM </strong> platforms. </strong> </span>
    <li> Select the required <strong> Service </strong> from the list. </li>
      <ol type="a">
        <li> For the Basic Service of the Cloud App Security, select the <strong> Application </strong> from list. </li>
      </ol>
    <span> <strong> NOTE: </strong> Basic Service of Cloud App Security is available for <strong> Office 365, </strong>  and <strong> Google </strong>
      applications. </span>
    <li> Enter the Friendly Name of the Product. </li>
    <span> <strong> NOTE: </strong> For the <strong> Capture Client, </strong> the <strong> Friendly Name </strong> gets generated automatically with
      <strong> Product - Tenant Name </strong> combination. </span>
    <li> For <strong> Cloud App Security, </strong> and <strong> Cloud Edge, </strong> enter the Sub  <strong> domain name. </strong> </li>
    <li> Enter the number of <strong> Licensed Units </strong> to be provisioned. </li>
      <ol type="a">
        <li> For the <strong> Capture Client, </strong> you can select <strong> Set upper limit </strong> to enter the maximum allowable units, or
          select strong> No upper limit </strong> to use as many units as needed for the deployment. </li>
      </ol>
    <li> Select the <strong> Expiry </strong> date of the Product. </li>
    <li> For <strong> Capture Client, Cloud App Security, </strong> and <strong> Cloud Edge, </strong> select the applicable
      <strong> Data Center. </strong> </li>
    <li> Click <strong> Provision </strong> to add the Product, and close the window. </li>
    <li> Check <strong> STATUS </strong> of the added Product in the <strong> Tenant Management </strong> table. </li>
      <ul>
        <li> <strong> Active - </strong> The Product is successfully provisioned, and ready to use. </li>
        <li> <strong> Provisioning in progress </strong> - The Product provisioning is in progress. Wait until the status is
          changed to Active to use the Product. </li>
      </ul>
      <span> <strong> NOTE: </strong> You can find the <strong> CSC Console </strong> icon for the <strong> ACTIVE </strong> Products except for NSv Products. </span>
  </ol>

  <h1 id="interpretingProducts"> Interpreting the Products Table </h1>
  <p> From the <strong> Tenant Management </strong> table, you can perform the below list of operations. </p>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem;display:flex;justify-contents:start" width="150">
          <div>
            <span class="sw-icon__inner sw-font-icon icon-pencil" style="font-size:2rem"></span>
          </div>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Edit </strong> icon to edit Tenant, and Product details.
          <ul>
            <li> To edit Tenant details, point to the required Tenant name in the table, and click <strong> Edit </strong> icon. </li>
            <li> To edit Product details, click <strong> Edit </strong> icon available at end of the Product row.
              You can edit the provisioned licensed units, expiry date, and service of the
            Product. </li>
          </ul>
        </td>
      </tr>

      <tr>
        <td style="text-align:right;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <div style="display:flex;align-items:center">
            <span class="sw-icon__inner sw-font-icon icon-monitoring" style="font-size:2rem"></span>
          </div>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> CSC Console </strong> icon to connect to respective product console.
        </td>
      </tr>

      <tr>
        <td style="text-align:right;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem;display:flex;justify-contents:start" width="150">
          <div>
            <span class="sw-icon__inner sw-font-icon icon-menu" style="font-size:2rem"></span>
          </div>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> More Actions </strong> icon to:
          <div style="display:flex;align-items:center;border-top:1px solid #ddd">
            <div> <span class="sw-icon__inner sw-font-icon icon-trash" style="font-size:2rem"></span> </div>
            <div> <ul> <li> <strong> Delete </strong> the Product. </li> </ul> </div>
          </div>
          <div style="display:flex;align-items:center;border-top:1px solid #ddd">
            <div> <span class="sw-icon__inner sw-font-icon icon-download" style="font-size:2rem"></span> </div>
            <div> <ul> <li> <strong> Download </strong> the Products details into CSV, or XLS format. </li> </ul> </div>
          </div>
          <div style="display:flex;align-items:center;border-top:1px solid #ddd">
            <div> <span class="sw-icon__inner sw-font-icon icon-topo-change" style="font-size:2rem"></span> </div>
            <div> <ul> <li> <strong> Transfer </strong> the Product to another Tenant.</li> </ul> </div>
          </div>
          <div style="display:flex;align-items:center;border-top:1px solid #ddd">
            <div> <span class="sw-icon__inner sw-font-icon icon-app-remove" style="font-size:2rem"></span> </div>
            <div> <ul> <li> <strong> Remove </strong> the Product from <strong> MSSP Monthly. </strong> </li> </ul> </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <h1 id="editingTenantProduct"> Editing Tenant, or Product Details </h1>
  <p> <strong> Topics: </strong> </p>
  <ul>
    <li> <a href="#editingTenant"> <span style="color:#FF791A"> Editing Tenant Details </span> </a> </li>
    <li> <a href="#editingProduct"> <span style="color:#FF791A"> Editing Product Details </span> </a> </li>
  </ul>

  <h1 id="editingTenant"> Editing Tenant Details </h1>
  <ol>
    <li> Point to the required <strong> Tenant </strong> name in the table, and click <strong> Edit </strong> icon. </li>
    <div> <img src="${tenantMgmtFive}" style="height:100%;width:100%"/> </div>
    <li> Make the necessary changes, and click <strong> Save </strong>. </li>
  </ol>

  <h1 id="editingProduct"> Editing Product Details </h1>
  <ol>
    <li> Click <strong> Edit </strong> icon in the table for editing the <strong> Product </strong>. </li>
    <div> <img src="${tenantMgmtSix}" style="height:100%;width:100%"/> </div>
    <li> Update the provisioned <strong> Licensed Units, Expiry </strong> date, or <strong> Service </strong> of the Product as required. </li>
    <li> Click <strong> Save </strong>. </li>
  </ol>

  <h1 id="deletingProduct"> Deleting Product </h1>
  <ol>
    <li> Click <strong> More Actions </strong> icon in the table. </li>
    <li> Click <strong> Delete </strong> icon to delete the product. </li>
    <div> <img src="${tenantMgmtSeven}" style="height:100%;width:100%"/> </div>
    <li> Select the reason for deleting the product, and click <strong> Delete </strong>. </li>
  </ol>

  <h1 id="sortingData"> Sorting the Table Data </h1>
  <p> Click the table headings to sort the data in ascending, or descending order. </p>

  <h1 id="exportingData"> Exporting the Table Data </h1>
  <p> You can export the filtered table data into CSV, or XLS format. </p>
  <p> To export the table data, click the <strong> Export </strong> icon, and select <strong> Export CSV </strong> or <strong> Export XLS </strong>. </p>
</div>`;

export const regularBillingReport =
`<div>
  <h1> Billing Report </h1>
  <p> Navigation: <strong> MSSP Monthly > Billing Report </strong> </p>
  <p> The <strong> Billing Report </strong> page gives you an overview of the monthly billing of the Products in a tabular form. </p>
  <p> The <strong> Billing Report </strong> captures the count on 25th day of every month to prepare billing per below: </p>
    <ul>
      <li> Captures the count of the endpoints commissioned, or installed for Capture Client. </li>
      <li> Captures count of the provisioned licenses for Cloud App Security, Cloud Edge, Hosted Email Security, NSv, SMA </li>
    </ul>
  <p> The <strong> Billing Report </strong> stores the data for last 24 months. </p>
  <p> From the <strong> Billing Report </strong> table, you can filter, save the filter preferences, and export the billing of the Products for
  a month, or multiple months in a year. You can also filter the table data for a specific Tenant. </p>

  <p> <strong> Default page: </strong> </p>
  <p> The <strong> Billing Report </strong> page gives you an overview on the Billing of the Products for previous month of the current
  year in a tabular form. </p>
  <p> You can filter, save the filter preferences, and export the table data with the help of the options available on top of
  the table. </p>
  <p> <strong> Topics: </strong> </p>
  <ul>
    <li> <a href="#optionsForBilling"> <span style="color:#FF791A"> Options for Billing Report </span> </a> </li>
    <li> <a href="#quickFilter"> <span style="color:#FF791A"> Quick Filter </span> </a> </li>
    <li> <a href="#generatingBillingReport"> <span style="color:#FF791A"> Generating the Monthly Billing Report </span> </a> </li>
    <li> <a href="#sortingData"> <span style="color:#FF791A"> Sorting the Table Data </span> </a> </li>
    <li> <a href="#exportingData"> <span style="color:#FF791A"> Exporting the Table Data </span> </a> </li>
  </ul>

  <h1 id="optionsForBilling"> Options for Billing Report </h1>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-filter" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Quick Filter </strong> icon to filter the table data for specific results per <a href="#quickFilter"> <span style="color:#FF791A"> Quick Filter </span> </a>
          groups, and save the filter preferences for next time log in. You can apply these filter groups either individually,
          or in combination to find the specific notification results.
        </td>
      </tr>

      <tr>
        <td style="text-align:right;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <div style="display:flex;align-items:center">
            <span class="sw-icon__inner sw-font-icon icon-arrow-up" style="font-size:2rem;transform: rotateZ(180deg);"></span>
          </div>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Drop-down </strong> icon to select a specific Tenant from the list.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-search" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Search </strong> icon to filter the table data with a specific string.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-export" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Export </strong> icon to export the table data into CSV, or XLS format.
        </td>
      </tr>
    </tbody>
  </table>

  <h1 id="quickFilter"> Quick Filter </h1>
  <p> Use the <strong> Quick Filter </strong> option if you are looking for details of any single group, or combination of the groups listed below. </p>
  <div> <img src="${usageReportOne}" style="height:100%;width:100%"/> </div>
  <p> <strong> Filter Groups </strong> </p>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Group Name </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          PRODUCTS
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> PRODUCTS </strong> group displays the list of products available under MSSP Monthly.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          SERVICES
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> SERVICES </strong> group displays the complete list of services available for the
          products listed under <strong> PRODUCTS </strong> group.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          LICENSED UNITS
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> LICENSED UNITS </strong> group gives an opportunity to enter the minimum, and
          maximum number of units.
        </td>
      </tr>
    </tbody>
  </table>

  <p> <strong style="font-style:italic"> To Filter Data by Quick Filter: </i> </strong> </p>
  <ol>
    <li> Click the <strong> Quick Filter </strong> icon available at top left corner of the table. </li>
    <li> Select the required filter options. </li>
    <li> Click <strong> Apply </strong> to set the filter preferences only for this time, otherwise, click <strong>  Save & Apply </strong>
    to set, and save the filter preferences for next time log in. </li>
    <span> <strong> NOTE: </strong> Saved filter preferences are applied until you choose to <strong> Clear </strong>, and <strong> Save & Apply. </strong> </span>
    <li> Click <strong> Clear </strong> to clear the filter selection. </li>
    <div style="margin-left:-15px"> <strong> NOTE: </strong> </div>
    <ul>
      <li> To show, or hide the filter groups at any point, click the <strong> Quick Filter </strong> icon available at top-left corner of
      the table. </li>
      <li> If none of the filter group is selected from the <strong> Quick Filter </strong>, the table displays the details for all filter groups. </li>
    </ul>
  </ol>

  <h1 id="generatingBillingReport"> Generating the Monthly Billing Report </h1>
  <p> Navigation: <strong> MSSP Monthly > Billing Report </strong> </p>
  <p> <strong style="font-style:italic"> To generate monthly report: </i> </strong> </p>
  <ol>
    <li> Set the required filters per <a href="#quickFilter"> <span style="color:#FF791A"> Quick Filter </span>. </a> </li>
    <li> Click the <strong> Search </strong> icon and type a search string if you are looking for any specific details. </li>
    <li> Select the required Tenant from the drop-down list. </li>
    <li> Select the month, and year from the respective drop-downs. </li>
    <span> <strong> NOTE: </strong> </span>
    <ul>
      <li> You can select a month, or multiple months for the selected year. </li>
      <li> You can filter, and view the usage report for any month in the last 24 months. </li>
    </ul>
  </ol>

  <h1 id="sortingData"> Sorting the Table Data </h1>
  <p> Click the table headings to sort the data in ascending, or descending order. </p>

  <h1 id="exportingData"> Exporting the Table Data </h1>
  <p> You can export the filtered table data into CSV, or XLS format. </p>
  <p> To export the table data, click the <strong> Export </strong> icon, and select <strong> Export CSV </strong> or <strong> Export XLS </strong>. </p>
</div>`;

export const masterBillingReport =
`<div>
  <h1> Billing Report </h1>
  <p> Navigation: <strong> MSSP Monthly > Billing Report </strong> </p>
  <p> The <strong> Billing Report </strong> page gives you an overview of the monthly billing of the Products in a tabular form. </p>
  <p> The <strong> Billing Report </strong> captures the count on 25th day of every month to prepare billing per below: </p>
    <ul>
      <li> Captures the count of the endpoints commissioned, or installed for Capture Client. </li>
      <li> Captures count of the provisioned licenses for Cloud App Security, Cloud Edge, Hosted Email Security, NSv, SMA </li>
    </ul>
  <p> The <strong> Billing Report </strong> stores the data for last 24 months. </p>
  <p> From the <strong> Billing Report </strong> table, you can filter, save the filter preferences, and export the billing of the Products for
  a month, or multiple months in a year. You can also filter the table data for a specific MSSP, or Tenant. </p>

  <p> <strong> Default page: </strong> </p>
  <p> The <strong> Billing Report </strong> page gives you an overview on the Billing of the Products for previous month of the current
  year in a tabular form. </p>
  <p> You can filter, save the filter preferences, and export the table data with the help of the options available on top of
  the table. </p>
  <p> <strong> Topics: </strong> </p>
  <ul>
    <li> <a href="#optionsForBilling"> <span style="color:#FF791A"> Options for Billing Report </span> </a> </li>
    <li> <a href="#quickFilter"> <span style="color:#FF791A"> Quick Filter </span> </a> </li>
    <li> <a href="#generatingBillingReport"> <span style="color:#FF791A"> Generating the Monthly Billing Report </span> </a> </li>
    <li> <a href="#sortingData"> <span style="color:#FF791A"> Sorting the Table Data </span> </a> </li>
    <li> <a href="#exportingData"> <span style="color:#FF791A"> Exporting the Table Data </span> </a> </li>
  </ul>

  <h1 id="optionsForBilling"> Options for Billing Report </h1>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-filter" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Quick Filter </strong> icon to filter the table data for specific results per <a href="#quickFilter"> <span style="color:#FF791A"> Quick Filter </span> </a>
          groups, and save the filter preferences for next time log in. You can apply these filter groups either individually,
          or in combination to find the specific notification results.
        </td>
      </tr>

      <tr>
        <td style="text-align:right;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <div style="display:flex;align-items:center">
            <span class="sw-icon__inner sw-font-icon icon-arrow-up" style="font-size:2rem;transform: rotateZ(180deg);"></span>
          </div>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Drop-down </strong> icon to select a specific MSSP, and Tenant from the list.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-search" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Search </strong> icon to filter the table data with a specific string.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-export" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Export </strong> icon to export the table data into CSV, or XLS format.
        </td>
      </tr>
    </tbody>
  </table>

  <h1 id="quickFilter"> Quick Filter </h1>
  <p> Use the <strong> Quick Filter </strong> option if you are looking for details of any single group, or combination of the groups listed below. </p>
  <div> <img src="${usageReportOne}" style="height:100%;width:100%"/> </div>
  <p> <strong> Filter Groups </strong> </p>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Group Name </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          PRODUCTS
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> PRODUCTS </strong> group displays the list of products available under MSSP Monthly.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          SERVICES
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> SERVICES </strong> group displays the complete list of services available for the
          products listed under <strong> PRODUCTS </strong> group.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          LICENSED UNITS
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> LICENSED UNITS </strong> group gives an opportunity to enter the minimum, and
          maximum number of units.
        </td>
      </tr>
    </tbody>
  </table>

  <p> <strong style="font-style:italic"> To Filter Data by Quick Filter: </i> </strong> </p>
  <ol>
    <li> Click the <strong> Quick Filter </strong> icon available at top left corner of the table. </li>
    <li> Select the required filter options. </li>
    <li> Click <strong> Apply </strong> to set the filter preferences only for this time, otherwise, click <strong>  Save & Apply </strong>
    to set, and save the filter preferences for next time log in. </li>
    <span> <strong> NOTE: </strong> Saved filter preferences are applied until you choose to <strong> Clear </strong>, and <strong> Save & Apply. </strong> </span>
    <li> Click <strong> Clear </strong> to clear the filter selection. </li>
    <div style="margin-left:-15px"> <strong> NOTE: </strong> </div>
    <ul>
      <li> To show, or hide the filter groups at any point, click the <strong> Quick Filter </strong> icon available at top-left corner of
      the table. </li>
      <li> If none of the filter group is selected from the <strong> Quick Filter </strong>, the table displays the details for all filter groups. </li>
    </ul>
  </ol>

  <h1 id="generatingBillingReport"> Generating the Monthly Billing Report </h1>
  <p> Navigation: <strong> MSSP Monthly > Billing Report </strong> </p>
  <p> <strong style="font-style:italic"> To generate monthly report: </i> </strong> </p>
  <ol>
    <li> Set the required filters per <a href="#quickFilter"> <span style="color:#FF791A"> Quick Filter </span>. </a> </li>
    <li> Click the <strong> Search </strong> icon and type a search string if you are looking for any specific details. </li>
    <li> Select the required MSSP, and Tenant from the drop-down list. </li>
    <li> Select the month, and year from the respective drop-downs. </li>
    <span> <strong> NOTE: </strong> </span>
    <ul>
      <li> You can select a month, or multiple months for the selected year. </li>
      <li> You can filter, and view the usage report for any month in the last 24 months. </li>
    </ul>
  </ol>

  <h1 id="sortingData"> Sorting the Table Data </h1>
  <p> Click the table headings to sort the data in ascending, or descending order. </p>

  <h1 id="exportingData"> Exporting the Table Data </h1>
  <p> You can export the filtered table data into CSV, or XLS format. </p>
  <p> To export the table data, click the <strong> Export </strong> icon, and select <strong> Export CSV </strong> or <strong> Export XLS </strong>. </p>
</div>`;

export const renewalManagerHelpGuide =
`<div>
  <h1> RenewalManager </h1>

  <p> The <strong> Renewal Manager </strong> generates the quotes for the products which are due to expire in next 180 days. From the
  <strong> Renewal Manager </strong>, you can quickly identify the status of the quote with color of the status text </p>

  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Color </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Status </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Blue </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Due </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The contract is active and the service is due for renewal in the next 60-90 days
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Orange </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Urgent </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The contract is active and the service is due for renewal in the next 30-60 days
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Red </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Overdue </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The contract is active and the service is due for renewal in the next 30 days
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Gray </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Expired </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The contract is expired
        </td>
      </tr>
    </tbody>
  </table>

  <p> The generated quote gets updated dynamically if any product of the quote is renewed, or cancelled through other channels. </p>

  <p> From the <strong> Renewal Manager </strong> table, you can: </p>
  <ul>
    <li> Filter, refresh, and export the quote details. </li>
    <li> Switch between Reseller Managed, and Program Managed </li>
    <li> View quote activity, and quote notes. </li>
    <li> View active, pending, and expired quotes from the <strong> Opportunity </strong> tab. </li>
    <li> View <strong> Booked, </strong> and <strong> Cancelled </strong> quotes from the respective tabs. </li>
  </ul>

  <p> <strong> Default page: </strong> </p>

  <p> The <strong> Renewal Manager </strong> page shows the <strong> Opportunity </strong> tab with list of quotes generated for
    the products which are due to expire in next 180 days. </p>

  <h1> Options for the Renewal Manager </h1>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-filter" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Quick Filter </strong> icon to filter the table data for specific results.
          You can apply these filter groups either individually, or in combination to find the specific notification results.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-search" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Search </strong> icon to filter the table data with a specific string.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-refresh" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Refresh </strong> icon to refresh the table data per selected filter groups.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-export" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Export </strong> icon to export the table data into CSV format.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-add" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Create New Note </strong> icon to create and add a new note for the quote.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-go-back" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Return </strong> icon to go back to previous window.
        </td>
      </tr>
    </tbody>
  </table>

  <h1> Quick Filter </h1>
  <p> Use the <strong> Quick Filter </strong> option if you are looking for quotes of any single group, or combination of the groups listed below. </p>

  <p> <strong style="font-style:italic"> To Filter Data by Quick Filter: </i> </strong> </p>

  <ol>
    <li> Select the filter groups in one of the following ways: </li>
      <ul>
        <li> Click the Quick Filter icon and select any single group. Type a search string in the field and click
          outside the field to add filter </li>
        <div style="margin-left:-15px"> <strong> NOTE: </strong> You can include all filter groups if required. </div>
        <div> <img src="${renewalManagerOne}" style="height:100%;"/> </div>
        <div> <img src="${renewalManagerTwo}" style="height:100%;width:100%"/> </div>
        <li> In the <strong> Renewal Manager </strong> table, point to required <strong> QUOTE ID, </strong> or <strong> EXPIRES ON </strong>
          column details, and click the <strong> Add Filter </strong> icon. </li>
        <div> <img src="${renewalManagerThree}" style="height:100%;width:100%"/> </div>
      </ul>
    <li> Repeat the step 1 to include the remaining <strong> Quick Filter </strong> groups. </li>
    <li> Click the <strong> Search </strong> icon and type the specific string to reduce the number of notifications being displayed. </li>
    <span> <strong> NOTE: </strong> You can use the <strong> Search </strong> icon either individually or in combination with the
      <strong> Quick Filter </strong> groups. </span>
    <li> Click the <strong> Refresh </strong> icon to filter the data per selected filters. </li>
    <li> Click <strong> Close </strong> (X) of the respective filter group to remove. </li>
    <li> Click <strong> Close </strong> (X) on right side of the active filters row to remove all the active filter groups. </li>
    <div style="margin-left:-15px"> <strong> NOTE: </strong> The <strong> Renewal Manager </strong> table displays the results for all filter
      groups if none of the filter groups is selected from the <strong> Quick Filter </strong>. </div>
  </ol>

  <h1> Interpreting the Renewal Manager Table </h1>
  <p> From the <strong> Renewal Manager </strong> table, you can navigate to the <strong> Quote Activity, </strong> and <strong> Quote Notes. </strong> </p>

  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-pulse" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Quote Activity </strong> icon to view the activities performed on the quote.
          From the <strong> Quote Activity, </strong> you can filter, refresh, and sort the data.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-register" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Quote Notes </strong> icon to view the notes added for the quote. From the
          <strong> Quote Notes, </strong> you can add new notes, filter, refresh, and sort the existing data.
        </td>
      </tr>
    </tbody>
  </table>

  <h1> Viewing Quote - Activities, and Notes </h1>
  <ol>
    <li> Point to row of the required quote in the table, and click the <strong> Quote Activity, </strong>  or <strong> Quote Notes </strong>
      icon at end of the row. </li>
    <div> <img src="${renewalManagerFour}" style="height:100%;width:100%"/> </div>
    <li> Filter the table data in one of the following ways: </li>
      <ul>
        <li> Click the <strong> Quick Filter </strong> icon and select any single group. Type a search string in the field and click
          outside the field to add filter </li>
        <div style="margin-left:-15px"> <strong> NOTE: </strong> You can include all filter groups if required. </div>
        <li> Point to description of the required filter group, and click the <strong> Add Filter </strong> icon. </li>
      </ul>
    <li> Repeat the step 2 to include the remaining <strong> Quick Filter </strong> groups. </li>
    <li> Click the <strong> Search </strong> icon and type the specific string to reduce the number of notifications being displayed. </li>
      <span> <strong> NOTE: </strong> You can use the <strong> Search </strong> icon either individually or in combination with the
        <strong> Quick Filter </strong> groups. </span>
    <li> Click the <strong> Refresh </strong> icon to filter the data per selected filters. </li>
    <li> Click <strong> Close </strong> (X) of the respective filter group to remove. </li>
    <li> Click <strong> Close </strong> (X) on right side of the active filters row to remove all the active filter groups. </li>
    <div style="margin-left:-15px"> <strong> NOTE: </strong> The table displays the results for all filter groups if none of
      the filter groups is selected from the <strong> Quick Filter. </strong> </div>
  </ol>

  <h1> Adding Quote Notes </h1>
  <ol>
    <li> Point to row of the required quote in the table, and click the <strong> Quote Notes </strong> icon at end of the row. </li>
    <li> Click the <strong> Create New Note </strong> (+) icon to create, and add a new note to the quote. </li>
    <li> Select the <strong> Quote ID </strong> from the drop-down list, type the <strong> Note </strong> description, and click <strong> Save. </strong> </li>
  </ol>

  <h1> Sorting the Table Data </h1>
  <p> Click the table headings to sort the data in ascending or descending order. </p>

  <h1> Switching between the Reseller and Program Managed </h1>

  <p> <strong style="font-style:italic"> To switch a quote between the Reseller and Program managed: </strong> </p>
  <p> Check the box in the <strong> RESELLER MANAGED, </strong> or <strong> PROGRAM MANAGED </strong> columns for the required quote. </p>
  <div> <img src="${renewalManagerFive}" style="height:100%;width:100%"/> </div>

  <p> <strong style="font-style:italic"> To switch multiple quotes: </strong> </p>
  <ul>
    <li> From Reseller managed to Program managed, check the boxes of the required quotes, and click the
      <strong> Close </strong> icon on top of the table. </li>
    <div> <img src="${renewalManagerSix}" style="height:100%;width:100%"/> </div>
    <li> From Program managed to Reseller managed, check the boxes of the required quotes, and click the <strong> Lock </strong>
    icon on top of the table. </li>
    <div> <img src="${renewalManagerSeven}" style="height:100%;width:100%"/> </div>
  </ul>

  <h1> Sorting the Table Data </h1>
  <p> Click the table headings to sort the data in ascending or descending order. </p>

  <h1> Exporting the Table Data </h1>
  <p> Check the boxes of the required rows, or leave all the boxes unselected to export complete table data, and click
  the <strong> Export </strong> icon. </p>

  <h1> Viewing the Quote Details </h1>
  <p> To view the quote details, navigate, and click the required <strong> QUOTE ID </strong> in the <strong> Renewal Manager </strong> table. </p>
  <p> The <strong> RENEWAL MANAGER QUOTE DETAILS </strong> window gives you the following information:</p>
  <ul>
    <li> Quote information. </li>
    <li> Sales representative details. </li>
    <li> Reseller details. </li>
    <li> Items in quote. </li>
    <li> Checkout instructions. </li>
  </ul>
  <p> From the <strong> RENEWAL MANAGER QUOTE DETAILS </strong> window, you can: </p>
  <ul>
    <li> <strong> Email Quote </strong> to registered email IDs, or different Email addresses registered with MySonicWall. </li>
    <li> Export the <strong> ITEMS IN QUOTE </strong> into CSV format. </li>
    <li> Search for the required <strong> ITEMS IN QUOTE. </strong> </li>
    <li> Opt-in, or opt-out for the <strong> AUTO RENEW </strong> option for the required <strong> ITEMS IN QUOTE. </strong> </li>
    <li> <strong> Remove, </strong> or <strong> Add Services </strong> to the quote </li>
    <li> <strong> Split Quote. </strong> </li>
    <li> <strong> Print Quote. </strong> </li>
    <li> <strong> Decline Quote. </strong> </li>
    <li> <strong> Request Change </strong> in quote. </li>
    <li> <strong> Checkout </strong> the quote for payment. </li>
  </ul>

  <h1> Emailing the Quote </h1>
  <ol>
    <li> Click <strong> Email Quote. </strong> </li>
    <li> Select Email option from <strong> Email ID </strong> drop-down list to send to the registered, or a different Email ID. </li>
      <ul>
        <li> Select the registered Email ID available in the list. </li>
        <li> Select <strong> Do you want to use a different Email Address? </strong> to enter a different Email address
        registered with MySonicWall </li>
      </ul>
    <li> Click <strong> Email Quote. </strong> </li>
  </ol>

  <h1 id="exportingQuote"> Exporting the Quote Table </h1>
  <p> Click the <strong> Export </strong> icon to export the <strong> ITEMS IN QUOTE </strong> into CSV format. </p>

  <h1 id="searchingQuote"> Searching the Quote Table </h1>
  <ol>
    <li> Click the <strong> Search </strong> icon, and type a search string. </li>
    <li> Press <strong> enter. </strong> </li>
    <li> Clear the search string to remove the filter. </li>
  </ol>

  <h1 id="printingQuote"> Printing the Quote </h1>
  <ol>
    <li> Click <strong> Print Quote </strong> which opens the print preview in a separate tab. </li>
    <li> Click <strong> Print </strong> at the right top corner. </li>
    <li> Set print parameters, and click <strong> Print. </strong> </li>
  </ol>

  <h1 id="autoRenewOption"> Adding, or Removing the Auto Renew Option </h1>
  <p> Under <strong> AUTO RENEW </strong> column, check, or uncheck the boxes for required line items of the quote. </p>

  <h1 id="addingServicesToQuote"> Adding the Services to the Quote </h1>
  <ol>
    <li> Click <strong> Add Services. </strong> </li>
    <li> Select the <strong> Serial Number, Service Name, </strong> and <strong> SKU </strong> from the respective drop-down lists. </li>
    <li> Click <strong> Add </strong> to add more services, else click <strong> Add and Close </strong> to add the selected service and close the
    <strong> ADD SERVICES </strong> window. </li>
  </ol>

  <h1 id="removingServicesFromQuote"> Removing the Services from the Quote </h1>
  <ol>
    <li> Do one of the following: </li>
      <ul>
        <li> Under <strong> Remove </strong> column, click the <strong> Delete </strong> icon of the required line item of the quote. </li>
        <li> Check the boxes of required line items of the quote, and click <strong> Remove. </strong> </li>
      </ul>
    <li> Click <strong> Confirm </strong> in the <strong> REMOVE ITEM </strong> prompt. </li>
  </ol>

  <h1 id="splittingQuote"> Splitting the Quote </h1>
  <ol>
    <li> Check the boxes of required line items of the quote, and click <strong> Split Quote. </strong> </li>
    <li> Edit the new quote as required. </li>
    <li> Do one of the following: </li>
      <ul>
        <li> Click <strong> Checkout </strong> to continue for payment. </li>
        <li> Click the <strong> Return </strong> icon to go to Renewal Manager default page. </li>
      </ul>
  </ol>

  <h1> Declining the Quote </h1>
  <ol>
    <li> Click <strong> Decline Quote. </strong> </li>
    <li> Select the <strong> Cancellation Reason </strong> from the drop-down list. </li>
    <li> Click <strong> Confirm. </strong> </li>
  </ol>

  <h1> Requesting the Change in Quote </h1>
  <ol>
    <li> Make the necessary changes to the quote as required: </li>
      <ul>
        <li> <a href="#addingServicesToQuote"> <span style="color:#FF791A"> Adding the Services to the Quote. </span> </a> </li>
        <li> <a href="#removingServicesFromQuote"> <span style="color:#FF791A"> Removing the Services from the Quote. </span> </a> </li>
        <li> <a href="#splittingQuote"> <span style="color:#FF791A"> Splitting the Quote. </span> </a> </li>
        <li> <a href="#autoRenewOption"> <span style="color:#FF791A"> Adding, or Removing the Auto Renew Option </span> </a> </li>
        <li> Changing the renewal period if applicable. </li>
      </ul>
    <li> Click <strong> Request Change. </strong> </li>
    <li> <strong> Enter the reason for Request Change, </strong> and click <strong> Confirm. </strong> </li>
  </ol>

  <h1> Checking out the Quote </h1>
  <ol>
    <li> Click <strong> Checkout. </strong> </li>
    <li> Verify the <strong> Shopping Cart </strong> items, and make the changes if required. </li>
      <ul>
        <li> Update quantity of the items. </li>
        <li> Opt-in, or opt-out for <strong> Auto Renew </strong> option. </li>
        <li> Remove the cart items. </li>
        <div style="margin-left:-15px"> <strong> NOTE: </strong> <strong> Save Quote </strong> if you do not want to continue <strong> Checkout. </strong> </div>
      </ul>
    <li> Click <strong> Checkout </strong> to continue. </li>
    <li> Verify the <strong> Checkout - Billing </strong> address details, and edit if required. </li>
    <li> Uncheck <strong> Save address for future transactions </strong> box if you do not want to save the address for future
    transactions </li>
    <li> Enter <strong> Checkout - Payment </strong> details. </li>
    <div style="margin-left:-15px"> <strong> NOTE: </strong> </div>
      <ul>
        <li> You can make the payment through Card, or <strong> E-Check. </strong> </li>
        <li> To make payment through E-Check, turn on <strong> Pay using E-Check. </strong> </li>
      </ul>
    <li> Click <strong> Continue. </strong> </li>
    <li> Verify <strong> Checkout - Confirmation </strong> details, edit the <strong> Billing Information, </strong> and
          <strong> Payment Details </strong> if required. </li>
    <li> Check <strong> I have read and agreed to all of the conditions for use </strong> box. </li>
    <li> Click <strong> Place Order. </strong> </li>
  </ol>

  <h1> Saving the Quote </h1>
  <ol>
    <li> Click <strong> Save Quote. </strong> </li>
    <li> Make the changes as required: </li>
      <ul>
        <li> Update the preferences for <strong> Purchase Mode, </strong> address for future transactions. </li>
        <li> <strong> Change Address. </strong> </li>
        <li> Opt-in, or opt-out for <strong> AUTO RENEW </strong> option. </li>
        <li> Remove the items in quote. </li>
    </ul>
    <li> Click <strong> Update Quote. </strong> </li>
      <div> <strong> NOTE: </strong> You can also perform the following actions from <strong> Edit Quote </strong> window. </div>
      <ul>
        <li> Emailing quote to the registered Email ID. </li>
        <li> <a href="#printingQuote"> <span style="color:#FF791A"> Printing the Quote. </span>  </a></li>
        <li> <a href="#exportingQuote"> <span style="color:#FF791A"> Exporting the Quote Table. </span>  </a></li>
        <li> <a href="#searchingQuote"> <span style="color:#FF791A"> Searching the Quote Table. </span>  </a></li>
      </ul>
    <li> Do one of the following: </li>
      <ul>
        <li> Click <strong> Checkout </strong> to continue for payment. </li>
        <li> Click the <strong> Return </strong> icon to go to <strong> Shopping Cart. </strong> </li>
      </ul>
  </ol>

</div>`;

export const notificationCenterHelpGuide =
`<div>
  <h1> Notification Center </h1>

  <p> The <strong> Notification Center </strong> page lists the notifications of the products registered and shared with your MySonicWall
  account. From the <strong> Notification Center </strong> page, you can pin, delete, and sort the notifications. </p>

  <h1> Filter Options for the Notification Center </h1>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-filter" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Quick Filter </strong> icon to filter the table data for specific results per <strong> TYPE, CATEGORY, DURATION. </strong>
          You can apply these filter groups either individually, or in combination to find the specific notification results.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-search" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Search </strong> icon to filter the table data with a specific string.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-refresh" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Refresh </strong> icon to refresh the table data per selected filter groups.
        </td>
      </tr>
    </tbody>
  </table>

  <h1> Quick Filter </h1>
  <p> Use the <strong> Quick Filter </strong> option if you are looking for notifications of any single group, or combination of the groups listed below. </p>
  <p> <strong> Filter Groups </strong> </p>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Group Name </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> <strong> TYPE </strong> </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> TYPE </strong> group displays the list of notifications of a specific type. For more details,
          refer to <a href="#notificationTypes"> <span style="color:#FF791A"> Notification Types. </span> </a>
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> <strong> CATEGORY </strong> </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> CATEGORY </strong> group displays the list of notifications of a specific type of
          category. For example, Firewall Security, New Software and Firmware.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> <strong> DURATION </strong> </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> DURATION </strong> group displays the list of notifications received for a specific time
          period: for example, 2 hours or 13 days.
        </td>
      </tr>
    </tbody>
  </table>

  <p> <strong style="font-style:italic"> To Filter Data by Quick Filter: </strong> </p>
  <ol>
    <li> Select the filter groups in one of the following ways: </li>
      <ul>
        <div style="margin-left:-15px"> <strong> NOTE: </strong> You can include all three filter groups - <strong>  TYPE, CATEGORY, DURATION </strong>
         if required. </div>
        <li> Click the Quick Filter icon and select any single group. Type a search string in the field and click
          outside the field to add filter </li>
        <div> <img src="${notificationCenterOne}" style="height:100%;"/> </div>
        <div> <img src="${notificationCenterTwo}" style="height:100%;width:100%"/> </div>
        <li> In the <strong> Notification Center </strong> table, point to description of the required filter group - <strong> TYPE </strong> or
        <strong> CATEGORY </strong> or <strong> DURATION </strong> and click the <strong> Add Filter </strong> icon. </li>
        <div> <img src="${notificationCenterThree}" style="height:100%;width:100%"/> </div>
      </ul>
    <li> Repeat the step 1 to include the remaining <strong> Quick Filter </strong> groups. </li>
    <li> Click the <strong> Search </strong> icon and type the specific string to reduce the number of notifications being displayed. </li>
    <span> <strong> NOTE: </strong> You can use the <strong> Search </strong> icon either individually or in combination with the
      <strong> Quick Filter </strong> groups. </span>
    <li> Select the required <strong> CATEGORY </strong> from the drop-down list next to <strong> Search </strong> icon. </li>
    <li> Click the <strong> Refresh </strong> icon to filter the data per selected filters. </li>
    <li> Click <strong> Close </strong> (X) of the respective filter group to remove. </li>
    <li> Click <strong> Close </strong> (X) on right side of the active filters row to remove all the active filter groups. </li>
    <div style="margin-left:-15px"> <strong> NOTE: </strong> The <strong> Notification Center </strong> table displays the results for all filter
      groups if none of the filter groups is selected from the <strong> Quick Filter </strong>. </div>
  </ol>

  <h1 id="notificationTypes"> Notification Types </h1>
  <p> All MySonicWall notifications are categorized, and grouped per below table. </p>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="300"> Type </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Notifications Related To </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Maintenance </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Firewall security
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> All SonicWall Products </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          SonicWall products
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> SonicWall Security Center </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Product security of the user owned products
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> New Software and Firmware Upgrades </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Release of a new software, or firmware, or upgrade of the user owned products
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Security Notices </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Common security issues
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> New Product and Feature Releases </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          New releases made on a product, or a feature of the product
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Site and Infrastructure Updates </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Downtime, or service interruptions due to upgrade of a site, or infrastructure
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Firewall Security </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Security of the user owned firewall appliances
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Security Community </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Security community portal
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> SonicWall Threat Protection </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Threat protection on the SonicWall devices
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> RM Partner Notification </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Renewal Manager for partner
        </td>
      </tr>
    </tbody>
  </table>

  <h1> Interpreting the Notification Center Table </h1>
  <p> From the <strong> Notification Center </strong> table, you can navigate to the <strong> Download Center, Pin,
    </strong> or <strong> Delete </strong> the notifications. </p>
  <div> <strong> NOTE: </strong> You cannot perform <strong> Pin , Delete, </strong> navigate to
   <strong> Download Center </strong> on the <strong> Maintenance </strong> type notifications. </div>

  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-url" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> URL </strong> icon to navigate to the <strong> Download Center </strong> with pre-defined filters.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-pin" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Pin </strong> icon to show the notifications at top of the table until you choose
          to unpin them.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-trash" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Delete </strong> icon to delete the notification from the table.
        </td>
      </tr>
    </tbody>
  </table>

  <h1> Sorting the Notification Center Table </h1>
  <p> Click the table headings to sort the data in ascending or descending order. </p>

</div>`;

export const downloadSignaturesHelpGuide =
`<div>
  <h1> Download Signatures </h1>

  <p> The <strong> Download Signatures </strong> page is a common place to download the signature file for the registered and shared
  products under your MySonicWall account which are running SonicOS enhanced version 3.2 or newer. </p>

  <p> <strong> Default page: </strong> </p>

  <p> The <strong> Download Signatures </strong> page displays the lowest <strong> Signature ID </strong> of your products, signature update
    applicability, the list of <strong> Applicable Products </strong> grouped under the ID and the link to download the signature file. </p>

  <p> All SonicWall products are grouped under particular Signature IDs. The <strong> Signature ID </strong> displays in the list only if
    you have registered or shared at least one product with your MySonicWall account </p>
    <div> <img src="${downloadSignatureOne}" style="height:100%;width:100%"/> </div>

  <p> <strong style="font-style:italic"> To download the Signature file: </strong> </p>
  <ol>
    <li> Select the <strong> Signature ID </strong> from the list. </li>
      <div> <strong> NOTE: </strong> The <strong> Signature ID </strong> list may vary for you per the products registered and shared with your
        MySonicWall account. </div>
      <div> <img src="${downloadSignatureTwo}" style="height:100%;width:100%"/> </div>
    <li> Check the required product for the signature file falls under the <strong> Applicable Products. </strong> If yes, go to next
    step, otherwise, repeat step 1 with remaining <strong> Signature IDs. </strong> </li>
      <div> <strong> NOTE: </strong> The <strong> Applicable Products </strong> list may vary for you per the products registered and shared with
      your MySonicWall account. </div>
    <li> Check the version of your product is eligible for update with Signature file. If yes, go to next step,
      otherwise, update the Signatures manually. </li>
    <li> <strong> Click here to download the Signature File </strong> to download the signature file. </li>
      <div> <img src="${downloadSignatureThree}" style="height:100%;width:100%"/> </div>
  </ol>
</div>`;

export const nfrServicesHelpGuide =
`<div>
  <h1> NFR Services </h1>

  <p> The <strong> NFR Services </strong> page shows the list of products purchased under NFR SKU and the regular products which
   are eligible to convert to <strong> NFR Services. </strong> </p>

  <p> From the <strong> NFR Services </strong> page, you can: </p>
  <ul>
    <li> Extend the <strong> NFR Services </strong> of the eligible products which are due to expire within next 90 days for an
      additional six months or any custom duration, not exceeding six months. </li>
    <li> Convert the eligible regular products into <strong> NFR Services </strong> </li>
    <li> View history of the <strong> NFR Services </strong> extension. </li>
    <div style="margin-left:-15px"> <strong> NOTE: </strong> The product is not eligible for <strong> NFR Services </strong> extension
      if the product box is shaded. You can find the reason under <strong> DESCRIPTION </strong> column. </div>
  </ul>

  <h1> Filter Options for the NFR Services </h1>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-filter" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Quick Filter </strong> icon to list products per <strong>  NAME, SERIAL NUMBER, DESCRIPTION. </strong>
          You can apply these filter groups either individually, or in combination to find the specific notification results.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-search" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Search </strong> icon to filter the table data with a specific string.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-refresh" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Refresh </strong> icon to refresh the table data per selected filter groups.
        </td>
      </tr>
    </tbody>
  </table>

  <h1> Quick Filter </h1>
  <p> Use the <strong> Quick Filter </strong> option if you are looking for notifications of any single group, or combination of the groups listed below. </p>
  <p> <strong> Filter Groups </strong> </p>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Group Name </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> <strong> NAME </strong> </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> NAME </strong> group displays the list of products with a specific name. </span>
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> <strong> SERIAL NUMBER </strong> </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> SERIAL NUMBER </strong> group displays the product with a specific serial number.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> <strong> DESCRIPTION </strong> </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          The <strong> DESCRIPTION </strong> group displays the list of products with a specific description.
        </td>
      </tr>
    </tbody>
  </table>

  <p> <strong style="font-style:italic"> To Filter Data by Quick Filter: </strong> </p>
  <ol>
    <li> Click the Quick Filter icon and select any single group. </li>
    <div> <img src="${nfrServicesOne}" style="height:100%;"/> </div>
    <li> Type a search string in the field and click outside the field to add filter. </li>
    <li> Repeat the steps 1 & 2 to include the remaining <strong> Quick Filter </strong> groups. </li>
      <span> <strong> NOTE: </strong> You can include all three filter groups - <strong> NAME, SERIAL NUMBER, DESCRIPTION </strong> if required. </span>
    <li> Click the <strong> Search </strong> icon and type the specific string to reduce the number of notifications being displayed. </li>
      <span> <strong> NOTE: </strong> You can use the <strong> Search </strong> icon either individually or in combination with the
        <strong> Quick Filter </strong> groups. </span>
    <div> <img src="${nfrServicesTwo}" style="height:100%;width:100%"/> </div>
    <li> Click the <strong> Refresh </strong> icon to filter the data per selected filters. </li>
    <li> Click <strong> Close </strong> (X) of the respective filter group to remove. </li>
    <li> Click <strong> Close </strong> (X) at right side of the active filters row to remove all the active filter groups. </li>
    <div style="margin-left:-15px"> <strong> NOTE: </strong> The <strong> NFR Services </strong> table displays the results for all filter
      groups if none of the filter groups is selected from the <strong> Quick Filter </strong>. </div>
  </ol>

  <h1> Applying NFR Services </h1>
  <ol>
    <li> Select the required products boxes to apply for NFR extension or to convert to <strong> NFR Services. </strong> </li>
      <span> <strong> NOTE: </strong> Check the header row box to select all eligible products for NFR extension. </span>
    <li> Click <strong> Apply NFR. </strong> </li>
    <li> Click <strong> Submit </strong> to extend <strong> NFR Services </strong> for six months. </li>
      <span> <strong> NOTE: </strong> If you want to extend the <strong> NFR Services </strong> for any custom duration within six months,
        check the <strong> Requested expiration date for Subscriptions </strong> box, and set the <strong> Expiration Date. </strong> </span>
  </ol>

  <h1> Viewing NFR Request History </h1>
  <p> Click View <strong> NFR History </strong> to view the history of the NFR extension details. You can extend
    the <strong> NFR Services </strong> for any number of times. </p>
  <span> <strong> NOTE: </strong> The <strong> NFR Request History </strong> does not show the history of the products purchased under NFR SKU. </span>

  <h1> Sorting the NFR Services Table </h1>
  <p> Click the table headings to sort the data in ascending or descending order. </p>

</div>`;

export const psaIntegrationHelpGuide =
`<div>
  <h1> ConnectWise Integration </h1>

  <p> The ConnectWise Manage (CWM) is a professional services automation platform dedicated in automating
  business processes. You can manage the professional services for all your SonicWall products through the
  CWM. Sync all your SonicWall products information to CWM to manage the Tenants. </p>

  <p> From the ConnectWise Integration, you can configure the integrations, sync your tenants to the ConnectWise
  Manage company along with respective Agreements. You can also download the Capture Client Error logs. </p>

  <p> <strong> Default page </strong> </p>

  <p> The ConnectWise Integration page shows the list of all the tenants added under your account. </p>

  <div> <img src="${psaOne}" style="height:100%;"/> </div>

  <h1> Configuring the Integration </h1>

  <ol>
    <li> Click <strong> Configure. </strong> </li>
    <li> Enter the <strong> Server Details: </strong> Server Hostname, Company ID, API Public Key, and API Private Key. </li>
    <li> Select <strong> Add network products as additions </strong> to add the network products from SonicWall as additions in
    ConnectWise Integration agreements along with configurations (These are added as configurations in
      selected agreement by default). </li>
    <li> Select <strong> Add proration for changes </strong> to bill on actual usage of the services. </li>
    <li> Click <strong> Test Connection </strong> to verify the server details. On successful verification of server details, it shows
    the <strong> Connection established successfully </strong> message. </li>
    <li> Click <strong> Next </strong> for <strong> Ticketing Configuration. </strong> </li>
    <li> Select the <strong> Service Board </strong> from the list in which you want to create the Capture Client alerts as tickets. </li>
    <div> <strong> NOTE: </strong>
      <ul>
        <li> Make sure that the Service Board has default status, and other statuses defined in
        ConnectWise Manage along with team details, else alert tickets are not created. </li>
        <li> The Service Board generates the alerts only for companies with Active status. </li>
        <li> The Service Board shows the appropriate error messages in the logs, if you map any company
        having status other than Active is mapped. </li>
      </ul>
    </div>
    <li> Map the ConnectWise Manage Integration priority for <strong> Critical </strong> and <strong> High </strong> severity of the Capture Client
    alerts. </li>
    <li> Click <strong> Next. </strong> </li>
    <li> Review the configured details, and click <strong> Submit. </strong> </li>
    <li> On successful submission of the request, back end service create the Product types, categories, and
    subcategories automatically. Create them manually if they do not exist. For more details, refer to the
    <span style="color:#FF791A"> ConnectWise Documentation. </span> </li>
    <div> <strong> Types </strong>
      <ul>
        <li> SonicWall </li>
        <li> Miscellaneous </li>
      </ul>
    <div> <strong> Categories/Subcategories </strong>
      <ul>
        <li> Cloud </li>
          <ul>
            <li> Cloud Services </li>
            <li> CSoftware</li>
          </ul>
        <li> Hardware/Virtual </li>
          <ul>
            <li> Network Device </li>
          </ul>
        <li> Miscellaneous </li>
          <ul>
            <li> Miscellaneous </li>
          </ul>
      </ul>
  </ol>

  <h1> Syncing Tenant Details </h1>
  <p> On successful submission of the <strong> Configuration, </strong> the integration fetches all the available companies with their
  agreements from ConnectWise Manage (CWI). </p>
  <div> <strong> NOTE: </strong>
    <ul>
        <li> Integration takes a few minutes to fetch the details for the first time. </li>
        <li> Integration does not populate the companies with no agreements. </li>
        <li> Irrespective of the CWI status, integration populates all companies, and agreements. </li>
    </ul>
  </div>

  <div> <strong style="font-style:italic"> Enabling the Sync Now: </strong> </div>
  <ol>
      <li> Click the <strong> Refresh </strong> icon until the <strong> Sync Now </strong> status is enabled. </li>
      <li> On successful <strong> Sync, </strong> the integration shows the companies with their respective agreements in the
      respective drop-down lists. </li>
  </ol>

  <p> The details of products, or services synched as a part of the operation are listed below: </p>
  <ul>
      <li> All billable products, and their service details from SonicWall to CWI </li>
      <li> All <strong> Critical, </strong> and <strong> High </strong> severity alerts from Capture Client to CWI. </li>
      <li> All associated alerts in Capture Client will be deleted when the tickets are closed in CWI. </li>
  </ul>

  <h1> Mapping ConnectWise Company, and Agreement with Tenant </h1>
  <p> The integration page shows all available MSW tenants in a table with ConnectWise Company, and Agreement selection. </p>
  <ol>
      <li> Select a <strong> CONNECTWISE COMPANY, </strong> and corresponding <strong> AGREEMENT </strong> from the respective drop-downs
      for the <strong> TENANT. </strong> </li>
      <li> Enable, or disable the <strong> Sync </strong> for syncing products for the Tenant. </li>
      <div> <strong> NOTE: </strong>
        <ul>
          <li> You can enable the <strong> Sync </strong> if both the <strong> CONNECTWISE COMPANY, </strong> and <strong> AGREEMENT </strong> are
          selected for the <strong> TENANT. </strong> </li>
          <li> The <strong> Last Sync </strong> shows the last time when the products were synced for the <strong> TENANT. </strong> </li>
        </ul>
      <div> <img src="${psaTwo}" style="height:100%;"/> </div>
  </ol>

  <h1> Auto Syncing of Tenant Details </h1>
  <p> The Tenant sync operation works in the background, and executes for every 24 hours at 1 AM (Timezone of the master account). </p>

  <h1> Manual Syncing of Tenant Details </h1>
  <p> The manual sync service performs the same tasks as Automatic Sync. To sync the changes of the Tenant
  products, or services immediately, you can sync the details manually. </p>
  <p> To sync the Tenant details manually, click <strong> Sync Now. </strong> </p>

  <h1> Syncing Capture Client Alerts </h1>
  <p> The alert sync service runs in background at 10 minutes interval for each configured MSW user. All the tenants
  that are configured, and enabled for sync are considered for the alert sync operation. </p>

  <p> For each enabled tenant, if the tenant has a Capture Client associated with it, the alert sync operation: </p>
  <ul>
      <li> Adds the Capture Client alerts with <strong> critical, </strong> and <strong> high </strong> severity as tickets in ConnectWise Integration for
      the configured Service Board, and with selected priority. </li>
      <li> Considers the latest 100 alerts in the last 10 minutes. </li>
  </ul>

  <p> The following details are set in each ticket from the alert: </p>
  <ul>
      <li> The Alert message in Ticket Summary </li>
      <li> Service Board </li>
      <li> Priority </li>
      <li> The company and agreement mapped with MSW Tenant </li>
  </ul>

  <h1> Downloading Error Logs </h1>
  <p> From the ConnectWise Integration page, you can get the quick preview on the number of Errors. When the Errors
  count is more than Zero, click <strong> Errors. </strong> to download log as a zip file. </p>
  <div> <img src="${psaThree}" style="height:100%;"/> </div>

</div>`;

export const masterMsspAccessMgmtUserGuide =
`<div>
  <h1> Access Management </h1>
  <p> Access Management helps define and control the role based access and permissions for the users. </p>

  <p> <strong style="font-style:italic"> To navigate to Access Management: </i> </strong> </p>
  <ol>
    <li> Navigate to <strong> MSSP Monthly | MSSP Tenants. </strong> </li>
    <li> Click the <strong> Access Management </strong> icon on top of the MSSP Tenants table. </li>
    <div> <img src="${accessMgmtOne}" style="height:100%;width:100%"/> </div>
  </ol>

  <div> The <strong> Access Management </strong> page lists the <strong> Users </strong> added to your account and <strong> User Groups </strong> created for Master MSSP and MSSP.
    The User Group is defined by these attributes: </div>
  <ul>
    <li> List of <strong> Users </strong> </li>
    <li> <strong> Scope </strong> of access for the users </li>
    <li> Role based <strong> Permissions </strong> </li>
  </ul>

  <p> From the <strong> Users </strong> tab, you can: </p>
  <ul>
    <li> Filter and customize the user table data </li>
    <li> Invite a new user </li>
    <li> Define or modify the MSSP monthly permissions of the user </li>
    <li> Update 2FA and External IDP for the user </li>
    <li> Delete an existing user </li>
  </ul>

  <p> From the <strong> User Group </strong> tab, you can: </p>
  <ul>
    <li> Create a new user group </li>
    <li> Add or remove the users from the user group </li>
    <li> Define or modify the scope to include or exclude the Tenants from the user group </li>
    <li> Define or modify the permissions for the user group</li>
  </ul>

  <p> <strong> Default page: </strong> </p>
  <p> The <strong> Access Management </strong> page shows the <strong> Users </strong> tab with list of users added under your account in a tabular
    form. You can customize the table to show or hide <strong> TYPE, ACCESS SCOPE, USER GROUP, ORGANIZATION,
    MSSP PERMISSION. </strong> By default, these details are shown in the <strong> Users </strong> table. To hide them in the table, click
    <strong> Customize Columns </strong> icon on top of the table and uncheck the boxes for the required details. </p>
  <div> <img src="${accessMgmtTwo}" style="height:100%;width:100%"/> </div>

  <p> <strong> Topics: </strong> </p>
  <ul>
    <li> <a href="#options"> <span style="color:#FF791A"> Options for the Access Management </span> </a> </li>
    <li> <a href="#quickFilter"> <span style="color:#FF791A"> Quick Filter </span> </a> </li>
    <li> <a href="#customizingColumn"> <span style="color:#FF791A"> Customizing Columns </span> </a> </li>
    <li> <a href="#invitingNewUser"> <span style="color:#FF791A"> Inviting a New User </span> </a> </li>
    <li> <a href="#modifyingMsspMonthlyPermissions"> <span style="color:#FF791A"> Modifying the MSSP Monthly Permissions </span> </a> </li>
    <li> <a href="#interpretingUser"> <span style="color:#FF791A"> Interpreting the Users Table </span> </a> </li>
    <li> <a href="#creatingUser"> <span style="color:#FF791A"> Creating a New User Group </span> </a> </li>
    <li> <a href="#addingUser"> <span style="color:#FF791A"> Adding the Users to the User Group </span> </a> </li>
    <li> <a href="#removingUser"> <span style="color:#FF791A"> Removing the User from the User Group </span> </a> </li>
    <li> <a href="#modifyingScope"> <span style="color:#FF791A"> Defining or Modifying the Scope </span> </a> </li>
    <li> <a href="#modifyingUserGroupPermissions"> <span style="color:#FF791A"> Modifying the User Group Permissions </span> </a> </li>
  </ul>

  <h1 id="options"> Options for the Access Management </h1>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-filter" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Quick Filter </strong> icon to filter the table data for specific results. You can apply these
          filter groups either individually or in combination to find the specific notification results.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-search" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Search </strong> icon to filter the table data with a specific string.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-options" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Customize Columns </strong> icon to show, or hide <strong> TYPE, ACCESS SCOPE, USER
          GROUP, ORGANIZATION, MSSP PERMISSION </strong> in <strong> Users </strong> details.
        </td>
      </tr>
    </tbody>
  </table>

  <h1 id="quickFilter"> Quick Filter </h1>
  <p> Use the <strong> Quick Filter </strong> option if you are looking for users of any single filter group or combination of the groups </p>
  <p> <strong style="font-style:italic"> To Filter Data by Quick Filter: </i> </strong> </p>
  <ol>
   <li> Click the <strong> Quick Filter </strong> icon and check the required boxes under each filter group. </li>
   <div> <img src="${accessMgmtThree}" style="height:100%;width:100%"/> </div>
   <li> Click <strong> Apply. </strong> </li>
   <li> Click the <strong> Search </strong> icon and type the specific string to reduce the number of results being displayed. </li>
   <span> <strong> NOTE: </strong> You can use the <strong> Search </strong> icon either individually or in combination with the <strong> Quick Filter </strong>
     groups </span>
  </ol>
  <div> <strong> NOTE: </strong> The <strong> Users </strong> table displays the results for all filter groups if none of the filter groups is selected from the
    <strong> Quick Filter. </strong> </div>

  <h1 id="customizingColumn"> Customizing Columns </h1>
  <p> You can customize the table to show or hide <strong> TYPE, ACCESS SCOPE, USER GROUP, ORGANIZATION, MSSP
    PERMISSION. </strong> By default, these details are shown in the <strong> Users </strong> table. To hide them in the table, click <strong> Customize
    Columns </strong> icon on top of the table and uncheck the boxes for the required details. </p>

  <h1 id="invitingNewUser"> Inviting a New User </h1>
  <ol>
    <li> On the <strong> Users </strong> tab, click <strong> Invite New User. </strong> </li>
    <li> Select the <strong> MSSP </strong> and <strong> User Group </strong> under which you want to add the invited user. </li>
    <li> Select the <strong> Contact Type. </strong> You can invite the user as <strong> Partner, Employee,</strong> or <strong> Customer. </strong> </li>
    <li> Enter <strong> Email Address, First Name, </strong> and <strong> Last Name </strong> of the user. </li>
    <li> Click <strong> Invite. </strong> </li>
  </ol>

  <h1 id="modifyingMsspMonthlyPermissions"> Modifying the MSSP Monthly Permissions </h1>
  <p> In the <strong> Users </strong> tab > <strong> MSSP PERMISSION </strong> column, modify the <strong> MSSP Monthly </strong> permission of users as required. </p>
  <div> <strong> NOTE: </strong> By default, all Master MSSP and MSSP users get <strong> FULL ACCESS. </strong> </div>

  <h1 id="interpretingUser"> Interpreting the Users Table </h1>
  <p> From the <strong> Users </strong> table, you can perform the below list of operations. </p>
  <p> On the <strong> Users </strong> tab > <strong> ACTIONS </strong> column, point to the required user. </p>

  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-trash" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Delete </strong> icon to delete an existing user from the account
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-locked" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Lock </strong> icon to turn ON or OFF the 2FA mode
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-user-lock" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> IDP </strong> icon to enable or disable external IDP for the user
        </td>
      </tr>
    </tbody>
  </table>

  <h1 id="creatingUser"> Creating a New User Group </h1>
  <ol>
    <li> On the <strong> User Groups </strong> tab, select the <strong> MSSP </strong> from the drop-down list under which you want to create a new
      user group. </li>
    <div> <strong> NOTE: </strong> Select <strong> Global </strong> from the drop-down list if you want to create a User Group for Master MSSP
      organization. </div>
    <li> Click the <strong> New User Group </strong> (+) icon. </li>
    <li> Enter a name for the new user group. </li>
    <li> Click the Tick ( ✓ ) mark next to the Name box. </li>
    <div> On successful User Group creation, you get Success notification per below. </div>
    <div> <img src="${accessMgmtFour}" style="height:100%;width:100%"/> </div>
  </ol>

  <h1 id="addingUser"> Adding the Users to the User Group </h1>
  <ol>
    <li> On the <strong> User Groups </strong> tab, select the <strong> MSSP </strong> from the drop-down list. </li>
    <li> Select the required <strong> User Group </strong> from the list. </li>
    <div> <strong> NOTE: </strong> Use <strong> Search </strong> option to filter the required user group from the list if required. </div>
    <li> In the Users section, click + <strong> Add User. </strong> </li>
    <li> Check boxes of the required users from the <strong> Available users </strong> list and click <strong> Add </strong> for existing users. </li>
    <li> Click <strong> Invite New User </strong> and follow per <a href="#invitingNewUser"> <span style="color:#FF791A"> Inviting a New User </span> </a>
      to invite and add a new user if users are not available in the list. </li>
  </ol>

  <h1 id="removingUser"> Removing the User from the User Group </h1>
  <p> On the <strong> User Groups </strong> tab, point to the required user and click the <strong> Delete </strong> icon </p>

  <h1 id="modifyingScope"> Defining or Modifying the Scope </h1>
  <p> The <strong> Scope </strong> section allows you to specify the selection of the <strong> Tenants </strong> to the User Group access. </p>
  <ol>
    <li> On the <strong> User Groups </strong> tab, select the <strong> MSSP </strong> from the drop-down list. </li>
    <li> Select the required <strong> User Group </strong> from the list. </li>
    <div> <strong> NOTE: </strong> Use <strong> Search </strong> option to filter the required user group from the list if required. </div>
    <li> In the Scope section, click ✎ <strong> Edit. </strong> </li>
    <li> Do one of the following to include or exclude in the User Group:
      <ul>
        <li> Select <strong> All Tenants </strong> to include all Tenants available in your account. </li>
        <div> <strong> All Tenants </strong> option is available only for the User Groups created under the Global MSSP. </div>
        <li> Select <strong> MSSP </strong> to include all the Tenants created under the specific MSSP. </li>
        <li> Select <strong> Tenant </strong> and check to include individual Tenants. </li>
        <div> <strong> NOTE: </strong> Use <strong> Search </strong> option to filter the required Tenants from the list if required. </div>
      </ul>
    </li>
    <li> Click Save. </li>
  </ol>

  <h1 id="modifyingUserGroupPermissions"> Modifying the User Group Permissions </h1>
  <ol>
    <li> On the <strong> User Groups </strong> tab, select the <strong> MSSP </strong> from the drop-down list. </li>
    <li> Select the required <strong> User Group </strong> from the list. </li>
    <div> <strong> NOTE: </strong> Use <strong> Search </strong> option to filter the required user group from the list if required. </div>
    <li> In the Permissions section, click ✎ <strong> Edit. </strong> </li>
    <li> Set the permissions as required </li>
    <div> By default, Admin access is provided for all User Groups. You can modify the permissions as required. </div>
    <li> Click Save. </li>
  </ol>

  </div>`;

export const regularMsspAccessMgmtUserGuide =
`<div>
  <h1> Access Management </h1>
  <p> Access Management helps define and control the role based access and permissions for the users. </p>

  <p> <strong style="font-style:italic"> To navigate to Access Management: </i> </strong> </p>
  <ol>
    <li> Navigate to <strong> MSSP Monthly | MSSP Tenants. </strong> </li>
    <li> Click the <strong> Access Management </strong> icon on top of the MSSP Tenants table. </li>
    <div> <img src="${accessMgmtOne}" style="height:100%;width:100%"/> </div>
  </ol>

  <div> The <strong> Access Management </strong> page lists the <strong> Users </strong> added to your account and <strong> User Groups </strong> created for MSSP.
    The User Group is defined by these attributes: </div>
  <ul>
    <li> List of <strong> Users </strong> </li>
    <li> <strong> Scope </strong> of access for the users </li>
    <li> Role based <strong> Permissions </strong> </li>
  </ul>

  <p> From the <strong> Users </strong> tab, you can: </p>
  <ul>
    <li> Filter and customize the user table data </li>
    <li> Invite a new user </li>
    <li> Define or modify the MSSP monthly permissions of the user </li>
    <li> Update 2FA and External IDP for the user </li>
    <li> Delete an existing user </li>
  </ul>

  <p> From the <strong> User Group </strong> tab, you can: </p>
  <ul>
    <li> Create a new user group </li>
    <li> Add or remove the users from the user group </li>
    <li> Define or modify the scope to include or exclude the Tenants from the user group </li>
    <li> Define or modify the permissions for the user group</li>
  </ul>

  <p> <strong> Default page: </strong> </p>
  <p> The <strong> Access Management </strong> page shows the <strong> Users </strong> tab with list of users added under your account in a tabular
    form. You can customize the table to show or hide <strong> TYPE, ACCESS SCOPE, USER GROUP, ORGANIZATION,
    MSSP PERMISSION. </strong> By default, these details are shown in the <strong> Users </strong> table. To hide them in the table, click
    <strong> Customize Columns </strong> icon on top of the table and uncheck the boxes for the required details. </p>
  <div> <img src="${accessMgmtTwo}" style="height:100%;width:100%"/> </div>

  <p> <strong> Topics: </strong> </p>
  <ul>
    <li> <a href="#options"> <span style="color:#FF791A"> Options for the Access Management </span> </a> </li>
    <li> <a href="#quickFilter"> <span style="color:#FF791A"> Quick Filter </span> </a> </li>
    <li> <a href="#customizingColumn"> <span style="color:#FF791A"> Customizing Columns </span> </a> </li>
    <li> <a href="#invitingNewUser"> <span style="color:#FF791A"> Inviting a New User </span> </a> </li>
    <li> <a href="#modifyingMsspMonthlyPermissions"> <span style="color:#FF791A"> Modifying the MSSP Monthly Permissions </span> </a> </li>
    <li> <a href="#interpretingUser"> <span style="color:#FF791A"> Interpreting the Users Table </span> </a> </li>
    <li> <a href="#creatingUser"> <span style="color:#FF791A"> Creating a New User Group </span> </a> </li>
    <li> <a href="#addingUser"> <span style="color:#FF791A"> Adding the Users to the User Group </span> </a> </li>
    <li> <a href="#removingUser"> <span style="color:#FF791A"> Removing the User from the User Group </span> </a> </li>
    <li> <a href="#modifyingScope"> <span style="color:#FF791A"> Defining or Modifying the Scope </span> </a> </li>
    <li> <a href="#modifyingUserGroupPermissions"> <span style="color:#FF791A"> Modifying the User Group Permissions </span> </a> </li>
  </ul>

  <h1 id="options"> Options for the Access Management </h1>
  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-filter" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Quick Filter </strong> icon to filter the table data for specific results. You can apply these
          filter groups either individually or in combination to find the specific notification results.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-search" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Search </strong> icon to filter the table data with a specific string.
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-options" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Customize Columns </strong> icon to show, or hide <strong> TYPE, ACCESS SCOPE, USER
          GROUP, ORGANIZATION, MSSP PERMISSION </strong> in <strong> Users </strong> details.
        </td>
      </tr>
    </tbody>
  </table>

  <h1 id="quickFilter"> Quick Filter </h1>
  <p> Use the <strong> Quick Filter </strong> option if you are looking for users of any single filter group or combination of the groups </p>
  <p> <strong style="font-style:italic"> To Filter Data by Quick Filter: </i> </strong> </p>
  <ol>
   <li> Click the <strong> Quick Filter </strong> icon and check the required boxes under each filter group. </li>
   <div> <img src="${accessMgmtThree}" style="height:100%;width:100%"/> </div>
   <li> Click <strong> Apply. </strong> </li>
   <li> Click the <strong> Search </strong> icon and type the specific string to reduce the number of results being displayed. </li>
   <span> <strong> NOTE: </strong> You can use the <strong> Search </strong> icon either individually or in combination with the <strong> Quick Filter </strong>
     groups </span>
  </ol>
  <div> <strong> NOTE: </strong> The <strong> Users </strong> table displays the results for all filter groups if none of the filter groups is selected from the
    <strong> Quick Filter. </strong> </div>

  <h1 id="customizingColumn"> Customizing Columns </h1>
  <p> You can customize the table to show or hide <strong> TYPE, ACCESS SCOPE, USER GROUP, ORGANIZATION, MSSP
    PERMISSION. </strong> By default, these details are shown in the <strong> Users </strong> table. To hide them in the table, click <strong> Customize
    Columns </strong> icon on top of the table and uncheck the boxes for the required details. </p>

  <h1 id="invitingNewUser"> Inviting a New User </h1>
  <ol>
    <li> On the <strong> Users </strong> tab, click <strong> Invite New User. </strong> </li>
    <li> Select the <strong> User Group </strong> under which you want to add the invited user. </li>
    <li> Select the <strong> Contact Type. </strong> You can invite the user as <strong> Partner, Employee,</strong> or <strong> Customer. </strong> </li>
    <li> Enter <strong> Email Address, First Name, </strong> and <strong> Last Name </strong> of the user. </li>
    <li> Click <strong> Invite. </strong> </li>
  </ol>

  <h1 id="modifyingMsspMonthlyPermissions"> Modifying the MSSP Monthly Permissions </h1>
  <p> In the <strong> Users </strong> tab > <strong> MSSP PERMISSION </strong> column, modify the <strong> MSSP Monthly </strong> permission of users as required. </p>
  <div> <strong> NOTE: </strong> By default, all MSSP users get <strong> FULL ACCESS. </strong> </div>

  <h1 id="interpretingUser"> Interpreting the Users Table </h1>
  <p> From the <strong> Users </strong> table, you can perform the below list of operations. </p>
  <p> On the <strong> Users </strong> tab > <strong> ACTIONS </strong> column, point to the required user. </p>

  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150"> Icon </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-trash" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Delete </strong> icon to delete an existing user from the account
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-locked" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> Lock </strong> icon to turn ON or OFF the 2FA mode
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem" width="150">
          <span class="sw-icon__inner sw-font-icon icon-user-lock" style="font-size:2rem"></span>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          Use the <strong> IDP </strong> icon to enable or disable external IDP for the user
        </td>
      </tr>
    </tbody>
  </table>

  <h1 id="creatingUser"> Creating a New User Group </h1>
  <ol>
    <li> On the <strong> User Groups </strong> tab, select the <strong> MSSP </strong> from the drop-down list under which you want to create a new
      user group. </li>
    <li> Click the <strong> New User Group </strong> (+) icon. </li>
    <li> Enter a name for the new user group. </li>
    <li> Click the Tick ( ✓ ) mark next to the Name box. </li>
    <div> On successful User Group creation, you get Success notification per below. </div>
    <div> <img src="${accessMgmtFour}" style="height:100%;width:100%"/> </div>
  </ol>

  <h1 id="addingUser"> Adding the Users to the User Group </h1>
  <ol>
    <li> On the <strong> User Groups </strong> tab, select the <strong> MSSP </strong> from the drop-down list. </li>
    <li> Select the required <strong> User Group </strong> from the list. </li>
    <div> <strong> NOTE: </strong> Use <strong> Search </strong> option to filter the required user group from the list if required. </div>
    <li> In the Users section, click + <strong> Add User. </strong> </li>
    <li> Check boxes of the required users from the <strong> Available users </strong> list and click <strong> Add </strong> for existing users. </li>
    <li> Click <strong> Invite New User </strong> and follow per <a href="#invitingNewUser"> <span style="color:#FF791A"> Inviting a New User </span> </a>
      to invite and add a new user if users are not available in the list. </li>
  </ol>

  <h1 id="removingUser"> Removing the User from the User Group </h1>
  <p> On the <strong> User Groups </strong> tab, point to the required user and click the <strong> Delete </strong> icon </p>

  <h1 id="modifyingScope"> Defining or Modifying the Scope </h1>
  <p> The <strong> Scope </strong> section allows you to specify the selection of the <strong> Tenants </strong> to the User Group access. </p>
  <ol>
    <li> On the <strong> User Groups </strong> tab, select the <strong> MSSP </strong> from the drop-down list. </li>
    <li> Select the required <strong> User Group </strong> from the list. </li>
    <div> <strong> NOTE: </strong> Use <strong> Search </strong> option to filter the required user group from the list if required. </div>
    <li> In the Scope section, click ✎ <strong> Edit. </strong> </li>
    <li> Do one of the following to include or exclude in the User Group:
      <ul>
        <li> Select <strong> MSSP </strong> to include all the Tenants created under the specific MSSP. </li>
        <li> Select <strong> Tenant </strong> and check to include individual Tenants. </li>
        <div> <strong> NOTE: </strong> Use <strong> Search </strong> option to filter the required Tenants from the list if required. </div>
      </ul>
    </li>
    <li> Click Save. </li>
  </ol>

  <h1 id="modifyingUserGroupPermissions"> Modifying the User Group Permissions </h1>
  <ol>
    <li> On the <strong> User Groups </strong> tab, select the <strong> MSSP </strong> from the drop-down list. </li>
    <li> Select the required <strong> User Group </strong> from the list. </li>
    <div> <strong> NOTE: </strong> Use <strong> Search </strong> option to filter the required user group from the list if required. </div>
    <li> In the Permissions section, click ✎ <strong> Edit. </strong> </li>
    <li> Set the permissions as required </li>
    <div> By default, Admin access is provided for all User Groups. You can modify the permissions as required. </div>
    <li> Click Save. </li>
  </ol>

  </div>`;

export const externalIDPGuide =
`<div>
  <h1> External Identify Provider </h1>
  <p> This section provides the instructions to configure an external identity provider, Azure or Okta for your
    MySonicWall application. </p>

  <h3> Topics: </h3>
  <div> <a href="#configuringExternalIDP"> <span style="color:#FF791A"> Configuring an External Identify Provider </span> </a> </div>

  <h1 id="configuringExternalIDP"> Configuring an External Identify Provider </h1>

  <p> <strong style="font-style:italic"> To configure an external identity provider for MySonicWall: </i> </strong> </p>
  <ol>
    <li> Log in to your MySonicWall account. </strong> </li>
    <li> Navigate to <strong> Settings > My Account > My personal profile. </strong> </li>
    <li> Enable <strong> Use External Identity Provider </strong> under <strong> ADDITIONAL OPTIONS </strong> group. </li>
    <li> Select the Identity Provider Organization. </li>
      <ul>
        <li> Okta Configuration </li>
        <li> Azure Active Directory Configuration </li>
      </ul>
    <li> Configure the external identity provider in one of the following ways: </li>
      <ul>
        <li> Select the check box and enter the <strong> Service Provider Metadata URL </strong> copied from the external
          Identify Provider (Okta or Azure AD) application.
          System automatically pull the relevant data and populates in the input fields. For more information
          about getting metadata URL, refer to below table. </li>
        <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
          <tbody>
            <tr>
              <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> IdP Protocol </th>
              <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Okta </th>
              <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Azure </th>
            </tr>

            <tr>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                SAML
              </td>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                <a href="#oktaSamlMetadata"> <span style="color:#FF791A"> Okta-SAML Metadata URL </span> </a>
              </td>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                <a href="#azureSamlMetadata"> <span style="color:#FF791A"> Azure-SAML Metadata URL </span> </a>
              </td>
            </tr>

            <tr>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                OpenID Connect
              </td>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                <a href="#oktaOpenIdMetadata"> <span style="color:#FF791A"> Okta-OpenID Metadata URL </span> </a>
              </td>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                <a href="#azureOpenIdMetadata"> <span style="color:#FF791A"> Azure-OpenID Metadata URL </span> </a>
              </td>
            </tr>
          </tbody>
        </table>
        <li> Manually select the identity provider protocol: </li>
          <ul>
            <li> Set <strong> Authentication Type </strong> as <strong> Code </strong> or <strong> Token </strong> for <strong> OpenID Connect </strong> protocol. </li>
            <li> Fill in the respective fields with information copied from external identity provider
              application. For more information, refer to the below table. </li>
          </ul>
          <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
          <tbody>
            <tr>
              <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem"> IdP Protocol </th>
              <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;width: 200px"> External IdP application information </th>
              <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Okta </th>
              <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Azure </th>
            </tr>

            <tr>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                SAML
              </td>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                <div> SSO URL </div>
                <div> x509 Certificate </div>
              </td>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                <div> <a href="#oktaSamlManual"> <span style="color:#FF791A"> Okta-SAML Manual </span> </a> </div>
                <div> <a href="#oktaSamlManual"> <span style="color:#FF791A"> Configuration Information </span> </a> </div>
              </td>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                <div> <a href="#azureSamlManual"> <span style="color:#FF791A"> Azure-SAML Manual </span> </a> </div>
                <div> <a href="#azureSamlManual"> <span style="color:#FF791A"> Configuration Information </span> </a> </div>
              </td>
            </tr>

            <tr>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                OpenID Connect
              </td>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                <div> Client ID </div>
                <div> Client Secret </div>
                <div> Authorization URL </div>
              </td>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                <div> <a href="#oktaOpenIdManual"> <span style="color:#FF791A"> Okta-OpenID Manual </span> </a> </div>
                <div> <a href="#oktaOpenIdManual"> <span style="color:#FF791A"> Configuration Information </span> </a> </div>
              </td>
              <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
                <div> <a href="#azureOpenIdManual"> <span style="color:#FF791A"> Azure-OpenID Manual </span> </a> </div>
                <div> <a href="#azureOpenIdManual"> <span style="color:#FF791A"> Configuration Information </span> </a> </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ul>
    <li> Click <strong> Connect & Save </strong> </li>
  </ol>

  <h1 id="azureSamlMetadata"> Azure-SAML Metadata URL </h1>
  <p> <strong style="font-style:italic"> To form metadata url: </strong> </p>

  <ol>
    <li> Log in to Azure portal. </li>
    <li> Click <strong> View </strong> under <strong> Manage Azure Active Directory. </strong> </li>
    <li> Navigate to <strong> Manage > Enterprise applications. </strong> </li>
    <li> Select the application. </li>
    <li> Click <strong> Single sign-on. </strong> </li>
    <li> Click the <strong> Copy to clipboard </strong> icon next to <strong> App Federation Metadata Url </strong> under <strong> SAML Certificates </strong> group. </li>
    <li> Enter the copied Url in MySonicWall application to setup external identity provider. </li>
  </ol>

  <h1 id="azureSamlManual"> Azure-SAML Manual Configuration Information </h1>
  <p> <strong style="font-style:italic"> To get information from Azure-SAML application: </strong> </p>

  <ol>
    <li> Log in to Azure portal. </li>
    <li> Click <strong> View </strong> under <strong> Manage Azure Active Directory. </strong> </li>
    <li> Navigate to <strong> Manage > Enterprise applications. </strong> </li>
    <li> Select the application. </li>
    <li> Click <strong> Single sign-on. </strong> </li>
    <li> Click <strong> Download </strong> next to <strong> Federation Metadata XML </strong> under <strong> SAML Certificates </strong> group. </li>
    <li> Open the downloaded XML file. </li>
    <li> Search with HTTP-POST. </li>
    <li> Copy the SSO URL as shown below. </li>
      <div> <img src="${externalIDPOne}" style="height:100%;width:100%"/> </div>
    <li> Search with KeyInfo. </li>
    <li> Copy the x509 Certificate as shown below. </li>
      <div> <img src="${externalIDPTwo}" style="height:100%;width:100%"/> </div>
    <li> Enter the copied SSO URL and x509 Certificate information in MySonicWall to setup external identity provider. </li>
  </ol>

  <h1 id="azureOpenIdMetadata"> Azure-OpenID Metadata URL </h1>
  <p> <strong style="font-style:italic"> To form metadata url: </strong> </p>

  <ol>
    <li> Log in to Azure portal. </li>
    <li> Click <strong> View </strong> under <strong> Manage Azure Active Directory. </strong> </li>
    <li> Navigate to <strong> Manage > App registrations </strong> in the left navigation menu. </li>
    <li> Select the application. </li>
    <li> Click <strong> Endpoints </strong> on top of the page. </li>
    <li> Click the <strong> Copy to clipboard </strong> icon next to <strong> OpenID Connect metadata document. </strong> </li>
    <li> Enter the copied Url in MySonicWall application to setup external identity provider. </li>
  </ol>

  <h1 id="azureOpenIdManual"> Azure-OpenID Manual Configuration Information </h1>
  <p> <strong style="font-style:italic"> To get information from Azure-OpenID application: </strong> </p>

  <ol>
    <li> Log in to Azure portal. </li>
    <li> Click <strong> View </strong> under <strong> Manage Azure Active Directory. </strong> </li>
    <li> Navigate to <strong> Manage > App registrations </strong> in the left navigation menu. </li>
    <li> Select the application. </li>
    <li> Copy and store the OpenID application information to enter in MySonicWall application. </li>
  </ol>

  <table style="border-top: 1px solid #ddd;border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem; width: 100px"> Application Information </th>
        <th style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;"> Description </th>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          <strong> Application (client) ID </strong>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          <div> Click <strong> Overview. </strong> </div>
          <div> Click the <strong> Copy to clipboard </strong> icon next to the <strong> Application (client) ID. </strong> </div>
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          <strong> Client secret key </strong>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          <div> Click <strong> Certificates & secrets. </strong> </div>
          <div> Click the <strong> Copy to clipboard </strong> icon under <strong> Client secrets </strong> group. </div>
        </td>
      </tr>

      <tr>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          <strong> Authorization URL </strong>
        </td>
        <td style="text-align:left;border-top: 1px solid #ddd;border-collapse: collapse;padding:.5rem">
          <div> Click <strong> Overview > Endpoints. </strong> </div>
          <div> Click the <strong> Copy to clipboard </strong> icon of <strong> OAuth 2.0 authorization endpoint (v2) </strong> </div>
        </td>
      </tr>

    </tbody>
  </table>


  <h1 id="oktaSamlMetadata"> Okta-SAML Metadata URL </h1>
  <p> <strong style="font-style:italic"> To form metadata url: </strong> </p>

  <ol>
    <li> Log in to Okta. </li>
    <li> Navigate to <strong> Applications > Applications. </strong> </li>
    <li> Select the application from the list. </li>
    <li> Click the <strong> Sign On </strong> tab. </li>
    <li> Scroll-down and click <strong> View SAML setup instructions </strong> under <strong> SAML setup. </strong> </li>
    <li> Copy the domain name and app id from <strong> Identity Provider Single Sign-On URL. </strong> </li>
    <li> Replace $ {yourOktaDomain} and $ {yourAppID} in URL
      https://$ {yourOktaDomain}/app/$ {yourAppID}/sso/saml/metadata with the information copied in previous step </li>
    <li> Paste the formed metadata URL in MySonicWall application to setup external identity provider. </li>
  </ol>

  <h1 id="oktaSamlManual"> Okta-SAML Manual Configuration Information </h1>
  <p> <strong style="font-style:italic"> To get information from Okta-SAML application: </strong> </p>

  <ol>
    <li> Log in to Okta. </li>
    <li> Navigate to <strong> Applications > Applications </strong> in the left navigation. </li>
    <li> Select the application from the list. </li>
    <li> Click the <strong> Sign On </strong> tab. </li>
    <li> Scroll-down and click <strong> View SAML setup instructions </strong> under <strong> SAML setup. </strong> </li>
    <li> Copy the <strong> Identity Provider Single Sign-On URL </strong> and <strong> X.509 Certificate </strong> respectively. </li>
    <li> Enter the copied information in MySonicWall application to setup external identity provider. </li>
  </ol>

  <h1 id="oktaOpenIdMetadata"> Okta-OpenID Metadata URL </h1>
  <p> <strong style="font-style:italic"> To form metadata url: </strong> </p>

  <ol>
    <li> Log in to Okta. </li>
    <li> Click the account information. </li>
    <li> Click the <strong> Copy to clipboard </strong> icon next to the issuer domain name as shown below. </li>
    <li> Copy the Issuer domain name as shown below. </li>
      <div> <img src="${externalIDPThree}"/> </div>
    <li> Replace $ {yourOktaDomain} in URL https://$ {yourOktaDomain}/.well-known/openid-configuration with
      the issuer domain name copied in previous step.
      For more information, refer to <a href="https://developer.okta.com/docs/reference/api/oidc/#well-known-openid-configuration.">
      <span style="color:#FF791A"> https://developer.okta.com/docs/reference/api/oidc/#well-known-openid-configuration. </span> </a>
    </li>
  </ol>

  <h1 id="oktaOpenIdManual"> Okta-OpenID Manual Configuration Information </h1>
  <p> <strong style="font-style:italic"> To get Client ID and Client secret from Okta-OpenID application: </strong> </p>

  <ol>
    <li> Log in to Okta. </li>
    <li> Navigate to <strong> Applications > Applications </strong> in the left navigation menu. </li>
    <li> Select the application from the list. </li>
    <li> Scroll-down to <strong> Client credentials </strong> group under <strong> General </strong> tab. </li>
    <li> Click the <strong> Copy to clipboard </strong> icon next to <strong> Client ID </strong> and <strong> Client secret </strong> respectively and enter the
      information inMySonicWall application. </li>
  </ol>

  <p> <strong style="font-style:italic"> To form an Authorization URL from Okta-OpenID application: </strong> </p>
  <ol>
    <li> Copy the domain name from Okta account information. For more information, refer to <a href="#oktaOpenIdMetadata">
      <span style="color:#FF791A"> Okta-OpenID Metadata URL. </span> </a>
    </li>
    <li> Replace $ {yourOktaDomain} in URL https://$ {yourOktaDomain}/oauth2/default/v1/authorize with the
      information copied in previous step.
    </li>
  </ol>
</div>`;

export const catalogHelp =
`<div>
  <h1> Catalog </h1>
  <p> SonicWall offers an online catalog where you can explore the available products.
      Navigate to <b> Product Management > Catalog </b> and use the fields at the top of the page to narrow your search.
      Enter the part number to go directly to a specific product. If you don't know the part number,
      select the <b> Product family </b> from the drop-down list, and then select the <b> Product name. </b> The applicable products are listed.
      Click the arrowhead next to the product name to expand the selection and see the options that are available.
  </p>
  <p> When you click to <b> +Add </b> a unit, it's added to the your cart for purchase. To complete the purchase or convert it to a quote,
      click on the <b> My Cart </b> icon, and select the appropriate options.
  </p>
</div>`;

export const freedownloadsHelp =
`<div>
  <h1> Free Downloads </h1>
  <p> Navigate to <b> Resource & Support > Free Downloads </b> to see the free SonicWall software, firmware,
      and documentation available for SonicWall products. Select a language and the product you're interested in.
      Free downloads are limited to the products available on the drop-down lists above the table.
  </p>
</div>`;

export const quotehistoryHelp =
`<div>
  <h1> My Quotes </h1>
  <p> The <b> My Quotes </b> page provides a table of all your active SonicWall quotes. Information listed here includes the quote ID,
      date of the quote, the description of what's being quoted, the expiration date for the quote, and the amount.
      You can use the icons above the table to filter, search or refresh the data. Click on the table headings to sort the data in
      ascending or descending order.
  </p>
  <p> To see more detail or edit the quote, click on the <b> QUOTE ID. </b> The full quote is shown and you can edit some of the fields.
      You can also print the quote from this page or begin the purchase process.
  </p>
  <p> <span style="font-style: italic; margin-right: .5rem"> <b> IMPORTANT: </b> </span> Items are not added to your shopping cart in the following situations: </p>
  <ul>
      <li> The device status has changed since the quote was created. </li>
      <li> You already have this item in your cart. </li>
      <li> You are not logged in. </li>
  </ul>
</div>`;

export const productClaimsHelp =
`<div>
  <h1> Product Claims </h1>
  <p> Navigate to <b> Reports > Product Claims </b> to display the <b> Product Claims </b> page.
      It lists all product claims associated with your account including claim status, product name, serial number, and date.
      You can filter, search, and export the data using the toolbar icons.
  </p>
</div>`;

export const managecasesHelp =
`<div>
  <h1> Support </h1>
  <p> Navigate to <b> Resource & Support > Support </b> to display the <b> Support </b> page. It provides a table of all your active support cases.
      Information listed here includes the case number, subject, date the case was opened, the product name, the serial number and the priority.
      You can use the icons above the table to filter, search, add a case, or refresh the data.
      Click on the table headings to sort the data in ascending or descending order.
  </p>

  <p> To see more detail or edit the quote, click on the <b> QUOTE ID. </b> The full quote is shown and you can edit some of the fields.
      You can also print the quote from this page or begin the purchase process.
  </p>
  <p> <span style="font-style: italic; margin-right: .5rem"> <b> To open a case: </b> </span> </p>
  <ol>
      <li> Click on the <b> Create Case </b> icon. </li>
      <li> Click on <b> SUBMIT A CASE. </b> </li>
      <li> Select a product from the drop-down list. </li>
      <li> Click <b> NEXT. </b> </li>
      <li> Provide the case details in the fields provided. </li>
      <li> Click <b> SUBMIT. </b> </li>
  </ol>
</div>`;
